var _e2 = function e(t, n) {
  return _e2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  }, _e2(t, n);
};
function t(t, n) {
  if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  function r() {
    this.constructor = t;
  }
  _e2(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
}
var _n2 = function n() {
  return _n2 = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    return e;
  }, _n2.apply(this, arguments);
};
function r(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  }
  return n;
}
function i(e, t, n, r) {
  return new (n || (n = Promise))(function (i, o) {
    function s(e) {
      try {
        c(r.next(e));
      } catch (e) {
        o(e);
      }
    }
    function a(e) {
      try {
        c(r.throw(e));
      } catch (e) {
        o(e);
      }
    }
    function c(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(s, a);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function o(e, t) {
  var n,
    r,
    i,
    o,
    s = {
      label: 0,
      sent: function sent() {
        if (1 & i[0]) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    };
  return o = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;
  function a(a) {
    return function (c) {
      return function (a) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, a[0] && (s = 0)), s;) try {
          if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;
          switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {
            case 0:
            case 1:
              i = a;
              break;
            case 4:
              return s.label++, {
                value: a[1],
                done: !1
              };
            case 5:
              s.label++, r = a[1], a = [0];
              continue;
            case 7:
              a = s.ops.pop(), s.trys.pop();
              continue;
            default:
              if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                s = 0;
                continue;
              }
              if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                s.label = a[1];
                break;
              }
              if (6 === a[0] && s.label < i[1]) {
                s.label = i[1], i = a;
                break;
              }
              if (i && s.label < i[2]) {
                s.label = i[2], s.ops.push(a);
                break;
              }
              i[2] && s.ops.pop(), s.trys.pop();
              continue;
          }
          a = t.call(e, s);
        } catch (e) {
          a = [6, e], r = 0;
        } finally {
          n = i = 0;
        }
        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, c]);
    };
  }
}
function s(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
    n = t && e[t],
    r = 0;
  if (n) return n.call(e);
  if (e && "number" == typeof e.length) return {
    next: function next() {
      return e && r >= e.length && (e = void 0), {
        value: e && e[r++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function a(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
    i,
    o = n.call(e),
    s = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) s.push(r.value);
  } catch (e) {
    i = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (i) throw i.error;
    }
  }
  return s;
}
function c(e, t, n) {
  if (n || 2 === arguments.length) for (var r, i = 0, o = t.length; i < o; i++) !r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var u,
  l = "4.9.3",
  h = function () {
    function e() {}
    return Object.defineProperty(e, "OS_VERSION", {
      get: function get() {
        return "undefined" != typeof navigator && navigator.userAgent ? navigator.userAgent.replace(/,/g, ".") : "noAgent";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e, "SDK_VERSION", {
      get: function get() {
        return l;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e, "SDK_MAJOR_VERSION", {
      get: function get() {
        return e.SDK_VERSION.split(".")[0];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e, "DEFAULT_MAX_UNREAD_COUNT_OF_SUPER_GROUP_CHANNEL", {
      get: function get() {
        return 100;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e, "INTERNAL_CALL", {
      get: function get() {
        return "ic";
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }();
!function (e) {
  e[e.STAT_LOG_NOT_ALLOWED = 400108] = "STAT_LOG_NOT_ALLOWED", e[e.NON_AUTHORIZED = 400108] = "NON_AUTHORIZED", e[e.INVALID_TOKEN = 400111] = "INVALID_TOKEN", e[e.NOT_FOUND_IN_DATABASE = 400201] = "NOT_FOUND_IN_DATABASE", e[e.SESSION_TOKEN_EXPIRED = 400302] = "SESSION_TOKEN_EXPIRED", e[e.SESSION_KEY_EXPIRED = 400309] = "SESSION_KEY_EXPIRED", e[e.SESSION_REVOKED = 400310] = "SESSION_REVOKED", e[e.STAT_UPLOAD_NOT_ALLOWED = 403200] = "STAT_UPLOAD_NOT_ALLOWED", e[e.INTERNAL_SERVER_ERROR = 500901] = "INTERNAL_SERVER_ERROR", e[e.RATE_LIMIT_EXCEEDED = 500910] = "RATE_LIMIT_EXCEEDED", e[e.UNKNOWN_SERVER_ERROR = 900200] = "UNKNOWN_SERVER_ERROR", e[e.DEBUG_MODE_REQUIRED = 7e5] = "DEBUG_MODE_REQUIRED", e[e.LOST_INSTANCE = 700100] = "LOST_INSTANCE", e[e.CONNECTION_RENEW = 700102] = "CONNECTION_RENEW", e[e.INVALID_CONNECTION_STATE_TRANSITION = 700200] = "INVALID_CONNECTION_STATE_TRANSITION", e[e.INVALID_COMMAND = 700700] = "INVALID_COMMAND", e[e.UNKNOWN_ERROR = 77e4] = "UNKNOWN_ERROR", e[e.INVALID_INITIALIZATION = 800100] = "INVALID_INITIALIZATION", e[e.CONNECTION_REQUIRED = 800101] = "CONNECTION_REQUIRED", e[e.CONNECTION_CANCELED = 800102] = "CONNECTION_CANCELED", e[e.INVALID_PARAMETER = 800110] = "INVALID_PARAMETER", e[e.NOT_SUPPORTED_ERROR = 800111] = "NOT_SUPPORTED_ERROR", e[e.NETWORK_ERROR = 800120] = "NETWORK_ERROR", e[e.NETWORK_ROUTING_ERROR = 800121] = "NETWORK_ROUTING_ERROR", e[e.MALFORMED_DATA = 800130] = "MALFORMED_DATA", e[e.MALFORMED_ERROR_DATA = 800140] = "MALFORMED_ERROR_DATA", e[e.WRONG_CHANNEL_TYPE = 800150] = "WRONG_CHANNEL_TYPE", e[e.MARK_AS_READ_RATE_LIMIT_EXCEEDED = 800160] = "MARK_AS_READ_RATE_LIMIT_EXCEEDED", e[e.QUERY_IN_PROGRESS = 800170] = "QUERY_IN_PROGRESS", e[e.ACK_TIMEOUT = 800180] = "ACK_TIMEOUT", e[e.LOGIN_TIMEOUT = 800190] = "LOGIN_TIMEOUT", e[e.WEBSOCKET_CONNECTION_CLOSED = 800200] = "WEBSOCKET_CONNECTION_CLOSED", e[e.WEBSOCKET_CONNECTION_FAILED = 800210] = "WEBSOCKET_CONNECTION_FAILED", e[e.REQUEST_FAILED = 800220] = "REQUEST_FAILED", e[e.FILE_UPLOAD_CANCEL_FAILED = 800230] = "FILE_UPLOAD_CANCEL_FAILED", e[e.REQUEST_CANCELED = 800240] = "REQUEST_CANCELED", e[e.REQUEST_DUPLICATED = 800250] = "REQUEST_DUPLICATED", e[e.FILE_SIZE_LIMIT_EXCEEDED = 800260] = "FILE_SIZE_LIMIT_EXCEEDED", e[e.SESSION_TOKEN_REQUEST_FAILED = 800500] = "SESSION_TOKEN_REQUEST_FAILED", e[e.SESSION_TOKEN_REFRESHED = 800501] = "SESSION_TOKEN_REFRESHED", e[e.SESSION_TOKEN_REFRESH_FAILED = 800502] = "SESSION_TOKEN_REFRESH_FAILED", e[e.COLLECTION_DISPOSED = 800600] = "COLLECTION_DISPOSED", e[e.DATABASE_ERROR = 800700] = "DATABASE_ERROR";
}(u || (u = {}));
var d,
  _,
  f,
  p,
  g,
  v = function v(e) {
    return !(e instanceof E && !e.shouldThrowOutside);
  },
  E = function (e) {
    function n(t) {
      var r = t.code,
        i = void 0 === r ? 0 : r,
        o = t.message,
        s = void 0 === o ? "" : o,
        a = e.call(this, s) || this;
      return a.shouldThrowOutside = !1, a.name = "SendbirdError", a.code = i, Object.setPrototypeOf(a, n.prototype), a;
    }
    return t(n, e), Object.defineProperty(n.prototype, "isInvalidTokenError", {
      get: function get() {
        return this.code === u.INVALID_TOKEN;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "isSessionTokenExpiredError", {
      get: function get() {
        return this.code === u.SESSION_TOKEN_EXPIRED;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "isSessionKeyExpiredError", {
      get: function get() {
        return this.code === u.SESSION_KEY_EXPIRED;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "isSessionRevokedError", {
      get: function get() {
        return this.code === u.SESSION_REVOKED;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "debugModeRequired", {
      get: function get() {
        return new n({
          code: u.DEBUG_MODE_REQUIRED,
          message: "Cannot run this operation in production mode."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "lostInstance", {
      get: function get() {
        return new n({
          code: u.LOST_INSTANCE,
          message: "Instance ID is missing. It should belong to an instance."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "invalidCommand", {
      get: function get() {
        return new n({
          code: u.INVALID_COMMAND,
          message: "Cannot send invalid command."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "unknown", {
      get: function get() {
        return new n({
          code: u.UNKNOWN_ERROR,
          message: "Unknown error occurred."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "connectionRenew", {
      get: function get() {
        return new n({
          code: u.CONNECTION_RENEW,
          message: "Connection restarts."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "invalidConnectionStateTransition", {
      get: function get() {
        return new n({
          code: u.INVALID_CONNECTION_STATE_TRANSITION,
          message: "Invalid connection state transition."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "connectionRequired", {
      get: function get() {
        return new n({
          code: u.CONNECTION_REQUIRED,
          message: "Connection is required."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "connectionCanceled", {
      get: function get() {
        return new n({
          code: u.CONNECTION_CANCELED,
          message: "Connection is canceled."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "invalidParameters", {
      get: function get() {
        return new n({
          code: u.INVALID_PARAMETER,
          message: "Invalid parameters."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "notSupportedError", {
      get: function get() {
        return new n({
          code: u.NOT_SUPPORTED_ERROR,
          message: "Given parameters are not supported."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "networkError", {
      get: function get() {
        return new n({
          code: u.NETWORK_ERROR,
          message: "There was a network error."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "markAsReadAllRateLimitExceeded", {
      get: function get() {
        return new n({
          code: u.MARK_AS_READ_RATE_LIMIT_EXCEEDED,
          message: "markAsRead rate limit exceeded."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "queryInProgress", {
      get: function get() {
        return new n({
          code: u.QUERY_IN_PROGRESS,
          message: "Query in progress."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "noAckTimeout", {
      get: function get() {
        return new n({
          code: u.ACK_TIMEOUT,
          message: "Command received no ack."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "loginTimeout", {
      get: function get() {
        return new n({
          code: u.LOGIN_TIMEOUT,
          message: "Connection timeout."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "connectionClosed", {
      get: function get() {
        return new n({
          code: u.WEBSOCKET_CONNECTION_CLOSED,
          message: "Connection is closed. Please reconnect."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "requestFailed", {
      get: function get() {
        return new n({
          code: u.REQUEST_FAILED,
          message: "Request failed."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "fileUploadCanceled", {
      get: function get() {
        return new n({
          code: u.FILE_UPLOAD_CANCEL_FAILED,
          message: "File upload has been canceled."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "requestCanceled", {
      get: function get() {
        return new n({
          code: u.REQUEST_CANCELED,
          message: "Request has been canceled."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "sessionTokenRefreshFailed", {
      get: function get() {
        return new n({
          code: u.SESSION_TOKEN_REFRESH_FAILED,
          message: "Failed to refresh the session key."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "sessionTokenRequestFailed", {
      get: function get() {
        return new n({
          code: u.SESSION_TOKEN_REQUEST_FAILED,
          message: "Failed to get the session token."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "databaseError", {
      get: function get() {
        return new n({
          code: u.DATABASE_ERROR,
          message: "Database error."
        });
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n, "fileSizeLimitExceededError", {
      get: function get() {
        return new n({
          code: u.FILE_SIZE_LIMIT_EXCEEDED,
          message: "File size exceeds the file size limit."
        });
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.throwOutside = function () {
      throw this.shouldThrowOutside = !0, this;
    }, n;
  }(Error),
  b = [u.CONNECTION_REQUIRED, u.NETWORK_ERROR, u.ACK_TIMEOUT, u.WEBSOCKET_CONNECTION_CLOSED, u.WEBSOCKET_CONNECTION_FAILED, u.FILE_UPLOAD_CANCEL_FAILED, u.REQUEST_CANCELED, u.INTERNAL_SERVER_ERROR, u.RATE_LIMIT_EXCEEDED, u.UNKNOWN_SERVER_ERROR],
  m = [u.WEBSOCKET_CONNECTION_CLOSED, u.WEBSOCKET_CONNECTION_FAILED, u.CONNECTION_REQUIRED],
  y = function y(e, t) {
    if (e !== t) {
      var r = _n2({}, e),
        i = _n2({}, t);
      return (!r.hasOwnProperty("messageId") || !i.hasOwnProperty("messageId") || r.messageId === i.messageId) && (!r.hasOwnProperty("reqId") || !i.hasOwnProperty("reqId") || r.reqId === i.reqId) && (r.hasOwnProperty("messageId") && delete r.messageId, r.hasOwnProperty("reqId") && delete r.reqId, i.hasOwnProperty("messageId") && delete i.messageId, i.hasOwnProperty("reqId") && delete i.reqId, JSON.stringify(r) === JSON.stringify(i));
    }
    return !0;
  },
  w = function w(e, t, n) {
    return void 0 === n && (n = !1), !(!n || null != t) || ("string" != typeof e ? "object" == typeof e ? S(e, t) : k(e, t) : typeof t === e);
  },
  S = function S(e, t, n) {
    return void 0 === n && (n = !1), !(!n || null != t) || Object.values(e).includes(t);
  },
  k = function k(e, t) {
    return t instanceof e;
  },
  T = function T(e, t, n) {
    return void 0 === n && (n = !1), !(!n || null != t) || Array.isArray(t) && t.every(function (t) {
      return w(e, t);
    });
  },
  C = function C(e) {
    return e > 0 && b.indexOf(e) >= 0;
  },
  O = function O(e) {
    return e > 0 && m.indexOf(e) >= 0;
  },
  A = function A(e, t) {
    if (void 0 === t && (t = !1), t && null == e) return !0;
    var n = "object" == typeof e && null !== e && e.hasOwnProperty("name") && "string" == typeof e.name && e.hasOwnProperty("uri") && "string" == typeof e.uri && e.hasOwnProperty("type") && "string" == typeof e.type;
    if (!n) {
      if ("undefined" != typeof Blob) return e instanceof Blob;
      if ("undefined" != typeof File) return e instanceof File;
    }
    return n;
  },
  N = function N(e, t) {
    if (e === t) return !0;
    if (null == e || null == t) return !1;
    if (e.length !== t.length) return !1;
    for (var n = c([], a(e), !1).sort(), r = c([], a(t), !1).sort(), i = 0; i < n.length; ++i) if (n[i] !== r[i]) return !1;
    return !0;
  },
  R = function () {
    function e(e) {
      var t = void 0 === e ? {} : e,
        n = t.useMemberInfoInMessage,
        r = void 0 === n || n,
        i = t.typingIndicatorInvalidateTime,
        o = void 0 === i ? 1e4 : i,
        s = t.typingIndicatorThrottle,
        a = void 0 === s ? 1e3 : s,
        c = t.websocketResponseTimeout,
        u = void 0 === c ? 1e4 : c,
        l = t.websocketPayloadDecompression,
        h = void 0 === l || l,
        d = t.sessionTokenRefreshTimeout,
        _ = void 0 === d ? 60 : d;
      this._useMemberInfoInMessage = !0, this._typingIndicatorInvalidateTime = 1e4, this._typingIndicatorThrottle = 1e3, this._websocketResponseTimeout = 1e4, this._sessionTokenRefreshTimeout = 60, this._useMemberInfoInMessage = r, this._typingIndicatorInvalidateTime = o, this._typingIndicatorThrottle = a, this._websocketResponseTimeout = u, this._sessionTokenRefreshTimeout = _, this.websocketPayloadDecompression = h;
    }
    return Object.defineProperty(e.prototype, "useMemberInfoInMessage", {
      get: function get() {
        return this._useMemberInfoInMessage;
      },
      set: function set(e) {
        w("boolean", e) && (this._useMemberInfoInMessage = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "typingIndicatorInvalidateTime", {
      get: function get() {
        return this._typingIndicatorInvalidateTime;
      },
      set: function set(e) {
        w("number", e) && (this._typingIndicatorInvalidateTime = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "typingIndicatorThrottle", {
      get: function get() {
        return this._typingIndicatorThrottle;
      },
      set: function set(e) {
        w("number", e) && e >= 1e3 && e <= 9e3 && (this._typingIndicatorThrottle = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "websocketResponseTimeout", {
      get: function get() {
        return this._websocketResponseTimeout;
      },
      set: function set(e) {
        w("number", e) && e >= 5e3 && e <= 3e4 && (this._websocketResponseTimeout = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "sessionTokenRefreshTimeout", {
      get: function get() {
        return this._sessionTokenRefreshTimeout;
      },
      set: function set(e) {
        w("number", e) && (e < 60 ? e = 60 : e > 1800 && (e = 1800), this._sessionTokenRefreshTimeout = e);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(),
  I = {
    encrypt: function encrypt(e) {
      return e;
    },
    decrypt: function decrypt(e) {
      return e;
    }
  },
  D = function () {
    function e(e) {
      var t = e.store;
      this._preference = new Map(), this._store = t;
    }
    return e.prototype._savePreferenceKeys = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this._store.set({
                key: this._keysAddress,
                value: c([], a(this._preference.keys()), !1)
              })];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, e.prototype.init = function (e, t) {
      var n;
      return void 0 === t && (t = 1), i(this, void 0, void 0, function () {
        var r, i, a, c, u, l, h, d, _, f;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return this._version = t, this._keysAddress = e, r = "".concat(e, ".metadata.version"), [4, this._store.get(r)];
            case 1:
              return i = o.sent(), [4, this._store.get(e)];
            case 2:
              return a = null !== (n = o.sent()) && void 0 !== n ? n : [], !i || i.version < this._version ? [4, this._resetPreferenceData(a, r)] : [3, 4];
            case 3:
              return o.sent(), [3, 11];
            case 4:
              o.trys.push([4, 9, 10, 11]), c = s(a), u = c.next(), o.label = 5;
            case 5:
              return u.done ? [3, 8] : (l = u.value, [4, this._store.get(l)]);
            case 6:
              (h = o.sent()) && this._preference.set(l, h), o.label = 7;
            case 7:
              return u = c.next(), [3, 5];
            case 8:
              return [3, 11];
            case 9:
              return d = o.sent(), _ = {
                error: d
              }, [3, 11];
            case 10:
              try {
                u && !u.done && (f = c.return) && f.call(c);
              } finally {
                if (_) throw _.error;
              }
              return [7];
            case 11:
              return [2];
          }
        });
      });
    }, e.prototype._resetPreferenceData = function (e, t) {
      return i(this, void 0, void 0, function () {
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return this._preference = new Map(), [4, this._store.removeMany(e)];
            case 1:
              return n.sent(), [4, this._store.set({
                key: t,
                value: {
                  version: this._version
                }
              })];
            case 2:
              return n.sent(), [2];
          }
        });
      });
    }, e.prototype.get = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          return [2, this._preference.get(e)];
        });
      });
    }, e.prototype.set = function (e, t) {
      return i(this, void 0, void 0, function () {
        var n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return n = !this._preference.has(e), [4, this._store.set({
                key: e,
                value: t
              })];
            case 1:
              return r.sent(), this._preference.set(e, t), n ? [4, this._savePreferenceKeys()] : [3, 3];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [2];
          }
        });
      });
    }, e.prototype.remove = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._store.remove(e)];
            case 1:
              return t.sent(), this._preference.delete(e), [4, this._savePreferenceKeys()];
            case 2:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.clear = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this._store.removeMany(c([], a(this._preference.keys()), !1))];
            case 1:
              return e.sent(), this._preference.clear(), [4, this._savePreferenceKeys()];
            case 2:
              return e.sent(), [2];
          }
        });
      });
    }, e;
  }(),
  L = function () {
    function e(e) {
      var t = e.encryption,
        n = e.store,
        r = e.localCacheEnabled,
        i = e.localCacheConfig;
      this.store = n, this.preference = new D({
        store: n
      }), this.encryption = null != t ? t : I, this.localCacheEnabled = r, this.localCacheConfig = i;
    }
    return e.prototype.replaceStore = function (e) {
      this.store = e, this.preference = new D({
        store: e
      });
    }, e;
  }();
!function (e) {
  e.SUCCESS = "success", e.PENDING = "pending", e.ERROR = "error";
}(d || (d = {})), function (e) {
  e.DEFAULT = "default", e.ALL = "all", e.MENTION_ONLY = "mention_only", e.OFF = "off";
}(_ || (_ = {})), function (e) {
  e.FCM = "gcm", e.APNS = "apns", e.UNKNOWN = "unknown";
}(f || (f = {})), function (e) {
  e.ALTERNATIVE = "alternative", e.DEFAULT = "default";
}(p || (p = {})), function (e) {
  e.CUSTOM = "custom", e.MESSAGE_COLLECTION_ACCESSED_AT = "messagecollection_accessed_at";
}(g || (g = {}));
var x,
  M,
  P,
  U,
  z,
  F,
  q,
  G,
  j,
  K = function () {
    function e(e) {
      var t = e.channel,
        n = e.cachedMessageCount;
      this._cachedMessageCount = 0, this._channel = t, this._cachedMessageCount = n;
    }
    return Object.defineProperty(e.prototype, "channel", {
      get: function get() {
        return this._channel;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "cachedMessageCount", {
      get: function get() {
        return this._cachedMessageCount;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(),
  B = function () {
    function e(e) {
      var t = void 0 === e ? {} : e,
        n = t.maxSize,
        r = void 0 === n ? 256 : n,
        i = t.clearOrder,
        o = void 0 === i ? g.MESSAGE_COLLECTION_ACCESSED_AT : i,
        s = t.customClearOrderComparator;
      this._clearOrderComparatorUseMessageCollectionAccessedAt = function (e, t) {
        return e.channel.messageCollectionLastAccessedAt === t.channel.messageCollectionLastAccessedAt ? e.channel.lastMessage && !t.channel.lastMessage ? 1 : !e.channel.lastMessage && t.channel.lastMessage ? -1 : e.channel.lastMessage || t.channel.lastMessage ? e.channel.lastMessage.createdAt - t.channel.lastMessage.createdAt : 0 : e.channel.messageCollectionLastAccessedAt > t.channel.messageCollectionLastAccessedAt ? 1 : -1;
      }, this._maxSize = Math.max(r, 64), s ? (this._clearOrder = o, this._customClearOrderComparator = s) : this._clearOrder = g.MESSAGE_COLLECTION_ACCESSED_AT;
    }
    return Object.defineProperty(e.prototype, "maxSize", {
      get: function get() {
        return this._maxSize;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "clearOrder", {
      get: function get() {
        return this._clearOrder;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "clearOrderComparator", {
      get: function get() {
        var e;
        return this._clearOrder === g.MESSAGE_COLLECTION_ACCESSED_AT ? this._clearOrderComparatorUseMessageCollectionAccessedAt : null !== (e = this._customClearOrderComparator) && void 0 !== e ? e : this._clearOrderComparatorUseMessageCollectionAccessedAt;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(),
  V = function () {
    function e() {}
    return Object.defineProperty(e.prototype, "hasSession", {
      get: function get() {
        return !!this.sessionKey;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.clear = function () {
      this.authToken = void 0, this.sessionKey = void 0;
    }, e;
  }(),
  Z = function Z() {
    var e = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
      var n = (e + 16 * Math.random()) % 16 | 0;
      return e = Math.floor(e / 16), ("x" === t ? n : 3 & n | 8).toString(16);
    });
  },
  H = function () {
    function e(e) {
      var t = e.container;
      this._container = {}, this._container = t, this.key = Z();
    }
    return e.prototype._register = function (e, t, n) {
      var r;
      return e in this._container || (this._container[e] = new Map()), null === (r = this._container[e]) || void 0 === r || r.set(this.key, {
        occurence: t,
        handler: n
      }), this;
    }, e.prototype.on = function (e, t) {
      return this._register(e, -1, t);
    }, e.prototype.once = function (e, t) {
      return this._register(e, 1, t);
    }, e.prototype.close = function () {
      var e;
      for (var t in this._container) null === (e = this._container[t]) || void 0 === e || e.delete(this.key);
    }, e;
  }(),
  W = function () {
    function e() {
      this._container = {};
    }
    return e.prototype.on = function (e, t) {
      return new H({
        container: this._container
      }).on(e, t);
    }, e.prototype.once = function (e, t) {
      return new H({
        container: this._container
      }).once(e, t);
    }, e.prototype.dispatch = function (e, t) {
      var n,
        r,
        i = this._container[e];
      if (i) {
        var o = [];
        try {
          for (var a = s(i.keys()), c = a.next(); !c.done; c = a.next()) {
            var u = c.value,
              l = i.get(u);
            l.handler(t), l.occurence > 0 && (l.occurence--, 0 === l.occurence && o.push(u));
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            c && !c.done && (r = a.return) && r.call(a);
          } finally {
            if (n) throw n.error;
          }
        }
        o.forEach(function (e) {
          return i.delete(e);
        });
      }
    }, e;
  }(),
  Q = function () {
    function e() {
      this._dispatcher = new W();
    }
    return e.prototype.on = function (e) {
      return this._dispatcher.on("event", e);
    }, e.prototype.once = function (e) {
      return this._dispatcher.once("event", e);
    }, e.prototype.dispatch = function (e) {
      this._dispatcher.dispatch("event", e);
    }, e;
  }(),
  Y = function Y() {},
  X = function X(e) {
    var t = {};
    return e && Object.keys(e).forEach(function (n) {
      void 0 === e[n] || Number.isNaN(e[n]) || null === e[n] || (t[n] = e[n]);
    }), t;
  },
  J = function J(e) {
    if (null != e) {
      if ("object" == typeof e) {
        if (Array.isArray(e)) {
          var t = c([], a(e), !1);
          for (var n in t) t[n] = J(t[n]);
          return t;
        }
        for (var r in e) null === e[r] && delete e[r];
        return e;
      }
      return e;
    }
  };
!function (e) {
  e.BASE = "base", e.GROUP = "group", e.OPEN = "open";
}(x || (x = {})), function (e) {
  e.OPERATOR = "operator", e.NONE = "none";
}(M || (M = {})), function (e) {
  e.BASE = "base", e.USER = "user", e.FILE = "file", e.ADMIN = "admin";
}(P || (P = {})), function (e) {
  e.ALL = "", e.USER = "MESG", e.FILE = "FILE", e.ADMIN = "ADMM";
}(U || (U = {})), function (e) {
  e.USER = "MESG", e.FILE = "FILE", e.ADMIN = "ADMM";
}(z || (z = {})), function (e) {
  e.USERS = "users", e.CHANNEL = "channel";
}(F || (F = {})), function (e) {
  e.ALL = "all", e.NONE = "none", e.ONLY_REPLY_TO_CHANNEL = "only_reply_to_channel";
}(q || (q = {})), function (e) {
  e.DEFAULT = "default", e.SUPPRESS = "suppress";
}(G || (G = {})), function (e) {
  e.PENDING = "pending", e.SCHEDULED = "scheduled", e.SUCCEEDED = "succeeded", e.FAILED = "failed", e.CANCELED = "canceled";
}(j || (j = {}));
var $,
  ee = "v3",
  te = "/".concat(ee, "/users"),
  ne = "/".concat(ee, "/storage/file"),
  re = "/".concat(ee, "/group_channels"),
  ie = "/".concat(ee, "/sdk/group_channels"),
  oe = "/".concat(ee, "/open_channels"),
  se = "/".concat(ee, "/sdk/open_channels"),
  ae = "/".concat(ee, "/search"),
  ce = "/".concat(ee, "/report"),
  ue = "/".concat(ee, "/emojis"),
  le = "/".concat(ee, "/emoji_categories"),
  he = "/".concat(ee, "/polls"),
  de = "/".concat(ee, "/scheduled_messages"),
  _e = "/".concat(ee, "/sdk/ui_kit/configuration"),
  fe = "/".concat(ee, "/sdk/statistics"),
  pe = function pe(e) {
    switch (e) {
      case x.GROUP:
        return re;
      case x.OPEN:
        return oe;
      default:
        return null;
    }
  },
  ge = function ge(e) {
    switch (e) {
      case x.GROUP:
        return "".concat(ce, "/group_channels");
      case x.OPEN:
        return "".concat(ce, "/open_channels");
      default:
        return null;
    }
  },
  ve = function ve(e, t, n) {
    var r, i;
    switch (e) {
      case F.CHANNEL:
        return !0;
      case F.USERS:
        if (t) try {
          for (var o = s(t), a = o.next(); !a.done; a = o.next()) {
            if (a.value === n) return !0;
          }
        } catch (e) {
          r = {
            error: e
          };
        } finally {
          try {
            a && !a.done && (i = o.return) && i.call(o);
          } finally {
            if (r) throw r.error;
          }
        }
    }
    return !1;
  },
  Ee = function Ee(e, t, n) {
    var r,
      i,
      o,
      s,
      a = ve(null !== (r = e.mentionType) && void 0 !== r ? r : null, null !== (i = e.mentionedUserIds) && void 0 !== i ? i : [], n),
      c = ve(null !== (o = t.mentionType) && void 0 !== o ? o : null, null !== (s = t.mentionedUserIds) && void 0 !== s ? s : [], n);
    return !a && c ? 1 : a && !c ? -1 : 0;
  },
  be = function be(e, t, n) {
    var r,
      i = t || new FormData();
    for (var o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
      var s = e[o],
        a = n ? "".concat(n, "[").concat(o, "]") : o;
      A(s) ? i.append(a, s, null !== (r = s.name) && void 0 !== r ? r : "filename") : "object" != typeof s || null === s || Array.isArray(s) || s instanceof Blob ? i.append(a, String(s)) : i = be(s, i, a);
    }
    return i;
  };
!function (e) {
  e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.DELETE = "DELETE";
}($ || ($ = {}));
var me,
  ye = function (e) {
    function n() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.params = {}, t.requireAuth = !0, t.headers = {}, t.requestId = Z(), t;
    }
    return t(n, e), n.prototype.encodeParams = function (e) {
      var t = this;
      return null == e || "" === e ? encodeURIComponent("") : Array.isArray(e) ? e.map(function (e) {
        return t.encodeParams(e);
      }).join(",") : "object" == typeof e ? encodeURIComponent(JSON.stringify(e)) : encodeURIComponent(String(e));
    }, Object.defineProperty(n.prototype, "query", {
      get: function get() {
        var e = this,
          t = X(this.params);
        return "?".concat(Object.keys(t).map(function (n) {
          return "".concat(encodeURIComponent(n), "=").concat(e.encodeParams(t[n]));
        }).join("&"));
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "payload", {
      get: function get() {
        var e = X(this.params);
        return Object.keys(e).some(function (t) {
          return A(e[t]);
        }) ? be(e) : JSON.stringify(e);
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(Y),
  we = function (e) {
    function r(t, n) {
      var r = e.call(this) || this;
      return r._iid = t, r._payload = n, r;
    }
    return t(r, e), Object.defineProperty(r.prototype, "payload", {
      get: function get() {
        return _n2({}, this._payload);
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.as = function (e) {
      return new e(this._iid, this.payload);
    }, r;
  }(Y),
  Se = function (e) {
    function n(t) {
      var n = e.call(this) || this;
      return n.requestId = t, n;
    }
    return t(n, e), n;
  }(Y),
  ke = function (e) {
    function n(t) {
      var n = t.expires_in,
        r = t.reason,
        i = void 0 === r ? u.SESSION_KEY_EXPIRED : r,
        o = e.call(this) || this;
      switch (o.expiresIn = null != n ? n : 0, i) {
        case u.SESSION_KEY_EXPIRED:
        case u.SESSION_TOKEN_EXPIRED:
        case u.SESSION_REVOKED:
          o.error = new E({
            code: i
          });
      }
      return o;
    }
    return t(n, e), Object.defineProperty(n.prototype, "invalidateSessionToken", {
      get: function get() {
        var e;
        return !!(null === (e = this.error) || void 0 === e ? void 0 : e.isSessionTokenExpiredError);
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(Y),
  Te = function (e) {
    function n(t) {
      var n = e.call(this) || this;
      return n.statLog = t, n;
    }
    return t(n, e), n;
  }(Y);
!function (e) {
  e.FEATURE_LOCALCACHE = "feature:local_cache", e.WEBSOCKET_CONNECT = "ws:connect", e.API_RESULT = "api:result";
}(me || (me = {}));
var Ce = function () {
    function e(e) {
      var t = e.type,
        n = e.data,
        r = e.ts,
        i = void 0 === r ? Date.now() : r;
      this.type = t, this.createdAt = i, this.data = n;
    }
    return e.payloadify = function (e) {
      return X({
        stat_type: e.type,
        ts: e.createdAt,
        data: X(e.data)
      });
    }, e;
  }(),
  Oe = function Oe() {
    return "undefined" == typeof document && "undefined" != typeof navigator && "ReactNative" == navigator.product;
  },
  Ae = function () {
    function e(e, t) {
      var n = t.auth,
        r = t.sdkState,
        i = t.dispatcher,
        o = t.logger,
        s = t.useFetchCompat,
        a = void 0 !== s && s,
        c = this;
      this._abortControl = new Map(), this._shouldImportFetchCompat = !1, this._iid = e, this._auth = n, this._sdkState = r, this._dispatcher = i, this._dispatcher.on(function (e) {
        e instanceof Se && c.cancel(e.requestId);
      }), this._logger = o, this._shouldImportFetchCompat = a;
    }
    return Object.defineProperty(e.prototype, "_userAgentWithExtension", {
      get: function get() {
        var e = this._sdkState.extensions,
          t = Oe() ? "reactnative" : "JS",
          n = "//";
        if (e) {
          var r = e.sb_syncmanager ? "s".concat(e.sb_syncmanager) : "",
            i = e.sb_uikit ? "u".concat(e.sb_uikit) : "",
            o = e["device-os-platform"] ? "o".concat(e["device-os-platform"]) : "";
          n = "".concat(r, "/").concat(i, "/").concat(o);
        }
        return "".concat(t, "/c").concat(h.SDK_VERSION, "/").concat(n);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._createHeader = function (e, t) {
      var r = this._sdkState,
        i = r.appId,
        o = r.appVersion,
        s = _n2(_n2({}, e.headers), {
          SendBird: "JS,".concat(h.OS_VERSION, ",").concat(h.SDK_VERSION, ",").concat(i).concat(o ? ",".concat(o) : ""),
          "SB-User-Agent": encodeURIComponent(this._userAgentWithExtension),
          "Request-Sent-Timestamp": Date.now().toString()
        });
      return t || (s["Content-Type"] = "application/json; charset=utf-8"), e.requireAuth && this._auth.hasSession && (s["Session-Key"] = this._auth.sessionKey), this._auth && this._auth.authToken && (s["App-Id"] = i, s["Access-Token"] = this._auth.authToken), s;
    }, e.prototype._statLogApiResult = function (e, t, n) {
      this._dispatcher.dispatch(new Te(new Ce({
        type: me.API_RESULT,
        data: {
          endpoint: e.path,
          method: e.method,
          success: !n,
          latency: Date.now() - t,
          error_code: null == n ? void 0 : n.code,
          error_description: null == n ? void 0 : n.message
        }
      })));
    }, e.prototype.send = function (e) {
      return i(this, void 0, void 0, function () {
        var t, n, r, i, s, a, c, u, l, h, d, _, f, p, g;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              t = e.path, n = e.method, r = ![$.GET, $.DELETE].includes(n), i = this._sdkState.api, s = "".concat(i.host).concat(t).concat(r ? "" : e.query), a = r ? e.payload : null, c = this._createHeader(e, a instanceof FormData ? a : void 0), u = new AbortController(), l = u.signal, this._abortControl.set(e.requestId, u), h = Date.now(), o.label = 1;
            case 1:
              return o.trys.push([1, 8,, 9]), this._shouldImportFetchCompat && (this._shouldImportFetchCompat = !1, ("undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || "undefined" != typeof global && global || {
                fetch: null
              }).fetch = null), "undefined" != typeof AbortController ? [3, 3] : [4, import("./__bundle-2aa1a987.js")];
            case 2:
              o.sent(), o.label = 3;
            case 3:
              return "function" == typeof fetch ? [3, 5] : [4, import("./__bundle-57274663.js")];
            case 4:
              o.sent(), o.label = 5;
            case 5:
              return [4, fetch(s, {
                method: n,
                body: a,
                headers: c,
                signal: l
              })];
            case 6:
              return [4, (d = o.sent()).json()];
            case 7:
              if (_ = o.sent(), d.ok || d.redirected) return this._logger.debug("receive api response", e.requestId), this._statLogApiResult(e, h), [2, new we(this._iid, _)];
              throw _ ? (((f = new E(_)).isSessionKeyExpiredError || f.isSessionTokenExpiredError) && this._dispatcher.dispatch(new ke({
                reason: f.code
              })), this._statLogApiResult(e, h, f), f) : (f = E.requestFailed, this._statLogApiResult(e, h, f), f);
            case 8:
              throw p = o.sent(), this._statLogApiResult(e, h, p), p instanceof E ? (this._logger.debug("fail api request", p), p) : "AbortError" === p.name ? E.requestCanceled : (g = E.networkError, this._logger.debug("fail api request", g), g);
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.cancel = function (e) {
      this._abortControl.has(e) && (this._abortControl.get(e).abort(), this._abortControl.delete(e));
    }, e.prototype.cancelAll = function () {
      var e, t;
      try {
        for (var n = s(this._abortControl.values()), r = n.next(); !r.done; r = n.next()) {
          r.value.abort();
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          r && !r.done && (t = n.return) && t.call(n);
        } finally {
          if (e) throw e.error;
        }
      }
      this._abortControl.clear();
    }, e;
  }(),
  Ne = function (e) {
    function n(t, n, r, i) {
      void 0 === i && (i = "");
      var o,
        s = this;
      return (s = e.call(this) || this)._iid = t, s.code = n, s.payload = r, s.requestId = null !== (o = r.req_id) && void 0 !== o ? o : i, s;
    }
    return t(n, e), n.createFromRawMessage = function (e, t) {
      var r = t.substring(0, 4),
        i = {};
      try {
        i = JSON.parse(t.substring(4));
      } catch (e) {
        r = "NOOP";
      } finally {
        return new n(e, r, i);
      }
    }, n.prototype.convertToMessage = function () {
      return "".concat(this.code).concat(JSON.stringify(this.payload), "\n");
    }, n.prototype.as = function (e) {
      return new e(this._iid, this.code, this.payload);
    }, n;
  }(Y),
  Re = function Re() {};
function Ie(e) {
  var t = e.length;
  for (; --t >= 0;) e[t] = 0;
}
var De = 256,
  Le = 286,
  xe = 30,
  Me = 15,
  Pe = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]),
  Ue = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]),
  ze = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]),
  Fe = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
  qe = new Array(576);
Ie(qe);
var Ge = new Array(60);
Ie(Ge);
var je = new Array(512);
Ie(je);
var Ke = new Array(256);
Ie(Ke);
var Be = new Array(29);
Ie(Be);
var Ve = new Array(xe);
function Ze(e, t, n, r, i) {
  this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
}
var He, We, Qe;
function Ye(e, t) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
Ie(Ve);
var Xe = function Xe(e) {
    return e < 256 ? je[e] : je[256 + (e >>> 7)];
  },
  Je = function Je(e, t) {
    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
  },
  $e = function $e(e, t, n) {
    e.bi_valid > 16 - n ? (e.bi_buf |= t << e.bi_valid & 65535, Je(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += n - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
  },
  et = function et(e, t, n) {
    $e(e, n[2 * t], n[2 * t + 1]);
  },
  tt = function tt(e, t) {
    var n = 0;
    do {
      n |= 1 & e, e >>>= 1, n <<= 1;
    } while (--t > 0);
    return n >>> 1;
  },
  nt = function nt(e, t, n) {
    var r = new Array(16);
    var i,
      o,
      s = 0;
    for (i = 1; i <= Me; i++) s = s + n[i - 1] << 1, r[i] = s;
    for (o = 0; o <= t; o++) {
      var _t2 = e[2 * o + 1];
      0 !== _t2 && (e[2 * o] = tt(r[_t2]++, _t2));
    }
  },
  rt = function rt(e) {
    var t;
    for (t = 0; t < Le; t++) e.dyn_ltree[2 * t] = 0;
    for (t = 0; t < xe; t++) e.dyn_dtree[2 * t] = 0;
    for (t = 0; t < 19; t++) e.bl_tree[2 * t] = 0;
    e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
  },
  it = function it(e) {
    e.bi_valid > 8 ? Je(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
  },
  ot = function ot(e, t, n, r) {
    var i = 2 * t,
      o = 2 * n;
    return e[i] < e[o] || e[i] === e[o] && r[t] <= r[n];
  },
  st = function st(e, t, n) {
    var r = e.heap[n];
    var i = n << 1;
    for (; i <= e.heap_len && (i < e.heap_len && ot(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !ot(t, r, e.heap[i], e.depth));) e.heap[n] = e.heap[i], n = i, i <<= 1;
    e.heap[n] = r;
  },
  at = function at(e, t, n) {
    var r,
      i,
      o,
      s,
      a = 0;
    if (0 !== e.sym_next) do {
      r = 255 & e.pending_buf[e.sym_buf + a++], r += (255 & e.pending_buf[e.sym_buf + a++]) << 8, i = e.pending_buf[e.sym_buf + a++], 0 === r ? et(e, i, t) : (o = Ke[i], et(e, o + De + 1, t), s = Pe[o], 0 !== s && (i -= Be[o], $e(e, i, s)), r--, o = Xe(r), et(e, o, n), s = Ue[o], 0 !== s && (r -= Ve[o], $e(e, r, s)));
    } while (a < e.sym_next);
    et(e, 256, t);
  },
  ct = function ct(e, t) {
    var n = t.dyn_tree,
      r = t.stat_desc.static_tree,
      i = t.stat_desc.has_stree,
      o = t.stat_desc.elems;
    var s,
      a,
      c,
      u = -1;
    for (e.heap_len = 0, e.heap_max = 573, s = 0; s < o; s++) 0 !== n[2 * s] ? (e.heap[++e.heap_len] = u = s, e.depth[s] = 0) : n[2 * s + 1] = 0;
    for (; e.heap_len < 2;) c = e.heap[++e.heap_len] = u < 2 ? ++u : 0, n[2 * c] = 1, e.depth[c] = 0, e.opt_len--, i && (e.static_len -= r[2 * c + 1]);
    for (t.max_code = u, s = e.heap_len >> 1; s >= 1; s--) st(e, n, s);
    c = o;
    do {
      s = e.heap[1], e.heap[1] = e.heap[e.heap_len--], st(e, n, 1), a = e.heap[1], e.heap[--e.heap_max] = s, e.heap[--e.heap_max] = a, n[2 * c] = n[2 * s] + n[2 * a], e.depth[c] = (e.depth[s] >= e.depth[a] ? e.depth[s] : e.depth[a]) + 1, n[2 * s + 1] = n[2 * a + 1] = c, e.heap[1] = c++, st(e, n, 1);
    } while (e.heap_len >= 2);
    e.heap[--e.heap_max] = e.heap[1], function (e, t) {
      var n = t.dyn_tree,
        r = t.max_code,
        i = t.stat_desc.static_tree,
        o = t.stat_desc.has_stree,
        s = t.stat_desc.extra_bits,
        a = t.stat_desc.extra_base,
        c = t.stat_desc.max_length;
      var u,
        l,
        h,
        d,
        _,
        f,
        p = 0;
      for (d = 0; d <= Me; d++) e.bl_count[d] = 0;
      for (n[2 * e.heap[e.heap_max] + 1] = 0, u = e.heap_max + 1; u < 573; u++) l = e.heap[u], d = n[2 * n[2 * l + 1] + 1] + 1, d > c && (d = c, p++), n[2 * l + 1] = d, l > r || (e.bl_count[d]++, _ = 0, l >= a && (_ = s[l - a]), f = n[2 * l], e.opt_len += f * (d + _), o && (e.static_len += f * (i[2 * l + 1] + _)));
      if (0 !== p) {
        do {
          for (d = c - 1; 0 === e.bl_count[d];) d--;
          e.bl_count[d]--, e.bl_count[d + 1] += 2, e.bl_count[c]--, p -= 2;
        } while (p > 0);
        for (d = c; 0 !== d; d--) for (l = e.bl_count[d]; 0 !== l;) h = e.heap[--u], h > r || (n[2 * h + 1] !== d && (e.opt_len += (d - n[2 * h + 1]) * n[2 * h], n[2 * h + 1] = d), l--);
      }
    }(e, t), nt(n, u, e.bl_count);
  },
  ut = function ut(e, t, n) {
    var r,
      i,
      o = -1,
      s = t[1],
      a = 0,
      c = 7,
      u = 4;
    for (0 === s && (c = 138, u = 3), t[2 * (n + 1) + 1] = 65535, r = 0; r <= n; r++) i = s, s = t[2 * (r + 1) + 1], ++a < c && i === s || (a < u ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== o && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, a = 0, o = i, 0 === s ? (c = 138, u = 3) : i === s ? (c = 6, u = 3) : (c = 7, u = 4));
  },
  lt = function lt(e, t, n) {
    var r,
      i,
      o = -1,
      s = t[1],
      a = 0,
      c = 7,
      u = 4;
    for (0 === s && (c = 138, u = 3), r = 0; r <= n; r++) if (i = s, s = t[2 * (r + 1) + 1], !(++a < c && i === s)) {
      if (a < u) do {
        et(e, i, e.bl_tree);
      } while (0 != --a);else 0 !== i ? (i !== o && (et(e, i, e.bl_tree), a--), et(e, 16, e.bl_tree), $e(e, a - 3, 2)) : a <= 10 ? (et(e, 17, e.bl_tree), $e(e, a - 3, 3)) : (et(e, 18, e.bl_tree), $e(e, a - 11, 7));
      a = 0, o = i, 0 === s ? (c = 138, u = 3) : i === s ? (c = 6, u = 3) : (c = 7, u = 4);
    }
  };
var ht = !1;
var dt = function dt(e, t, n, r) {
  $e(e, 0 + (r ? 1 : 0), 3), it(e), Je(e, n), Je(e, ~n), n && e.pending_buf.set(e.window.subarray(t, t + n), e.pending), e.pending += n;
};
var _t = function _t(e, t, n, r) {
    var i,
      o,
      s = 0;
    e.level > 0 ? (2 === e.strm.data_type && (e.strm.data_type = function (e) {
      var t,
        n = 4093624447;
      for (t = 0; t <= 31; t++, n >>>= 1) if (1 & n && 0 !== e.dyn_ltree[2 * t]) return 0;
      if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
      for (t = 32; t < De; t++) if (0 !== e.dyn_ltree[2 * t]) return 1;
      return 0;
    }(e)), ct(e, e.l_desc), ct(e, e.d_desc), s = function (e) {
      var t;
      for (ut(e, e.dyn_ltree, e.l_desc.max_code), ut(e, e.dyn_dtree, e.d_desc.max_code), ct(e, e.bl_desc), t = 18; t >= 3 && 0 === e.bl_tree[2 * Fe[t] + 1]; t--);
      return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
    }(e), i = e.opt_len + 3 + 7 >>> 3, o = e.static_len + 3 + 7 >>> 3, o <= i && (i = o)) : i = o = n + 5, n + 4 <= i && -1 !== t ? dt(e, t, n, r) : 4 === e.strategy || o === i ? ($e(e, 2 + (r ? 1 : 0), 3), at(e, qe, Ge)) : ($e(e, 4 + (r ? 1 : 0), 3), function (e, t, n, r) {
      var i;
      for ($e(e, t - 257, 5), $e(e, n - 1, 5), $e(e, r - 4, 4), i = 0; i < r; i++) $e(e, e.bl_tree[2 * Fe[i] + 1], 3);
      lt(e, e.dyn_ltree, t - 1), lt(e, e.dyn_dtree, n - 1);
    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, s + 1), at(e, e.dyn_ltree, e.dyn_dtree)), rt(e), r && it(e);
  },
  ft = {
    _tr_init: function _tr_init(e) {
      ht || (function () {
        var e, t, n, r, i;
        var o = new Array(16);
        for (n = 0, r = 0; r < 28; r++) for (Be[r] = n, e = 0; e < 1 << Pe[r]; e++) Ke[n++] = r;
        for (Ke[n - 1] = r, i = 0, r = 0; r < 16; r++) for (Ve[r] = i, e = 0; e < 1 << Ue[r]; e++) je[i++] = r;
        for (i >>= 7; r < xe; r++) for (Ve[r] = i << 7, e = 0; e < 1 << Ue[r] - 7; e++) je[256 + i++] = r;
        for (t = 0; t <= Me; t++) o[t] = 0;
        for (e = 0; e <= 143;) qe[2 * e + 1] = 8, e++, o[8]++;
        for (; e <= 255;) qe[2 * e + 1] = 9, e++, o[9]++;
        for (; e <= 279;) qe[2 * e + 1] = 7, e++, o[7]++;
        for (; e <= 287;) qe[2 * e + 1] = 8, e++, o[8]++;
        for (nt(qe, 287, o), e = 0; e < xe; e++) Ge[2 * e + 1] = 5, Ge[2 * e] = tt(e, 5);
        He = new Ze(qe, Pe, 257, Le, Me), We = new Ze(Ge, Ue, 0, xe, Me), Qe = new Ze(new Array(0), ze, 0, 19, 7);
      }(), ht = !0), e.l_desc = new Ye(e.dyn_ltree, He), e.d_desc = new Ye(e.dyn_dtree, We), e.bl_desc = new Ye(e.bl_tree, Qe), e.bi_buf = 0, e.bi_valid = 0, rt(e);
    },
    _tr_stored_block: dt,
    _tr_flush_block: _t,
    _tr_tally: function _tr_tally(e, t, n) {
      return e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = n, 0 === t ? e.dyn_ltree[2 * n]++ : (e.matches++, t--, e.dyn_ltree[2 * (Ke[n] + De + 1)]++, e.dyn_dtree[2 * Xe(t)]++), e.sym_next === e.sym_end;
    },
    _tr_align: function _tr_align(e) {
      $e(e, 2, 3), et(e, 256, qe), function (e) {
        16 === e.bi_valid ? (Je(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
      }(e);
    }
  };
var pt = function pt(e, t, n, r) {
  var i = 65535 & e | 0,
    o = e >>> 16 & 65535 | 0,
    s = 0;
  for (; 0 !== n;) {
    s = n > 2e3 ? 2e3 : n, n -= s;
    do {
      i = i + t[r++] | 0, o = o + i | 0;
    } while (--s);
    i %= 65521, o %= 65521;
  }
  return i | o << 16 | 0;
};
var gt = new Uint32Array(function () {
  var e,
    t = [];
  for (var n = 0; n < 256; n++) {
    e = n;
    for (var r = 0; r < 8; r++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[n] = e;
  }
  return t;
}());
var vt = function vt(e, t, n, r) {
    var i = gt,
      o = r + n;
    e ^= -1;
    for (var _n3 = r; _n3 < o; _n3++) e = e >>> 8 ^ i[255 & (e ^ t[_n3])];
    return -1 ^ e;
  },
  Et = {
    2: "need dictionary",
    1: "stream end",
    0: "",
    "-1": "file error",
    "-2": "stream error",
    "-3": "data error",
    "-4": "insufficient memory",
    "-5": "buffer error",
    "-6": "incompatible version"
  },
  bt = {
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    Z_BINARY: 0,
    Z_TEXT: 1,
    Z_UNKNOWN: 2,
    Z_DEFLATED: 8
  };
var mt = ft._tr_init,
  yt = ft._tr_stored_block,
  wt = ft._tr_flush_block,
  St = ft._tr_tally,
  kt = ft._tr_align,
  Tt = bt.Z_NO_FLUSH,
  Ct = bt.Z_PARTIAL_FLUSH,
  Ot = bt.Z_FULL_FLUSH,
  At = bt.Z_FINISH,
  Nt = bt.Z_BLOCK,
  Rt = bt.Z_OK,
  It = bt.Z_STREAM_END,
  Dt = bt.Z_STREAM_ERROR,
  Lt = bt.Z_DATA_ERROR,
  xt = bt.Z_BUF_ERROR,
  Mt = bt.Z_DEFAULT_COMPRESSION,
  Pt = bt.Z_FILTERED,
  Ut = bt.Z_HUFFMAN_ONLY,
  zt = bt.Z_RLE,
  Ft = bt.Z_FIXED,
  qt = bt.Z_DEFAULT_STRATEGY,
  Gt = bt.Z_UNKNOWN,
  jt = bt.Z_DEFLATED,
  Kt = 258,
  Bt = 262,
  Vt = 42,
  Zt = 113,
  Ht = 666,
  Wt = function Wt(e, t) {
    return e.msg = Et[t], t;
  },
  Qt = function Qt(e) {
    return 2 * e - (e > 4 ? 9 : 0);
  },
  Yt = function Yt(e) {
    var t = e.length;
    for (; --t >= 0;) e[t] = 0;
  },
  Xt = function Xt(e) {
    var t,
      n,
      r,
      i = e.w_size;
    t = e.hash_size, r = t;
    do {
      n = e.head[--r], e.head[r] = n >= i ? n - i : 0;
    } while (--t);
    t = i, r = t;
    do {
      n = e.prev[--r], e.prev[r] = n >= i ? n - i : 0;
    } while (--t);
  };
var Jt = function Jt(e, t, n) {
  return (t << e.hash_shift ^ n) & e.hash_mask;
};
var $t = function $t(e) {
    var t = e.state;
    var n = t.pending;
    n > e.avail_out && (n = e.avail_out), 0 !== n && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + n), e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, 0 === t.pending && (t.pending_out = 0));
  },
  en = function en(e, t) {
    wt(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, $t(e.strm);
  },
  tn = function tn(e, t) {
    e.pending_buf[e.pending++] = t;
  },
  nn = function nn(e, t) {
    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
  },
  rn = function rn(e, t, n, r) {
    var i = e.avail_in;
    return i > r && (i = r), 0 === i ? 0 : (e.avail_in -= i, t.set(e.input.subarray(e.next_in, e.next_in + i), n), 1 === e.state.wrap ? e.adler = pt(e.adler, t, i, n) : 2 === e.state.wrap && (e.adler = vt(e.adler, t, i, n)), e.next_in += i, e.total_in += i, i);
  },
  on = function on(e, t) {
    var n,
      r,
      i = e.max_chain_length,
      o = e.strstart,
      s = e.prev_length,
      a = e.nice_match;
    var c = e.strstart > e.w_size - Bt ? e.strstart - (e.w_size - Bt) : 0,
      u = e.window,
      l = e.w_mask,
      h = e.prev,
      d = e.strstart + Kt;
    var _ = u[o + s - 1],
      f = u[o + s];
    e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
    do {
      if (n = t, u[n + s] === f && u[n + s - 1] === _ && u[n] === u[o] && u[++n] === u[o + 1]) {
        o += 2, n++;
        do {} while (u[++o] === u[++n] && u[++o] === u[++n] && u[++o] === u[++n] && u[++o] === u[++n] && u[++o] === u[++n] && u[++o] === u[++n] && u[++o] === u[++n] && u[++o] === u[++n] && o < d);
        if (r = Kt - (d - o), o = d - Kt, r > s) {
          if (e.match_start = t, s = r, r >= a) break;
          _ = u[o + s - 1], f = u[o + s];
        }
      }
    } while ((t = h[t & l]) > c && 0 != --i);
    return s <= e.lookahead ? s : e.lookahead;
  },
  sn = function sn(e) {
    var t = e.w_size;
    var n, r, i;
    do {
      if (r = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - Bt) && (e.window.set(e.window.subarray(t, t + t - r), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), Xt(e), r += t), 0 === e.strm.avail_in) break;
      if (n = rn(e.strm, e.window, e.strstart + e.lookahead, r), e.lookahead += n, e.lookahead + e.insert >= 3) for (i = e.strstart - e.insert, e.ins_h = e.window[i], e.ins_h = Jt(e, e.ins_h, e.window[i + 1]); e.insert && (e.ins_h = Jt(e, e.ins_h, e.window[i + 3 - 1]), e.prev[i & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = i, i++, e.insert--, !(e.lookahead + e.insert < 3)););
    } while (e.lookahead < Bt && 0 !== e.strm.avail_in);
  },
  an = function an(e, t) {
    var n,
      r,
      i,
      o = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5,
      s = 0,
      a = e.strm.avail_in;
    do {
      if (n = 65535, i = e.bi_valid + 42 >> 3, e.strm.avail_out < i) break;
      if (i = e.strm.avail_out - i, r = e.strstart - e.block_start, n > r + e.strm.avail_in && (n = r + e.strm.avail_in), n > i && (n = i), n < o && (0 === n && t !== At || t === Tt || n !== r + e.strm.avail_in)) break;
      s = t === At && n === r + e.strm.avail_in ? 1 : 0, yt(e, 0, 0, s), e.pending_buf[e.pending - 4] = n, e.pending_buf[e.pending - 3] = n >> 8, e.pending_buf[e.pending - 2] = ~n, e.pending_buf[e.pending - 1] = ~n >> 8, $t(e.strm), r && (r > n && (r = n), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + r), e.strm.next_out), e.strm.next_out += r, e.strm.avail_out -= r, e.strm.total_out += r, e.block_start += r, n -= r), n && (rn(e.strm, e.strm.output, e.strm.next_out, n), e.strm.next_out += n, e.strm.avail_out -= n, e.strm.total_out += n);
    } while (0 === s);
    return a -= e.strm.avail_in, a && (a >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= a && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - a, e.strm.next_in), e.strstart), e.strstart += a, e.insert += a > e.w_size - e.insert ? e.w_size - e.insert : a), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), s ? 4 : t !== Tt && t !== At && 0 === e.strm.avail_in && e.strstart === e.block_start ? 2 : (i = e.window_size - e.strstart, e.strm.avail_in > i && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, i += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), i > e.strm.avail_in && (i = e.strm.avail_in), i && (rn(e.strm, e.window, e.strstart, i), e.strstart += i, e.insert += i > e.w_size - e.insert ? e.w_size - e.insert : i), e.high_water < e.strstart && (e.high_water = e.strstart), i = e.bi_valid + 42 >> 3, i = e.pending_buf_size - i > 65535 ? 65535 : e.pending_buf_size - i, o = i > e.w_size ? e.w_size : i, r = e.strstart - e.block_start, (r >= o || (r || t === At) && t !== Tt && 0 === e.strm.avail_in && r <= i) && (n = r > i ? i : r, s = t === At && 0 === e.strm.avail_in && n === r ? 1 : 0, yt(e, e.block_start, n, s), e.block_start += n, $t(e.strm)), s ? 3 : 1);
  },
  cn = function cn(e, t) {
    var n, r;
    for (;;) {
      if (e.lookahead < Bt) {
        if (sn(e), e.lookahead < Bt && t === Tt) return 1;
        if (0 === e.lookahead) break;
      }
      if (n = 0, e.lookahead >= 3 && (e.ins_h = Jt(e, e.ins_h, e.window[e.strstart + 3 - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== n && e.strstart - n <= e.w_size - Bt && (e.match_length = on(e, n)), e.match_length >= 3) {
        if (r = St(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
          e.match_length--;
          do {
            e.strstart++, e.ins_h = Jt(e, e.ins_h, e.window[e.strstart + 3 - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
          } while (0 != --e.match_length);
          e.strstart++;
        } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = Jt(e, e.ins_h, e.window[e.strstart + 1]);
      } else r = St(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
      if (r && (en(e, !1), 0 === e.strm.avail_out)) return 1;
    }
    return e.insert = e.strstart < 2 ? e.strstart : 2, t === At ? (en(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (en(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
  },
  un = function un(e, t) {
    var n, r, i;
    for (;;) {
      if (e.lookahead < Bt) {
        if (sn(e), e.lookahead < Bt && t === Tt) return 1;
        if (0 === e.lookahead) break;
      }
      if (n = 0, e.lookahead >= 3 && (e.ins_h = Jt(e, e.ins_h, e.window[e.strstart + 3 - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== n && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - Bt && (e.match_length = on(e, n), e.match_length <= 5 && (e.strategy === Pt || 3 === e.match_length && e.strstart - e.match_start > 4096) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
        i = e.strstart + e.lookahead - 3, r = St(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
        do {
          ++e.strstart <= i && (e.ins_h = Jt(e, e.ins_h, e.window[e.strstart + 3 - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
        } while (0 != --e.prev_length);
        if (e.match_available = 0, e.match_length = 2, e.strstart++, r && (en(e, !1), 0 === e.strm.avail_out)) return 1;
      } else if (e.match_available) {
        if (r = St(e, 0, e.window[e.strstart - 1]), r && en(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
      } else e.match_available = 1, e.strstart++, e.lookahead--;
    }
    return e.match_available && (r = St(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, t === At ? (en(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (en(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
  };
function ln(e, t, n, r, i) {
  this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
}
var hn = [new ln(0, 0, 0, 0, an), new ln(4, 4, 8, 4, cn), new ln(4, 5, 16, 8, cn), new ln(4, 6, 32, 32, cn), new ln(4, 4, 16, 16, un), new ln(8, 16, 32, 32, un), new ln(8, 16, 128, 128, un), new ln(8, 32, 128, 256, un), new ln(32, 128, 258, 1024, un), new ln(32, 258, 258, 4096, un)];
function dn() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = jt, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(1146), this.dyn_dtree = new Uint16Array(122), this.bl_tree = new Uint16Array(78), Yt(this.dyn_ltree), Yt(this.dyn_dtree), Yt(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(16), this.heap = new Uint16Array(573), Yt(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(573), Yt(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
var _n = function _n(e) {
    if (!e) return 1;
    var t = e.state;
    return !t || t.strm !== e || t.status !== Vt && 57 !== t.status && 69 !== t.status && 73 !== t.status && 91 !== t.status && 103 !== t.status && t.status !== Zt && t.status !== Ht ? 1 : 0;
  },
  fn = function fn(e) {
    if (_n(e)) return Wt(e, Dt);
    e.total_in = e.total_out = 0, e.data_type = Gt;
    var t = e.state;
    return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = 2 === t.wrap ? 57 : t.wrap ? Vt : Zt, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = -2, mt(t), Rt;
  },
  pn = function pn(e) {
    var t = fn(e);
    var n;
    return t === Rt && ((n = e.state).window_size = 2 * n.w_size, Yt(n.head), n.max_lazy_match = hn[n.level].max_lazy, n.good_match = hn[n.level].good_length, n.nice_match = hn[n.level].nice_length, n.max_chain_length = hn[n.level].max_chain, n.strstart = 0, n.block_start = 0, n.lookahead = 0, n.insert = 0, n.match_length = n.prev_length = 2, n.match_available = 0, n.ins_h = 0), t;
  },
  gn = function gn(e, t, n, r, i, o) {
    if (!e) return Dt;
    var s = 1;
    if (t === Mt && (t = 6), r < 0 ? (s = 0, r = -r) : r > 15 && (s = 2, r -= 16), i < 1 || i > 9 || n !== jt || r < 8 || r > 15 || t < 0 || t > 9 || o < 0 || o > Ft || 8 === r && 1 !== s) return Wt(e, Dt);
    8 === r && (r = 9);
    var a = new dn();
    return e.state = a, a.strm = e, a.status = Vt, a.wrap = s, a.gzhead = null, a.w_bits = r, a.w_size = 1 << a.w_bits, a.w_mask = a.w_size - 1, a.hash_bits = i + 7, a.hash_size = 1 << a.hash_bits, a.hash_mask = a.hash_size - 1, a.hash_shift = ~~((a.hash_bits + 3 - 1) / 3), a.window = new Uint8Array(2 * a.w_size), a.head = new Uint16Array(a.hash_size), a.prev = new Uint16Array(a.w_size), a.lit_bufsize = 1 << i + 6, a.pending_buf_size = 4 * a.lit_bufsize, a.pending_buf = new Uint8Array(a.pending_buf_size), a.sym_buf = a.lit_bufsize, a.sym_end = 3 * (a.lit_bufsize - 1), a.level = t, a.strategy = o, a.method = n, pn(e);
  };
var vn = {
  deflateInit: function deflateInit(e, t) {
    return gn(e, t, jt, 15, 8, qt);
  },
  deflateInit2: gn,
  deflateReset: pn,
  deflateResetKeep: fn,
  deflateSetHeader: function deflateSetHeader(e, t) {
    return _n(e) || 2 !== e.state.wrap ? Dt : (e.state.gzhead = t, Rt);
  },
  deflate: function deflate(e, t) {
    if (_n(e) || t > Nt || t < 0) return e ? Wt(e, Dt) : Dt;
    var n = e.state;
    if (!e.output || 0 !== e.avail_in && !e.input || n.status === Ht && t !== At) return Wt(e, 0 === e.avail_out ? xt : Dt);
    var r = n.last_flush;
    if (n.last_flush = t, 0 !== n.pending) {
      if ($t(e), 0 === e.avail_out) return n.last_flush = -1, Rt;
    } else if (0 === e.avail_in && Qt(t) <= Qt(r) && t !== At) return Wt(e, xt);
    if (n.status === Ht && 0 !== e.avail_in) return Wt(e, xt);
    if (n.status === Vt && 0 === n.wrap && (n.status = Zt), n.status === Vt) {
      var _t3 = jt + (n.w_bits - 8 << 4) << 8,
        _r2 = -1;
      if (_r2 = n.strategy >= Ut || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3, _t3 |= _r2 << 6, 0 !== n.strstart && (_t3 |= 32), _t3 += 31 - _t3 % 31, nn(n, _t3), 0 !== n.strstart && (nn(n, e.adler >>> 16), nn(n, 65535 & e.adler)), e.adler = 1, n.status = Zt, $t(e), 0 !== n.pending) return n.last_flush = -1, Rt;
    }
    if (57 === n.status) if (e.adler = 0, tn(n, 31), tn(n, 139), tn(n, 8), n.gzhead) tn(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), tn(n, 255 & n.gzhead.time), tn(n, n.gzhead.time >> 8 & 255), tn(n, n.gzhead.time >> 16 & 255), tn(n, n.gzhead.time >> 24 & 255), tn(n, 9 === n.level ? 2 : n.strategy >= Ut || n.level < 2 ? 4 : 0), tn(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (tn(n, 255 & n.gzhead.extra.length), tn(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = vt(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69;else if (tn(n, 0), tn(n, 0), tn(n, 0), tn(n, 0), tn(n, 0), tn(n, 9 === n.level ? 2 : n.strategy >= Ut || n.level < 2 ? 4 : 0), tn(n, 3), n.status = Zt, $t(e), 0 !== n.pending) return n.last_flush = -1, Rt;
    if (69 === n.status) {
      if (n.gzhead.extra) {
        var _t4 = n.pending,
          _r3 = (65535 & n.gzhead.extra.length) - n.gzindex;
        for (; n.pending + _r3 > n.pending_buf_size;) {
          var _i2 = n.pending_buf_size - n.pending;
          if (n.pending_buf.set(n.gzhead.extra.subarray(n.gzindex, n.gzindex + _i2), n.pending), n.pending = n.pending_buf_size, n.gzhead.hcrc && n.pending > _t4 && (e.adler = vt(e.adler, n.pending_buf, n.pending - _t4, _t4)), n.gzindex += _i2, $t(e), 0 !== n.pending) return n.last_flush = -1, Rt;
          _t4 = 0, _r3 -= _i2;
        }
        var _i3 = new Uint8Array(n.gzhead.extra);
        n.pending_buf.set(_i3.subarray(n.gzindex, n.gzindex + _r3), n.pending), n.pending += _r3, n.gzhead.hcrc && n.pending > _t4 && (e.adler = vt(e.adler, n.pending_buf, n.pending - _t4, _t4)), n.gzindex = 0;
      }
      n.status = 73;
    }
    if (73 === n.status) {
      if (n.gzhead.name) {
        var _t5,
          _r4 = n.pending;
        do {
          if (n.pending === n.pending_buf_size) {
            if (n.gzhead.hcrc && n.pending > _r4 && (e.adler = vt(e.adler, n.pending_buf, n.pending - _r4, _r4)), $t(e), 0 !== n.pending) return n.last_flush = -1, Rt;
            _r4 = 0;
          }
          _t5 = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, tn(n, _t5);
        } while (0 !== _t5);
        n.gzhead.hcrc && n.pending > _r4 && (e.adler = vt(e.adler, n.pending_buf, n.pending - _r4, _r4)), n.gzindex = 0;
      }
      n.status = 91;
    }
    if (91 === n.status) {
      if (n.gzhead.comment) {
        var _t6,
          _r5 = n.pending;
        do {
          if (n.pending === n.pending_buf_size) {
            if (n.gzhead.hcrc && n.pending > _r5 && (e.adler = vt(e.adler, n.pending_buf, n.pending - _r5, _r5)), $t(e), 0 !== n.pending) return n.last_flush = -1, Rt;
            _r5 = 0;
          }
          _t6 = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, tn(n, _t6);
        } while (0 !== _t6);
        n.gzhead.hcrc && n.pending > _r5 && (e.adler = vt(e.adler, n.pending_buf, n.pending - _r5, _r5));
      }
      n.status = 103;
    }
    if (103 === n.status) {
      if (n.gzhead.hcrc) {
        if (n.pending + 2 > n.pending_buf_size && ($t(e), 0 !== n.pending)) return n.last_flush = -1, Rt;
        tn(n, 255 & e.adler), tn(n, e.adler >> 8 & 255), e.adler = 0;
      }
      if (n.status = Zt, $t(e), 0 !== n.pending) return n.last_flush = -1, Rt;
    }
    if (0 !== e.avail_in || 0 !== n.lookahead || t !== Tt && n.status !== Ht) {
      var _r6 = 0 === n.level ? an(n, t) : n.strategy === Ut ? function (e, t) {
        var n;
        for (;;) {
          if (0 === e.lookahead && (sn(e), 0 === e.lookahead)) {
            if (t === Tt) return 1;
            break;
          }
          if (e.match_length = 0, n = St(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (en(e, !1), 0 === e.strm.avail_out)) return 1;
        }
        return e.insert = 0, t === At ? (en(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (en(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
      }(n, t) : n.strategy === zt ? function (e, t) {
        var n, r, i, o;
        var s = e.window;
        for (;;) {
          if (e.lookahead <= Kt) {
            if (sn(e), e.lookahead <= Kt && t === Tt) return 1;
            if (0 === e.lookahead) break;
          }
          if (e.match_length = 0, e.lookahead >= 3 && e.strstart > 0 && (i = e.strstart - 1, r = s[i], r === s[++i] && r === s[++i] && r === s[++i])) {
            o = e.strstart + Kt;
            do {} while (r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && i < o);
            e.match_length = Kt - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
          }
          if (e.match_length >= 3 ? (n = St(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = St(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (en(e, !1), 0 === e.strm.avail_out)) return 1;
        }
        return e.insert = 0, t === At ? (en(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.sym_next && (en(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
      }(n, t) : hn[n.level].func(n, t);
      if (3 !== _r6 && 4 !== _r6 || (n.status = Ht), 1 === _r6 || 3 === _r6) return 0 === e.avail_out && (n.last_flush = -1), Rt;
      if (2 === _r6 && (t === Ct ? kt(n) : t !== Nt && (yt(n, 0, 0, !1), t === Ot && (Yt(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), $t(e), 0 === e.avail_out)) return n.last_flush = -1, Rt;
    }
    return t !== At ? Rt : n.wrap <= 0 ? It : (2 === n.wrap ? (tn(n, 255 & e.adler), tn(n, e.adler >> 8 & 255), tn(n, e.adler >> 16 & 255), tn(n, e.adler >> 24 & 255), tn(n, 255 & e.total_in), tn(n, e.total_in >> 8 & 255), tn(n, e.total_in >> 16 & 255), tn(n, e.total_in >> 24 & 255)) : (nn(n, e.adler >>> 16), nn(n, 65535 & e.adler)), $t(e), n.wrap > 0 && (n.wrap = -n.wrap), 0 !== n.pending ? Rt : It);
  },
  deflateEnd: function deflateEnd(e) {
    if (_n(e)) return Dt;
    var t = e.state.status;
    return e.state = null, t === Zt ? Wt(e, Lt) : Rt;
  },
  deflateSetDictionary: function deflateSetDictionary(e, t) {
    var n = t.length;
    if (_n(e)) return Dt;
    var r = e.state,
      i = r.wrap;
    if (2 === i || 1 === i && r.status !== Vt || r.lookahead) return Dt;
    if (1 === i && (e.adler = pt(e.adler, t, n, 0)), r.wrap = 0, n >= r.w_size) {
      0 === i && (Yt(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0);
      var _e3 = new Uint8Array(r.w_size);
      _e3.set(t.subarray(n - r.w_size, n), 0), t = _e3, n = r.w_size;
    }
    var o = e.avail_in,
      s = e.next_in,
      a = e.input;
    for (e.avail_in = n, e.next_in = 0, e.input = t, sn(r); r.lookahead >= 3;) {
      var _e4 = r.strstart,
        _t7 = r.lookahead - 2;
      do {
        r.ins_h = Jt(r, r.ins_h, r.window[_e4 + 3 - 1]), r.prev[_e4 & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = _e4, _e4++;
      } while (--_t7);
      r.strstart = _e4, r.lookahead = 2, sn(r);
    }
    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = s, e.input = a, e.avail_in = o, r.wrap = i, Rt;
  },
  deflateInfo: "pako deflate (from Nodeca project)"
};
var En = function En(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
};
var bn = {
  assign: function assign(e) {
    var t = Array.prototype.slice.call(arguments, 1);
    for (; t.length;) {
      var n = t.shift();
      if (n) {
        if ("object" != typeof n) throw new TypeError(n + "must be non-object");
        for (var _t8 in n) En(n, _t8) && (e[_t8] = n[_t8]);
      }
    }
    return e;
  },
  flattenChunks: function flattenChunks(e) {
    var t = 0;
    for (var _n4 = 0, _r7 = e.length; _n4 < _r7; _n4++) t += e[_n4].length;
    var n = new Uint8Array(t);
    for (var _t9 = 0, _r8 = 0, _i4 = e.length; _t9 < _i4; _t9++) {
      var _i5 = e[_t9];
      n.set(_i5, _r8), _r8 += _i5.length;
    }
    return n;
  }
};
var mn = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (e) {
  mn = !1;
}
var yn = new Uint8Array(256);
for (var e = 0; e < 256; e++) yn[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
yn[254] = yn[254] = 1;
var wn = {
  string2buf: function string2buf(e) {
    if ("function" == typeof TextEncoder && TextEncoder.prototype.encode) return new TextEncoder().encode(e);
    var t,
      n,
      r,
      i,
      o,
      s = e.length,
      a = 0;
    for (i = 0; i < s; i++) n = e.charCodeAt(i), 55296 == (64512 & n) && i + 1 < s && (r = e.charCodeAt(i + 1), 56320 == (64512 & r) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), a += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
    for (t = new Uint8Array(a), o = 0, i = 0; o < a; i++) n = e.charCodeAt(i), 55296 == (64512 & n) && i + 1 < s && (r = e.charCodeAt(i + 1), 56320 == (64512 & r) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), n < 128 ? t[o++] = n : n < 2048 ? (t[o++] = 192 | n >>> 6, t[o++] = 128 | 63 & n) : n < 65536 ? (t[o++] = 224 | n >>> 12, t[o++] = 128 | n >>> 6 & 63, t[o++] = 128 | 63 & n) : (t[o++] = 240 | n >>> 18, t[o++] = 128 | n >>> 12 & 63, t[o++] = 128 | n >>> 6 & 63, t[o++] = 128 | 63 & n);
    return t;
  },
  buf2string: function buf2string(e, t) {
    var n = t || e.length;
    if ("function" == typeof TextDecoder && TextDecoder.prototype.decode) return new TextDecoder().decode(e.subarray(0, t));
    var r, i;
    var o = new Array(2 * n);
    for (i = 0, r = 0; r < n;) {
      var _t0 = e[r++];
      if (_t0 < 128) {
        o[i++] = _t0;
        continue;
      }
      var _s = yn[_t0];
      if (_s > 4) o[i++] = 65533, r += _s - 1;else {
        for (_t0 &= 2 === _s ? 31 : 3 === _s ? 15 : 7; _s > 1 && r < n;) _t0 = _t0 << 6 | 63 & e[r++], _s--;
        _s > 1 ? o[i++] = 65533 : _t0 < 65536 ? o[i++] = _t0 : (_t0 -= 65536, o[i++] = 55296 | _t0 >> 10 & 1023, o[i++] = 56320 | 1023 & _t0);
      }
    }
    return function (e, t) {
      if (t < 65534 && e.subarray && mn) return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
      var n = "";
      for (var _r9 = 0; _r9 < t; _r9++) n += String.fromCharCode(e[_r9]);
      return n;
    }(o, i);
  },
  utf8border: function utf8border(e, t) {
    (t = t || e.length) > e.length && (t = e.length);
    var n = t - 1;
    for (; n >= 0 && 128 == (192 & e[n]);) n--;
    return n < 0 || 0 === n ? t : n + yn[e[n]] > t ? n : t;
  }
};
var Sn = function Sn() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
};
var kn = Object.prototype.toString,
  Tn = bt.Z_NO_FLUSH,
  Cn = bt.Z_SYNC_FLUSH,
  On = bt.Z_FULL_FLUSH,
  An = bt.Z_FINISH,
  Nn = bt.Z_OK,
  Rn = bt.Z_STREAM_END,
  In = bt.Z_DEFAULT_COMPRESSION,
  Dn = bt.Z_DEFAULT_STRATEGY,
  Ln = bt.Z_DEFLATED;
function xn(e) {
  this.options = bn.assign({
    level: In,
    method: Ln,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Dn
  }, e || {});
  var t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Sn(), this.strm.avail_out = 0;
  var n = vn.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
  if (n !== Nn) throw new Error(Et[n]);
  if (t.header && vn.deflateSetHeader(this.strm, t.header), t.dictionary) {
    var _e5;
    if (_e5 = "string" == typeof t.dictionary ? wn.string2buf(t.dictionary) : "[object ArrayBuffer]" === kn.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, n = vn.deflateSetDictionary(this.strm, _e5), n !== Nn) throw new Error(Et[n]);
    this._dict_set = !0;
  }
}
function Mn(e, t) {
  var n = new xn(t);
  if (n.push(e, !0), n.err) throw n.msg || Et[n.err];
  return n.result;
}
xn.prototype.push = function (e, t) {
  var n = this.strm,
    r = this.options.chunkSize;
  var i, o;
  if (this.ended) return !1;
  for (o = t === ~~t ? t : !0 === t ? An : Tn, "string" == typeof e ? n.input = wn.string2buf(e) : "[object ArrayBuffer]" === kn.call(e) ? n.input = new Uint8Array(e) : n.input = e, n.next_in = 0, n.avail_in = n.input.length;;) if (0 === n.avail_out && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), (o === Cn || o === On) && n.avail_out <= 6) this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;else {
    if (i = vn.deflate(n, o), i === Rn) return n.next_out > 0 && this.onData(n.output.subarray(0, n.next_out)), i = vn.deflateEnd(this.strm), this.onEnd(i), this.ended = !0, i === Nn;
    if (0 !== n.avail_out) {
      if (o > 0 && n.next_out > 0) this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;else if (0 === n.avail_in) break;
    } else this.onData(n.output);
  }
  return !0;
}, xn.prototype.onData = function (e) {
  this.chunks.push(e);
}, xn.prototype.onEnd = function (e) {
  e === Nn && (this.result = bn.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
var Pn = {
  Deflate: xn,
  deflate: Mn,
  deflateRaw: function deflateRaw(e, t) {
    return (t = t || {}).raw = !0, Mn(e, t);
  },
  gzip: function gzip(e, t) {
    return (t = t || {}).gzip = !0, Mn(e, t);
  },
  constants: bt
};
var Un = 16209;
var zn = function zn(e, t) {
  var n, r, i, o, s, a, c, u, l, h, d, _, f, p, g, v, E, b, m, y, w, S, k, T;
  var C = e.state;
  n = e.next_in, k = e.input, r = n + (e.avail_in - 5), i = e.next_out, T = e.output, o = i - (t - e.avail_out), s = i + (e.avail_out - 257), a = C.dmax, c = C.wsize, u = C.whave, l = C.wnext, h = C.window, d = C.hold, _ = C.bits, f = C.lencode, p = C.distcode, g = (1 << C.lenbits) - 1, v = (1 << C.distbits) - 1;
  e: do {
    _ < 15 && (d += k[n++] << _, _ += 8, d += k[n++] << _, _ += 8), E = f[d & g];
    t: for (;;) {
      if (b = E >>> 24, d >>>= b, _ -= b, b = E >>> 16 & 255, 0 === b) T[i++] = 65535 & E;else {
        if (!(16 & b)) {
          if (0 == (64 & b)) {
            E = f[(65535 & E) + (d & (1 << b) - 1)];
            continue t;
          }
          if (32 & b) {
            C.mode = 16191;
            break e;
          }
          e.msg = "invalid literal/length code", C.mode = Un;
          break e;
        }
        m = 65535 & E, b &= 15, b && (_ < b && (d += k[n++] << _, _ += 8), m += d & (1 << b) - 1, d >>>= b, _ -= b), _ < 15 && (d += k[n++] << _, _ += 8, d += k[n++] << _, _ += 8), E = p[d & v];
        n: for (;;) {
          if (b = E >>> 24, d >>>= b, _ -= b, b = E >>> 16 & 255, !(16 & b)) {
            if (0 == (64 & b)) {
              E = p[(65535 & E) + (d & (1 << b) - 1)];
              continue n;
            }
            e.msg = "invalid distance code", C.mode = Un;
            break e;
          }
          if (y = 65535 & E, b &= 15, _ < b && (d += k[n++] << _, _ += 8, _ < b && (d += k[n++] << _, _ += 8)), y += d & (1 << b) - 1, y > a) {
            e.msg = "invalid distance too far back", C.mode = Un;
            break e;
          }
          if (d >>>= b, _ -= b, b = i - o, y > b) {
            if (b = y - b, b > u && C.sane) {
              e.msg = "invalid distance too far back", C.mode = Un;
              break e;
            }
            if (w = 0, S = h, 0 === l) {
              if (w += c - b, b < m) {
                m -= b;
                do {
                  T[i++] = h[w++];
                } while (--b);
                w = i - y, S = T;
              }
            } else if (l < b) {
              if (w += c + l - b, b -= l, b < m) {
                m -= b;
                do {
                  T[i++] = h[w++];
                } while (--b);
                if (w = 0, l < m) {
                  b = l, m -= b;
                  do {
                    T[i++] = h[w++];
                  } while (--b);
                  w = i - y, S = T;
                }
              }
            } else if (w += l - b, b < m) {
              m -= b;
              do {
                T[i++] = h[w++];
              } while (--b);
              w = i - y, S = T;
            }
            for (; m > 2;) T[i++] = S[w++], T[i++] = S[w++], T[i++] = S[w++], m -= 3;
            m && (T[i++] = S[w++], m > 1 && (T[i++] = S[w++]));
          } else {
            w = i - y;
            do {
              T[i++] = T[w++], T[i++] = T[w++], T[i++] = T[w++], m -= 3;
            } while (m > 2);
            m && (T[i++] = T[w++], m > 1 && (T[i++] = T[w++]));
          }
          break;
        }
      }
      break;
    }
  } while (n < r && i < s);
  m = _ >> 3, n -= m, _ -= m << 3, d &= (1 << _) - 1, e.next_in = n, e.next_out = i, e.avail_in = n < r ? r - n + 5 : 5 - (n - r), e.avail_out = i < s ? s - i + 257 : 257 - (i - s), C.hold = d, C.bits = _;
};
var Fn = 15,
  qn = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]),
  Gn = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]),
  jn = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]),
  Kn = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]);
var Bn = function Bn(e, t, n, r, i, o, s, a) {
  var c = a.bits;
  var u,
    l,
    h,
    d,
    _,
    f,
    p = 0,
    g = 0,
    v = 0,
    E = 0,
    b = 0,
    m = 0,
    y = 0,
    w = 0,
    S = 0,
    k = 0,
    T = null;
  var C = new Uint16Array(16),
    O = new Uint16Array(16);
  var A,
    N,
    R,
    I = null;
  for (p = 0; p <= Fn; p++) C[p] = 0;
  for (g = 0; g < r; g++) C[t[n + g]]++;
  for (b = c, E = Fn; E >= 1 && 0 === C[E]; E--);
  if (b > E && (b = E), 0 === E) return i[o++] = 20971520, i[o++] = 20971520, a.bits = 1, 0;
  for (v = 1; v < E && 0 === C[v]; v++);
  for (b < v && (b = v), w = 1, p = 1; p <= Fn; p++) if (w <<= 1, w -= C[p], w < 0) return -1;
  if (w > 0 && (0 === e || 1 !== E)) return -1;
  for (O[1] = 0, p = 1; p < Fn; p++) O[p + 1] = O[p] + C[p];
  for (g = 0; g < r; g++) 0 !== t[n + g] && (s[O[t[n + g]]++] = g);
  if (0 === e ? (T = I = s, f = 20) : 1 === e ? (T = qn, I = Gn, f = 257) : (T = jn, I = Kn, f = 0), k = 0, g = 0, p = v, _ = o, m = b, y = 0, h = -1, S = 1 << b, d = S - 1, 1 === e && S > 852 || 2 === e && S > 592) return 1;
  for (;;) {
    A = p - y, s[g] + 1 < f ? (N = 0, R = s[g]) : s[g] >= f ? (N = I[s[g] - f], R = T[s[g] - f]) : (N = 96, R = 0), u = 1 << p - y, l = 1 << m, v = l;
    do {
      l -= u, i[_ + (k >> y) + l] = A << 24 | N << 16 | R | 0;
    } while (0 !== l);
    for (u = 1 << p - 1; k & u;) u >>= 1;
    if (0 !== u ? (k &= u - 1, k += u) : k = 0, g++, 0 == --C[p]) {
      if (p === E) break;
      p = t[n + s[g]];
    }
    if (p > b && (k & d) !== h) {
      for (0 === y && (y = b), _ += v, m = p - y, w = 1 << m; m + y < E && (w -= C[m + y], !(w <= 0));) m++, w <<= 1;
      if (S += 1 << m, 1 === e && S > 852 || 2 === e && S > 592) return 1;
      h = k & d, i[h] = b << 24 | m << 16 | _ - o | 0;
    }
  }
  return 0 !== k && (i[_ + k] = p - y << 24 | 64 << 16 | 0), a.bits = b, 0;
};
var Vn = bt.Z_FINISH,
  Zn = bt.Z_BLOCK,
  Hn = bt.Z_TREES,
  Wn = bt.Z_OK,
  Qn = bt.Z_STREAM_END,
  Yn = bt.Z_NEED_DICT,
  Xn = bt.Z_STREAM_ERROR,
  Jn = bt.Z_DATA_ERROR,
  $n = bt.Z_MEM_ERROR,
  er = bt.Z_BUF_ERROR,
  tr = bt.Z_DEFLATED,
  nr = 16180,
  rr = 16190,
  ir = 16191,
  or = 16192,
  sr = 16194,
  ar = 16199,
  cr = 16200,
  ur = 16206,
  lr = 16209,
  hr = function hr(e) {
    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
  };
function dr() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
var _r = function _r(e) {
    if (!e) return 1;
    var t = e.state;
    return !t || t.strm !== e || t.mode < nr || t.mode > 16211 ? 1 : 0;
  },
  fr = function fr(e) {
    if (_r(e)) return Xn;
    var t = e.state;
    return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = nr, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(852), t.distcode = t.distdyn = new Int32Array(592), t.sane = 1, t.back = -1, Wn;
  },
  pr = function pr(e) {
    if (_r(e)) return Xn;
    var t = e.state;
    return t.wsize = 0, t.whave = 0, t.wnext = 0, fr(e);
  },
  gr = function gr(e, t) {
    var n;
    if (_r(e)) return Xn;
    var r = e.state;
    return t < 0 ? (n = 0, t = -t) : (n = 5 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? Xn : (null !== r.window && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, pr(e));
  },
  vr = function vr(e, t) {
    if (!e) return Xn;
    var n = new dr();
    e.state = n, n.strm = e, n.window = null, n.mode = nr;
    var r = gr(e, t);
    return r !== Wn && (e.state = null), r;
  };
var Er,
  br,
  mr = !0;
var yr = function yr(e) {
    if (mr) {
      Er = new Int32Array(512), br = new Int32Array(32);
      var _t1 = 0;
      for (; _t1 < 144;) e.lens[_t1++] = 8;
      for (; _t1 < 256;) e.lens[_t1++] = 9;
      for (; _t1 < 280;) e.lens[_t1++] = 7;
      for (; _t1 < 288;) e.lens[_t1++] = 8;
      for (Bn(1, e.lens, 0, 288, Er, 0, e.work, {
        bits: 9
      }), _t1 = 0; _t1 < 32;) e.lens[_t1++] = 5;
      Bn(2, e.lens, 0, 32, br, 0, e.work, {
        bits: 5
      }), mr = !1;
    }
    e.lencode = Er, e.lenbits = 9, e.distcode = br, e.distbits = 5;
  },
  wr = function wr(e, t, n, r) {
    var i;
    var o = e.state;
    return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), r >= o.wsize ? (o.window.set(t.subarray(n - o.wsize, n), 0), o.wnext = 0, o.whave = o.wsize) : (i = o.wsize - o.wnext, i > r && (i = r), o.window.set(t.subarray(n - r, n - r + i), o.wnext), (r -= i) ? (o.window.set(t.subarray(n - r, n), 0), o.wnext = r, o.whave = o.wsize) : (o.wnext += i, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += i))), 0;
  };
var Sr = {
  inflateReset: pr,
  inflateReset2: gr,
  inflateResetKeep: fr,
  inflateInit: function inflateInit(e) {
    return vr(e, 15);
  },
  inflateInit2: vr,
  inflate: function inflate(e, t) {
    var n,
      r,
      i,
      o,
      s,
      a,
      c,
      u,
      l,
      h,
      d,
      _,
      f,
      p,
      g,
      v,
      E,
      b,
      m,
      y,
      w,
      S,
      k = 0;
    var T = new Uint8Array(4);
    var C, O;
    var A = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
    if (_r(e) || !e.output || !e.input && 0 !== e.avail_in) return Xn;
    n = e.state, n.mode === ir && (n.mode = or), s = e.next_out, i = e.output, c = e.avail_out, o = e.next_in, r = e.input, a = e.avail_in, u = n.hold, l = n.bits, h = a, d = c, S = Wn;
    e: for (;;) switch (n.mode) {
      case nr:
        if (0 === n.wrap) {
          n.mode = or;
          break;
        }
        for (; l < 16;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        if (2 & n.wrap && 35615 === u) {
          0 === n.wbits && (n.wbits = 15), n.check = 0, T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = vt(n.check, T, 2, 0), u = 0, l = 0, n.mode = 16181;
          break;
        }
        if (n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
          e.msg = "incorrect header check", n.mode = lr;
          break;
        }
        if ((15 & u) !== tr) {
          e.msg = "unknown compression method", n.mode = lr;
          break;
        }
        if (u >>>= 4, l -= 4, w = 8 + (15 & u), 0 === n.wbits && (n.wbits = w), w > 15 || w > n.wbits) {
          e.msg = "invalid window size", n.mode = lr;
          break;
        }
        n.dmax = 1 << n.wbits, n.flags = 0, e.adler = n.check = 1, n.mode = 512 & u ? 16189 : ir, u = 0, l = 0;
        break;
      case 16181:
        for (; l < 16;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        if (n.flags = u, (255 & n.flags) !== tr) {
          e.msg = "unknown compression method", n.mode = lr;
          break;
        }
        if (57344 & n.flags) {
          e.msg = "unknown header flags set", n.mode = lr;
          break;
        }
        n.head && (n.head.text = u >> 8 & 1), 512 & n.flags && 4 & n.wrap && (T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = vt(n.check, T, 2, 0)), u = 0, l = 0, n.mode = 16182;
      case 16182:
        for (; l < 32;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        n.head && (n.head.time = u), 512 & n.flags && 4 & n.wrap && (T[0] = 255 & u, T[1] = u >>> 8 & 255, T[2] = u >>> 16 & 255, T[3] = u >>> 24 & 255, n.check = vt(n.check, T, 4, 0)), u = 0, l = 0, n.mode = 16183;
      case 16183:
        for (; l < 16;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        n.head && (n.head.xflags = 255 & u, n.head.os = u >> 8), 512 & n.flags && 4 & n.wrap && (T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = vt(n.check, T, 2, 0)), u = 0, l = 0, n.mode = 16184;
      case 16184:
        if (1024 & n.flags) {
          for (; l < 16;) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          n.length = u, n.head && (n.head.extra_len = u), 512 & n.flags && 4 & n.wrap && (T[0] = 255 & u, T[1] = u >>> 8 & 255, n.check = vt(n.check, T, 2, 0)), u = 0, l = 0;
        } else n.head && (n.head.extra = null);
        n.mode = 16185;
      case 16185:
        if (1024 & n.flags && (_ = n.length, _ > a && (_ = a), _ && (n.head && (w = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Uint8Array(n.head.extra_len)), n.head.extra.set(r.subarray(o, o + _), w)), 512 & n.flags && 4 & n.wrap && (n.check = vt(n.check, r, _, o)), a -= _, o += _, n.length -= _), n.length)) break e;
        n.length = 0, n.mode = 16186;
      case 16186:
        if (2048 & n.flags) {
          if (0 === a) break e;
          _ = 0;
          do {
            w = r[o + _++], n.head && w && n.length < 65536 && (n.head.name += String.fromCharCode(w));
          } while (w && _ < a);
          if (512 & n.flags && 4 & n.wrap && (n.check = vt(n.check, r, _, o)), a -= _, o += _, w) break e;
        } else n.head && (n.head.name = null);
        n.length = 0, n.mode = 16187;
      case 16187:
        if (4096 & n.flags) {
          if (0 === a) break e;
          _ = 0;
          do {
            w = r[o + _++], n.head && w && n.length < 65536 && (n.head.comment += String.fromCharCode(w));
          } while (w && _ < a);
          if (512 & n.flags && 4 & n.wrap && (n.check = vt(n.check, r, _, o)), a -= _, o += _, w) break e;
        } else n.head && (n.head.comment = null);
        n.mode = 16188;
      case 16188:
        if (512 & n.flags) {
          for (; l < 16;) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          if (4 & n.wrap && u !== (65535 & n.check)) {
            e.msg = "header crc mismatch", n.mode = lr;
            break;
          }
          u = 0, l = 0;
        }
        n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = ir;
        break;
      case 16189:
        for (; l < 32;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        e.adler = n.check = hr(u), u = 0, l = 0, n.mode = rr;
      case rr:
        if (0 === n.havedict) return e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = a, n.hold = u, n.bits = l, Yn;
        e.adler = n.check = 1, n.mode = ir;
      case ir:
        if (t === Zn || t === Hn) break e;
      case or:
        if (n.last) {
          u >>>= 7 & l, l -= 7 & l, n.mode = ur;
          break;
        }
        for (; l < 3;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        switch (n.last = 1 & u, u >>>= 1, l -= 1, 3 & u) {
          case 0:
            n.mode = 16193;
            break;
          case 1:
            if (yr(n), n.mode = ar, t === Hn) {
              u >>>= 2, l -= 2;
              break e;
            }
            break;
          case 2:
            n.mode = 16196;
            break;
          case 3:
            e.msg = "invalid block type", n.mode = lr;
        }
        u >>>= 2, l -= 2;
        break;
      case 16193:
        for (u >>>= 7 & l, l -= 7 & l; l < 32;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        if ((65535 & u) != (u >>> 16 ^ 65535)) {
          e.msg = "invalid stored block lengths", n.mode = lr;
          break;
        }
        if (n.length = 65535 & u, u = 0, l = 0, n.mode = sr, t === Hn) break e;
      case sr:
        n.mode = 16195;
      case 16195:
        if (_ = n.length, _) {
          if (_ > a && (_ = a), _ > c && (_ = c), 0 === _) break e;
          i.set(r.subarray(o, o + _), s), a -= _, o += _, c -= _, s += _, n.length -= _;
          break;
        }
        n.mode = ir;
        break;
      case 16196:
        for (; l < 14;) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        if (n.nlen = 257 + (31 & u), u >>>= 5, l -= 5, n.ndist = 1 + (31 & u), u >>>= 5, l -= 5, n.ncode = 4 + (15 & u), u >>>= 4, l -= 4, n.nlen > 286 || n.ndist > 30) {
          e.msg = "too many length or distance symbols", n.mode = lr;
          break;
        }
        n.have = 0, n.mode = 16197;
      case 16197:
        for (; n.have < n.ncode;) {
          for (; l < 3;) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          n.lens[A[n.have++]] = 7 & u, u >>>= 3, l -= 3;
        }
        for (; n.have < 19;) n.lens[A[n.have++]] = 0;
        if (n.lencode = n.lendyn, n.lenbits = 7, C = {
          bits: n.lenbits
        }, S = Bn(0, n.lens, 0, 19, n.lencode, 0, n.work, C), n.lenbits = C.bits, S) {
          e.msg = "invalid code lengths set", n.mode = lr;
          break;
        }
        n.have = 0, n.mode = 16198;
      case 16198:
        for (; n.have < n.nlen + n.ndist;) {
          for (; k = n.lencode[u & (1 << n.lenbits) - 1], g = k >>> 24, v = k >>> 16 & 255, E = 65535 & k, !(g <= l);) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          if (E < 16) u >>>= g, l -= g, n.lens[n.have++] = E;else {
            if (16 === E) {
              for (O = g + 2; l < O;) {
                if (0 === a) break e;
                a--, u += r[o++] << l, l += 8;
              }
              if (u >>>= g, l -= g, 0 === n.have) {
                e.msg = "invalid bit length repeat", n.mode = lr;
                break;
              }
              w = n.lens[n.have - 1], _ = 3 + (3 & u), u >>>= 2, l -= 2;
            } else if (17 === E) {
              for (O = g + 3; l < O;) {
                if (0 === a) break e;
                a--, u += r[o++] << l, l += 8;
              }
              u >>>= g, l -= g, w = 0, _ = 3 + (7 & u), u >>>= 3, l -= 3;
            } else {
              for (O = g + 7; l < O;) {
                if (0 === a) break e;
                a--, u += r[o++] << l, l += 8;
              }
              u >>>= g, l -= g, w = 0, _ = 11 + (127 & u), u >>>= 7, l -= 7;
            }
            if (n.have + _ > n.nlen + n.ndist) {
              e.msg = "invalid bit length repeat", n.mode = lr;
              break;
            }
            for (; _--;) n.lens[n.have++] = w;
          }
        }
        if (n.mode === lr) break;
        if (0 === n.lens[256]) {
          e.msg = "invalid code -- missing end-of-block", n.mode = lr;
          break;
        }
        if (n.lenbits = 9, C = {
          bits: n.lenbits
        }, S = Bn(1, n.lens, 0, n.nlen, n.lencode, 0, n.work, C), n.lenbits = C.bits, S) {
          e.msg = "invalid literal/lengths set", n.mode = lr;
          break;
        }
        if (n.distbits = 6, n.distcode = n.distdyn, C = {
          bits: n.distbits
        }, S = Bn(2, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, C), n.distbits = C.bits, S) {
          e.msg = "invalid distances set", n.mode = lr;
          break;
        }
        if (n.mode = ar, t === Hn) break e;
      case ar:
        n.mode = cr;
      case cr:
        if (a >= 6 && c >= 258) {
          e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = a, n.hold = u, n.bits = l, zn(e, d), s = e.next_out, i = e.output, c = e.avail_out, o = e.next_in, r = e.input, a = e.avail_in, u = n.hold, l = n.bits, n.mode === ir && (n.back = -1);
          break;
        }
        for (n.back = 0; k = n.lencode[u & (1 << n.lenbits) - 1], g = k >>> 24, v = k >>> 16 & 255, E = 65535 & k, !(g <= l);) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        if (v && 0 == (240 & v)) {
          for (b = g, m = v, y = E; k = n.lencode[y + ((u & (1 << b + m) - 1) >> b)], g = k >>> 24, v = k >>> 16 & 255, E = 65535 & k, !(b + g <= l);) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          u >>>= b, l -= b, n.back += b;
        }
        if (u >>>= g, l -= g, n.back += g, n.length = E, 0 === v) {
          n.mode = 16205;
          break;
        }
        if (32 & v) {
          n.back = -1, n.mode = ir;
          break;
        }
        if (64 & v) {
          e.msg = "invalid literal/length code", n.mode = lr;
          break;
        }
        n.extra = 15 & v, n.mode = 16201;
      case 16201:
        if (n.extra) {
          for (O = n.extra; l < O;) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          n.length += u & (1 << n.extra) - 1, u >>>= n.extra, l -= n.extra, n.back += n.extra;
        }
        n.was = n.length, n.mode = 16202;
      case 16202:
        for (; k = n.distcode[u & (1 << n.distbits) - 1], g = k >>> 24, v = k >>> 16 & 255, E = 65535 & k, !(g <= l);) {
          if (0 === a) break e;
          a--, u += r[o++] << l, l += 8;
        }
        if (0 == (240 & v)) {
          for (b = g, m = v, y = E; k = n.distcode[y + ((u & (1 << b + m) - 1) >> b)], g = k >>> 24, v = k >>> 16 & 255, E = 65535 & k, !(b + g <= l);) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          u >>>= b, l -= b, n.back += b;
        }
        if (u >>>= g, l -= g, n.back += g, 64 & v) {
          e.msg = "invalid distance code", n.mode = lr;
          break;
        }
        n.offset = E, n.extra = 15 & v, n.mode = 16203;
      case 16203:
        if (n.extra) {
          for (O = n.extra; l < O;) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          n.offset += u & (1 << n.extra) - 1, u >>>= n.extra, l -= n.extra, n.back += n.extra;
        }
        if (n.offset > n.dmax) {
          e.msg = "invalid distance too far back", n.mode = lr;
          break;
        }
        n.mode = 16204;
      case 16204:
        if (0 === c) break e;
        if (_ = d - c, n.offset > _) {
          if (_ = n.offset - _, _ > n.whave && n.sane) {
            e.msg = "invalid distance too far back", n.mode = lr;
            break;
          }
          _ > n.wnext ? (_ -= n.wnext, f = n.wsize - _) : f = n.wnext - _, _ > n.length && (_ = n.length), p = n.window;
        } else p = i, f = s - n.offset, _ = n.length;
        _ > c && (_ = c), c -= _, n.length -= _;
        do {
          i[s++] = p[f++];
        } while (--_);
        0 === n.length && (n.mode = cr);
        break;
      case 16205:
        if (0 === c) break e;
        i[s++] = n.length, c--, n.mode = cr;
        break;
      case ur:
        if (n.wrap) {
          for (; l < 32;) {
            if (0 === a) break e;
            a--, u |= r[o++] << l, l += 8;
          }
          if (d -= c, e.total_out += d, n.total += d, 4 & n.wrap && d && (e.adler = n.check = n.flags ? vt(n.check, i, d, s - d) : pt(n.check, i, d, s - d)), d = c, 4 & n.wrap && (n.flags ? u : hr(u)) !== n.check) {
            e.msg = "incorrect data check", n.mode = lr;
            break;
          }
          u = 0, l = 0;
        }
        n.mode = 16207;
      case 16207:
        if (n.wrap && n.flags) {
          for (; l < 32;) {
            if (0 === a) break e;
            a--, u += r[o++] << l, l += 8;
          }
          if (4 & n.wrap && u !== (4294967295 & n.total)) {
            e.msg = "incorrect length check", n.mode = lr;
            break;
          }
          u = 0, l = 0;
        }
        n.mode = 16208;
      case 16208:
        S = Qn;
        break e;
      case lr:
        S = Jn;
        break e;
      case 16210:
        return $n;
      default:
        return Xn;
    }
    return e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = a, n.hold = u, n.bits = l, (n.wsize || d !== e.avail_out && n.mode < lr && (n.mode < ur || t !== Vn)) && wr(e, e.output, e.next_out, d - e.avail_out), h -= e.avail_in, d -= e.avail_out, e.total_in += h, e.total_out += d, n.total += d, 4 & n.wrap && d && (e.adler = n.check = n.flags ? vt(n.check, i, d, e.next_out - d) : pt(n.check, i, d, e.next_out - d)), e.data_type = n.bits + (n.last ? 64 : 0) + (n.mode === ir ? 128 : 0) + (n.mode === ar || n.mode === sr ? 256 : 0), (0 === h && 0 === d || t === Vn) && S === Wn && (S = er), S;
  },
  inflateEnd: function inflateEnd(e) {
    if (_r(e)) return Xn;
    var t = e.state;
    return t.window && (t.window = null), e.state = null, Wn;
  },
  inflateGetHeader: function inflateGetHeader(e, t) {
    if (_r(e)) return Xn;
    var n = e.state;
    return 0 == (2 & n.wrap) ? Xn : (n.head = t, t.done = !1, Wn);
  },
  inflateSetDictionary: function inflateSetDictionary(e, t) {
    var n = t.length;
    var r, i, o;
    return _r(e) ? Xn : (r = e.state, 0 !== r.wrap && r.mode !== rr ? Xn : r.mode === rr && (i = 1, i = pt(i, t, n, 0), i !== r.check) ? Jn : (o = wr(e, t, n, n), o ? (r.mode = 16210, $n) : (r.havedict = 1, Wn)));
  },
  inflateInfo: "pako inflate (from Nodeca project)"
};
var kr = function kr() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
};
var Tr = Object.prototype.toString,
  Cr = bt.Z_NO_FLUSH,
  Or = bt.Z_FINISH,
  Ar = bt.Z_OK,
  Nr = bt.Z_STREAM_END,
  Rr = bt.Z_NEED_DICT,
  Ir = bt.Z_STREAM_ERROR,
  Dr = bt.Z_DATA_ERROR,
  Lr = bt.Z_MEM_ERROR;
function xr(e) {
  this.options = bn.assign({
    chunkSize: 65536,
    windowBits: 15,
    to: ""
  }, e || {});
  var t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Sn(), this.strm.avail_out = 0;
  var n = Sr.inflateInit2(this.strm, t.windowBits);
  if (n !== Ar) throw new Error(Et[n]);
  if (this.header = new kr(), Sr.inflateGetHeader(this.strm, this.header), t.dictionary && ("string" == typeof t.dictionary ? t.dictionary = wn.string2buf(t.dictionary) : "[object ArrayBuffer]" === Tr.call(t.dictionary) && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (n = Sr.inflateSetDictionary(this.strm, t.dictionary), n !== Ar))) throw new Error(Et[n]);
}
function Mr(e, t) {
  var n = new xr(t);
  if (n.push(e), n.err) throw n.msg || Et[n.err];
  return n.result;
}
xr.prototype.push = function (e, t) {
  var n = this.strm,
    r = this.options.chunkSize,
    i = this.options.dictionary;
  var o, s, a;
  if (this.ended) return !1;
  for (s = t === ~~t ? t : !0 === t ? Or : Cr, "[object ArrayBuffer]" === Tr.call(e) ? n.input = new Uint8Array(e) : n.input = e, n.next_in = 0, n.avail_in = n.input.length;;) {
    for (0 === n.avail_out && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), o = Sr.inflate(n, s), o === Rr && i && (o = Sr.inflateSetDictionary(n, i), o === Ar ? o = Sr.inflate(n, s) : o === Dr && (o = Rr)); n.avail_in > 0 && o === Nr && n.state.wrap > 0 && 0 !== e[n.next_in];) Sr.inflateReset(n), o = Sr.inflate(n, s);
    switch (o) {
      case Ir:
      case Dr:
      case Rr:
      case Lr:
        return this.onEnd(o), this.ended = !0, !1;
    }
    if (a = n.avail_out, n.next_out && (0 === n.avail_out || o === Nr)) if ("string" === this.options.to) {
      var _e6 = wn.utf8border(n.output, n.next_out),
        _t10 = n.next_out - _e6,
        _i6 = wn.buf2string(n.output, _e6);
      n.next_out = _t10, n.avail_out = r - _t10, _t10 && n.output.set(n.output.subarray(_e6, _e6 + _t10), 0), this.onData(_i6);
    } else this.onData(n.output.length === n.next_out ? n.output : n.output.subarray(0, n.next_out));
    if (o !== Ar || 0 !== a) {
      if (o === Nr) return o = Sr.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, !0;
      if (0 === n.avail_in) break;
    }
  }
  return !0;
}, xr.prototype.onData = function (e) {
  this.chunks.push(e);
}, xr.prototype.onEnd = function (e) {
  e === Ar && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = bn.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
var Pr = {
  Inflate: xr,
  inflate: Mr,
  inflateRaw: function inflateRaw(e, t) {
    return (t = t || {}).raw = !0, Mr(e, t);
  },
  ungzip: Mr,
  constants: bt
};
var Ur = Pn.Deflate,
  zr = Pn.deflate,
  Fr = Pn.deflateRaw,
  qr = Pn.gzip,
  Gr = Pr.Inflate,
  jr = Pr.inflate,
  Kr = Pr.inflateRaw,
  Br = Pr.ungzip;
var Vr,
  Zr = {
    Deflate: Ur,
    deflate: zr,
    deflateRaw: Fr,
    gzip: qr,
    Inflate: Gr,
    inflate: jr,
    inflateRaw: Kr,
    ungzip: Br,
    constants: bt
  };
!function (e) {
  e.CONNECTING = "CONNECTING", e.OPEN = "OPEN", e.CLOSED = "CLOSED";
}(Vr || (Vr = {}));
var Hr,
  Wr = function (e) {
    function n(t, n) {
      var r = n.sdkState,
        i = n.dispatcher,
        o = n.logger,
        s = e.call(this) || this;
      return s.lastActive = 0, s._iid = t, s._sdkState = r, s._dispatcher = i, s._logger = o, s;
    }
    return t(n, e), Object.defineProperty(n.prototype, "isOpen", {
      get: function get() {
        return this.connectionState === Vr.OPEN;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "connectionState", {
      get: function get() {
        if (this._ws) switch (this._ws.readyState) {
          case 0:
            return Vr.CONNECTING;
          case 1:
            return Vr.OPEN;
        }
        return Vr.CLOSED;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype._handleMessage = function (e) {
      var t = this;
      e.split("\n").forEach(function (e) {
        if (e) {
          var n = Ne.createFromRawMessage(t._iid, e);
          if (t._logger.debug("receive websocket event", n), "LOGI" === n.code) t.dispatch("message", n);else if ("PONG" === n.code) t.dispatch("pong");else if ("EXPR" === n.code) {
            if (n.payload) {
              var r = new ke(n.payload);
              r.expiresIn >= 0 && t._dispatcher.dispatch(r);
            }
          } else "NOOP" === n.code || t.dispatch("message", n);
        }
      });
    }, n.prototype.connect = function (e) {
      var t = this;
      this._ws = new WebSocket(e), this._ws.onopen = function () {
        t._logger.debug("websocket open"), t.dispatch("open");
      }, this._ws.onmessage = function (e) {
        return i(t, void 0, void 0, function () {
          var t,
            n,
            r = this;
          return o(this, function (s) {
            return (null === (n = this._sdkState.websocket) || void 0 === n ? void 0 : n.compression) ? e.data instanceof Blob ? ((t = new FileReader()).readAsArrayBuffer(e.data), t.onloadend = function () {
              return i(r, void 0, void 0, function () {
                var e;
                return o(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return [4, (r = t.result, i(void 0, void 0, void 0, function () {
                        var e;
                        return o(this, function (t) {
                          return e = Zr.ungzip(r), [2, String.fromCharCode.apply(null, e)];
                        });
                      }))];
                    case 1:
                      return e = n.sent(), this._handleMessage(e), [2];
                  }
                  var r;
                });
              });
            }) : "string" == typeof e.data && this._handleMessage(e.data) : this._handleMessage(e.data), [2];
          });
        });
      }, this._ws.onerror = function () {
        t._logger.debug("websocket error"), t.dispatch("error", E.networkError);
      }, this._ws.onclose = function () {
        t._logger.debug("websocket close"), t.dispatch("close");
      }, this.lastActive = Date.now();
    }, n.prototype.disconnect = function () {
      var e = this;
      return new Promise(function (t) {
        e._logger.debug("websocket disconnect"), e._ws && e.connectionState !== Vr.CLOSED ? (e._ws.onopen = Re, e._ws.onmessage = Re, e._ws.onerror = Re, e._ws.onclose = function () {
          e.dispatch("close"), t();
        }, e._ws.close(), e._ws = void 0) : t();
      });
    }, n.prototype.send = function (e) {
      if (!this._ws) throw E.connectionClosed;
      "PING" !== e.code ? this.dispatch("ping-refresh") : this._logger.debug("send ping", e), this._ws.send(e.convertToMessage());
    }, n.prototype.error = function (e) {
      this._logger.debug("websocket error", e), this.dispatch("error", e);
    }, n;
  }(W),
  Qr = function (e) {
    function n(t) {
      var n,
        r = t.code,
        i = t.ackRequired,
        o = t.payload,
        s = void 0 === o ? {} : o,
        a = this;
      return (a = e.call(this) || this).code = r, a.payload = s, a.requestId = null !== (n = a.payload.req_id) && void 0 !== n ? n : Z(), a.ackRequired = i, a.payload.req_id = a.requestId, a;
    }
    return t(n, e), n.prototype.convertToMessage = function () {
      return "".concat(this.code).concat(JSON.stringify(this.payload), "\n");
    }, n;
  }(Y),
  Yr = function (e) {
    function n(t) {
      var n = t.all,
        r = t.custom_types,
        i = t.ts,
        o = e.call(this) || this;
      return o.all = n, o.customTypes = r, o.ts = i, o;
    }
    return t(n, e), n;
  }(Y),
  Xr = function Xr() {
    var e = this;
    this.promise = new Promise(function (t, n) {
      e.resolve = t, e.reject = n;
    });
  },
  Jr = function () {
    function e(e, t) {
      var n = t.auth,
        r = t.sdkState,
        i = t.dispatcher,
        o = t.logger,
        s = t.useFetchCompat,
        a = void 0 !== s && s,
        c = this;
      this._ackStateMap = new Map(), this._sdkState = r, this._dispatcher = i, this._logger = o, this.apiClient = new Ae(e, {
        auth: n,
        sdkState: r,
        dispatcher: i,
        logger: o,
        useFetchCompat: a
      }), this.websocketClient = new Wr(e, {
        sdkState: r,
        dispatcher: i,
        logger: o
      }), this.websocketClient.on("message", function (e) {
        if (e.payload.unread_cnt && c._dispatcher.dispatch(new Yr(e.payload.unread_cnt)), e.requestId) {
          if (c._ackStateMap.has(e.requestId)) {
            var t = c._ackStateMap.get(e.requestId);
            "EROR" !== e.code ? t.resolve(e) : t.reject(new E({
              code: e.payload.code,
              message: e.payload.message
            }));
          }
        } else c._dispatcher.dispatch(e);
      }).on("close", function () {
        c._ackStateMap.forEach(function (e) {
          e.reject(E.connectionClosed);
        }), c._ackStateMap.clear();
      });
    }
    return e.prototype._sendApiRequest = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.apiClient.send(e)];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype._sendWebsocketRequest = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n,
          r,
          i = this;
        return o(this, function (o) {
          if (!this._sdkState.websocket) throw E.connectionRequired;
          if (t = new Xr(), e.ackRequired) {
            r = function r(_r0, o) {
              i._ackStateMap.has(e.requestId) && (i._ackStateMap.delete(e.requestId), n && (clearTimeout(n), n = null), _r0 ? (i._logger.debug("fail websocket request", _r0), t.reject(_r0)) : (i._logger.debug("receive websocket ack", e.requestId), t.resolve(o)));
            };
            try {
              n = setTimeout(function () {
                return r(E.noAckTimeout);
              }, this._sdkState.websocket.responseTimeout), this._ackStateMap.set(e.requestId, {
                resolve: function resolve(e) {
                  return r(void 0, e);
                },
                reject: function reject(e) {
                  return r(e);
                }
              }), this.websocketClient.send(e);
            } catch (e) {
              r(e);
            }
          } else try {
            this.websocketClient.send(e), t.resolve();
          } catch (e) {
            t.reject(e);
          }
          return [2, t.promise];
        });
      });
    }, e.prototype.send = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return e instanceof ye ? [4, this._sendApiRequest(e)] : [3, 2];
            case 1:
            case 3:
              return [2, t.sent()];
            case 2:
              return e instanceof Qr ? [4, this._sendWebsocketRequest(e)] : [3, 4];
            case 4:
              throw E.invalidParameters;
          }
        });
      });
    }, e.prototype.cancel = function (e) {
      this.apiClient.cancel(e);
    }, e.prototype.cancelAll = function () {
      this.apiClient.cancelAll();
    }, e;
  }();
!function (e) {
  e[e.NONE = 0] = "NONE", e[e.INITIALIZED = 1] = "INITIALIZED", e[e.CONNECTING = 2] = "CONNECTING", e[e.CONNECTED = 3] = "CONNECTED", e[e.RECONNECTING = 4] = "RECONNECTING", e[e.INTERNAL_DISCONNECTED = 5] = "INTERNAL_DISCONNECTED", e[e.EXTERNAL_DISCONNECTED = 6] = "EXTERNAL_DISCONNECTED", e[e.LOGOUT = 7] = "LOGOUT";
}(Hr || (Hr = {}));
var $r = function (e) {
    function n(t) {
      var n = t.stateType,
        r = e.call(this) || this;
      return r.stateType = n, r;
    }
    return t(n, e), n;
  }(Y),
  ei = function () {
    function e(e, t) {
      var n = t.auth,
        r = t.sdkState,
        s = t.dispatcher,
        a = t.logger,
        c = t.useFetchCompat,
        u = void 0 !== c && c,
        l = this;
      this._currentConnectionStateType = Hr.INITIALIZED, this._lazyCallQueue = [], this.commandRouter = new Jr(e, {
        auth: n,
        sdkState: r,
        dispatcher: s,
        logger: a,
        useFetchCompat: u
      }), this._auth = n, this._logger = a, this._dispatcher = s, this._dispatcher.on(function (e) {
        if (e instanceof $r) {
          var t = e.stateType;
          switch (l._currentConnectionStateType = t, t) {
            case Hr.CONNECTED:
              var n = l._lazyCallQueue;
              l._lazyCallQueue = [], n.forEach(function (e) {
                return i(l, void 0, void 0, function () {
                  var t, n, r, i, s;
                  return o(this, function (o) {
                    switch (o.label) {
                      case 0:
                        t = e.command, n = e.deferred, r = e.timeout, clearTimeout(r), o.label = 1;
                      case 1:
                        return o.trys.push([1, 3,, 4]), [4, this.send(t)];
                      case 2:
                        return i = o.sent(), n.resolve(i), [3, 4];
                      case 3:
                        return s = o.sent(), n.reject(s), [3, 4];
                      case 4:
                        return [2];
                    }
                  });
                });
              });
              break;
            case Hr.INITIALIZED:
            case Hr.INTERNAL_DISCONNECTED:
            case Hr.EXTERNAL_DISCONNECTED:
            case Hr.LOGOUT:
              n = l._lazyCallQueue;
              l._lazyCallQueue = [], n.forEach(function (e) {
                return i(l, void 0, void 0, function () {
                  var t, n;
                  return o(this, function (r) {
                    return t = e.deferred, n = e.timeout, clearTimeout(n), this._auth && this._auth.hasSession ? t.reject(E.connectionClosed) : t.reject(E.connectionRequired), [2];
                  });
                });
              });
          }
        }
      });
    }
    return Object.defineProperty(e.prototype, "isReady", {
      get: function get() {
        return this._currentConnectionStateType === Hr.CONNECTED;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isLazyCallActivated", {
      get: function get() {
        return this._currentConnectionStateType === Hr.CONNECTING || this._currentConnectionStateType === Hr.RECONNECTING;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.send = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n,
          r = this;
        return o(this, function (i) {
          switch (i.label) {
            case 0:
              return e instanceof Qr ? this.isReady ? (this._logger.debug("send websocket request", e), [4, this.commandRouter.send(e)]) : [3, 2] : [3, 4];
            case 1:
            case 5:
              return [2, i.sent()];
            case 2:
              if (this.isLazyCallActivated) return this._logger.debug("wait websocket request", e), t = new Xr(), this._lazyCallQueue.push({
                command: e,
                deferred: t,
                timeout: setTimeout(function () {
                  return r.timeout(e.requestId);
                }, 1e4)
              }), [2, t.promise];
              throw this._logger.debug("fail websocket request"), E.connectionRequired;
            case 3:
            case 7:
              return [3, 9];
            case 4:
              return e instanceof ye ? this._auth.hasSession ? (this._logger.debug("send api request", e), [4, this.commandRouter.send(e)]) : [3, 6] : [3, 8];
            case 6:
              if (this.isLazyCallActivated) return this._logger.debug("wait api request", e), t = new Xr(), this._lazyCallQueue.push({
                command: e,
                deferred: t,
                timeout: setTimeout(function () {
                  return r.timeout(e.requestId);
                }, 1e4)
              }), [2, t.promise];
              throw n = E.connectionRequired, this._logger.debug("fail api request", n), n;
            case 8:
              throw E.invalidCommand;
            case 9:
              return [2];
          }
        });
      });
    }, e.prototype.forceSend = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return this._logger.debug("send forced request", e), [4, this.commandRouter.send(e)];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.timeout = function (e) {
      this._logger.debug("timeout request", e);
      var t = this._lazyCallQueue.findIndex(function (t) {
        return t.command.requestId === e;
      });
      t > -1 && (this._lazyCallQueue[t].deferred.reject(E.connectionRequired), this._lazyCallQueue.splice(t, 1));
    }, e.prototype.cancel = function (e) {
      this._logger.debug("cancel api request", e), this.commandRouter.cancel(e);
    }, e.prototype.cancelAll = function () {
      this._logger.debug("cancel all api requests"), this.commandRouter.cancelAll();
    }, e;
  }(),
  ti = "sendbird@devicetokens",
  ni = function () {
    function e(e) {
      var t = e.type,
        n = e.token;
      this.type = t, this.token = n;
    }
    return e.payloadify = function (e) {
      return X(J({
        type: e.type,
        token: e.token
      }));
    }, e;
  }(),
  ri = function (e) {
    function n(t) {
      var n = t.userId,
        r = t.authToken,
        i = t.expiringSession,
        o = void 0 === i || i,
        s = e.call(this) || this;
      return s.path = "".concat(te, "/").concat(n, "/session_key"), s.method = $.POST, s.params = {
        token: r,
        expiring_session: !!o
      }, s.requireAuth = !1, s;
    }
    return t(n, e), n;
  }(ye),
  ii = function (e) {
    function n(t) {
      var n = t.authToken,
        r = t.expiringSession,
        i = void 0 === r || r,
        o = t.requestId,
        s = void 0 === o ? "" : o;
      return e.call(this, {
        code: "LOGI",
        payload: {
          token: n,
          expiring_session: i ? 1 : 0,
          req_id: s
        },
        ackRequired: !0
      }) || this;
    }
    return t(n, e), n;
  }(Qr),
  oi = function (e) {
    function n(t, n) {
      var r = e.call(this, t, n) || this,
        i = n.key;
      return r.key = i, r;
    }
    return t(n, e), n;
  }(we),
  si = function (e) {
    function n(t, n, r) {
      var i,
        o = this;
      return (o = e.call(this, t, "LOGI", r) || this).error = null, o.newKey = null, o.newKey = null !== (i = r.new_key) && void 0 !== i ? i : null, o.error = r.error ? new E(r.error) : null, o;
    }
    return t(n, e), n;
  }(Ne),
  ai = function (e) {
    function n() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return t(n, e), n;
  }(Y),
  ci = function ci(e) {
    return i(void 0, void 0, void 0, function () {
      return o(this, function (t) {
        return [2, new Promise(function (t) {
          return setTimeout(t, e);
        })];
      });
    });
  },
  ui = function () {
    function e() {}
    return e.prototype.calcTimeout = function () {
      return 0;
    }, e;
  }(),
  li = function li(e, t, n) {
    return void 0 === n && (n = new ui()), i(void 0, void 0, void 0, function () {
      var r, i, s, a, c, u;
      return o(this, function (o) {
        switch (o.label) {
          case 0:
            r = 0, i = null, s = function s(e) {
              return i = null != e ? e : new Error("Halted");
            }, a = function a() {
              r = 0;
            }, o.label = 1;
          case 1:
            if (!(-1 === t || r < t)) return [3, 9];
            o.label = 2;
          case 2:
            return o.trys.push([2, 4,, 8]), [4, e(s, a)];
          case 3:
            if (c = o.sent(), i) throw i;
            return [2, c];
          case 4:
            if (u = o.sent(), i) return [3, 6];
            if (++r === t) throw u;
            return [4, ci(n.calcTimeout(r))];
          case 5:
            return o.sent(), [3, 7];
          case 6:
            throw i;
          case 7:
            return [3, 8];
          case 8:
            return [3, 1];
          case 9:
            throw "It should not happen.";
        }
      });
    });
  },
  hi = function hi(e) {
    return i(void 0, void 0, void 0, function () {
      var t;
      return o(this, function (n) {
        switch (n.label) {
          case 0:
            return n.trys.push([0, 2,, 3]), [4, e()];
          case 1:
            return n.sent(), [3, 3];
          case 2:
            if (!((t = n.sent()) instanceof E)) throw t;
            return t.throwOutside(), [3, 3];
          case 3:
            return [2];
        }
      });
    });
  },
  di = function di(e) {
    return i(void 0, void 0, void 0, function () {
      return o(this, function (t) {
        switch (t.label) {
          case 0:
            return t.trys.push([0, 2,, 3]), [4, e()];
          case 1:
          case 2:
            return t.sent(), [3, 3];
          case 3:
            return [2];
        }
      });
    });
  },
  _i = new WeakMap(),
  fi = function (e) {
    function n(t) {
      var n = t.auth,
        r = t.cacheContext,
        i = t.sdkState,
        o = t.dispatcher,
        s = t.requestQueue,
        a = t.logger,
        c = e.call(this) || this;
      return c._currentConnectionStateType = Hr.INITIALIZED, c._isRefreshingAuthToken = !1, c._isRefreshingSessionKey = !1, c.currentUser = null, c.auth = n, c._cacheContext = r, c._sdkState = i, c._dispatcher = o, c._requestQueue = s, c._logger = a, c._deviceTokens = [], c._dispatcher.on(function (e) {
        var t;
        if (e instanceof $r) {
          var n = e.stateType;
          c._currentConnectionStateType = n;
        } else e instanceof ke && c.handler && (e.invalidateSessionToken && (c.auth.authToken = void 0), e.error && (e.error.isSessionKeyExpiredError || e.error.isSessionTokenExpiredError) && (c._logger.debug("session expired"), (null === (t = c.handler) || void 0 === t ? void 0 : t.onSessionExpired) && c.handler.onSessionExpired(), c.refresh()));
      }), c;
    }
    return t(n, e), Object.defineProperty(n.prototype, "ekey", {
      get: function get() {
        return _i.get(this);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "deviceTokens", {
      get: function get() {
        return this._deviceTokens;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "deviceTokenLastDeletedAt", {
      get: function get() {
        return this._deviceTokenLastDeletedAt;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.indexOfDeviceToken = function (e, t) {
      return this._deviceTokens.findIndex(function (n) {
        return n.type === e && n.token === t;
      });
    }, n.prototype.hasDeviceToken = function (e, t) {
      return this.indexOfDeviceToken(e, t) >= 0;
    }, n.prototype.createRefreshWebsocketCommand = function (e, t) {
      return new ii({
        authToken: e,
        expiringSession: !0,
        requestId: t
      });
    }, n.prototype._refreshSessionKeyByWebSocket = function (e) {
      return i(this, void 0, void 0, function () {
        var t, n, r, i, s;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return t = this.createRefreshWebsocketCommand(e), [4, this._requestQueue.forceSend(t)];
            case 1:
              if (n = o.sent(), r = n.as(si), i = r.newKey, s = r.error) throw s;
              return this.auth.sessionKey = null != i ? i : this.auth.sessionKey, [2];
          }
        });
      });
    }, n.prototype._refreshSessionKeyByApi = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n = this;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return t = new ri({
                userId: this._sdkState.userId,
                authToken: e,
                expiringSession: !0
              }), [4, li(function (e) {
                return i(n, void 0, void 0, function () {
                  var n, r, i;
                  return o(this, function (o) {
                    switch (o.label) {
                      case 0:
                        return o.trys.push([0, 2,, 3]), [4, this._requestQueue.forceSend(t)];
                      case 1:
                        return n = o.sent(), r = n.as(oi).key, this.auth.sessionKey = r, [3, 3];
                      case 2:
                        if (i = o.sent(), !this._isSessionRelatedError(i)) throw i;
                        return e(i), [3, 3];
                      case 3:
                        return [2];
                    }
                  });
                });
              }, 3)];
            case 1:
              return r.sent(), [2];
          }
        });
      });
    }, n.prototype._refreshSessionKey = function (e, t) {
      return void 0 === t && (t = !0), i(this, void 0, void 0, function () {
        var n, r, i;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              if (this._currentConnectionStateType !== Hr.CONNECTED) return [3, 10];
              o.label = 1;
            case 1:
              return o.trys.push([1, 3,, 10]), [4, this._refreshSessionKeyByWebSocket(e)];
            case 2:
              return o.sent(), this.complete(), [2];
            case 3:
              return n = o.sent(), this._isSessionRelatedError(n) && t ? [4, this._receiveNewAuthToken()] : [3, 9];
            case 4:
              return (i = o.sent()) ? (this.auth.authToken = i, [4, this._refreshSessionKey(this.auth.authToken, !1)]) : [3, 6];
            case 5:
              return o.sent(), this.complete(), [3, 8];
            case 6:
              return [4, this.clear()];
            case 7:
              o.sent(), this.close(), o.label = 8;
            case 8:
              return [2];
            case 9:
              return [3, 10];
            case 10:
              return o.trys.push([10, 12,, 22]), [4, this._refreshSessionKeyByApi(e)];
            case 11:
              return o.sent(), this.complete(), [3, 22];
            case 12:
              return r = o.sent(), this._isSessionRelatedError(r) ? t ? [4, this._receiveNewAuthToken()] : [3, 18] : [3, 20];
            case 13:
              return (i = o.sent()) ? (this.auth.authToken = i, [4, this._refreshSessionKeyByApi(this.auth.authToken)]) : [3, 15];
            case 14:
              return o.sent(), this.complete(), [3, 17];
            case 15:
              return [4, this.clear()];
            case 16:
              o.sent(), this.close(), o.label = 17;
            case 17:
              return [3, 19];
            case 18:
              throw r;
            case 19:
              return [3, 21];
            case 20:
              throw r;
            case 21:
              return [3, 22];
            case 22:
              return [2];
          }
        });
      });
    }, n.prototype._receiveNewAuthToken = function () {
      var e = this,
        t = new Xr();
      return hi(function () {
        return i(e, void 0, void 0, function () {
          var e,
            n,
            r = this;
          return o(this, function (i) {
            return this._isRefreshingAuthToken = !0, this.auth.clear(), e = null, n = function n() {
              e && (clearTimeout(e), e = null);
            }, e = setTimeout(function () {
              r._isRefreshingAuthToken = !1, t.reject();
            }, 1e3 * this._sdkState.sessionTokenRefreshTimeout), this.handler.onSessionTokenRequired ? this.handler.onSessionTokenRequired(function (e) {
              n(), r._isRefreshingAuthToken && (r._isRefreshingAuthToken = !1, r.dispatch("refresh-authtoken"), t.resolve(e));
            }, function (e) {
              n(), r._isRefreshingAuthToken = !1, t.reject(e);
            }) : t.resolve(null), [2];
          });
        });
      }), t.promise;
    }, n.prototype._isSessionRelatedError = function (e) {
      return e instanceof E && (e.isSessionKeyExpiredError || e.isSessionTokenExpiredError || e.isSessionRevokedError);
    }, Object.defineProperty(n.prototype, "isSessionKeyRefreshing", {
      get: function get() {
        return this._isRefreshingSessionKey;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "isRefreshingAuthToken", {
      get: function get() {
        return this._isRefreshingAuthToken;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.login = function (e) {
      var t;
      return i(this, void 0, void 0, function () {
        var n, r, i, s, a, c, u;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return n = e.key, r = e.ekey, i = e.userProfile, s = e.deviceTokenLastDeletedAt, a = void 0 === s ? 0 : s, this.auth.sessionKey = n, _i.set(this, r), this._deviceTokenCacheEnabled = null === (t = null == i ? void 0 : i.appInfo) || void 0 === t ? void 0 : t.deviceTokenCache, c = this._cacheContext.preference, this._deviceTokenCacheEnabled ? [4, c.get(ti)] : [3, 5];
            case 1:
              return !(u = o.sent()) || u.lastDeletedAt < a ? (this._deviceTokens = [], this._deviceTokenLastDeletedAt = a, [4, this.saveDeviceToken()]) : [3, 3];
            case 2:
              return o.sent(), [3, 4];
            case 3:
              this._deviceTokens = u.tokens.map(function (e) {
                return new ni(ni.payloadify(e));
              }), this._deviceTokenLastDeletedAt = u.lastDeletedAt, o.label = 4;
            case 4:
              return [3, 7];
            case 5:
              return [4, c.remove(ti)];
            case 6:
              o.sent(), o.label = 7;
            case 7:
              return [2];
          }
        });
      });
    }, n.prototype.complete = function () {
      var e = this;
      this.dispatch("refresh"), hi(function () {
        return i(e, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            return this._logger.debug("session refreshed"), (null === (e = this.handler) || void 0 === e ? void 0 : e.onSessionRefreshed) && this.handler.onSessionRefreshed(), [2];
          });
        });
      });
    }, n.prototype.error = function (e) {
      var t = this;
      hi(function () {
        return i(t, void 0, void 0, function () {
          var t;
          return o(this, function (n) {
            return (null === (t = this.handler) || void 0 === t ? void 0 : t.onSessionError) && this.handler.onSessionError(e), [2];
          });
        });
      });
    }, n.prototype.close = function () {
      var e = this;
      this.dispatch("close"), hi(function () {
        return i(e, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            return this._logger.debug("session closed"), (null === (e = this.handler) || void 0 === e ? void 0 : e.onSessionClosed) && this.handler.onSessionClosed(), [2];
          });
        });
      });
    }, n.prototype.refresh = function () {
      return i(this, void 0, void 0, function () {
        var e, t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              if (!this.handler) return [3, 10];
              if (this._isRefreshingSessionKey) return [3, 10];
              if (this._isRefreshingSessionKey = !0, this.auth.authToken) return [3, 7];
              n.label = 1;
            case 1:
              return n.trys.push([1, 6,, 7]), [4, this._receiveNewAuthToken()];
            case 2:
              return (e = n.sent()) ? (this._logger.debug("session refreshing.."), this.auth.authToken = e, [3, 5]) : [3, 3];
            case 3:
              return [4, this.clear()];
            case 4:
              return n.sent(), this._isRefreshingSessionKey = !1, [2];
            case 5:
              return [3, 7];
            case 6:
              throw n.sent(), t = E.sessionTokenRequestFailed, this._dispatcher.dispatch(new ai()), this.error(t), this._isRefreshingSessionKey = !1, t;
            case 7:
              return n.trys.push([7, 9,, 10]), [4, this._refreshSessionKey(this.auth.authToken)];
            case 8:
              return n.sent(), this._isRefreshingSessionKey = !1, [3, 10];
            case 9:
              throw n.sent(), t = E.sessionTokenRefreshFailed, this._dispatcher.dispatch(new ai()), this.error(t), this._isRefreshingSessionKey = !1, t;
            case 10:
              return [2];
          }
        });
      });
    }, n.prototype.setDeviceToken = function (e, t) {
      if (this._deviceTokenCacheEnabled && this.indexOfDeviceToken(e, t) < 0) return this._deviceTokens.push(new ni({
        type: e,
        token: t
      })), !0;
      return !1;
    }, n.prototype.unsetDeviceToken = function (e, t) {
      if (this._deviceTokenCacheEnabled) {
        var n = this.indexOfDeviceToken(e, t);
        n >= 0 && this._deviceTokens.splice(n, 1);
      }
    }, n.prototype.unsetDeviceTokens = function (e) {
      this._deviceTokenCacheEnabled && (this._deviceTokens = e ? this._deviceTokens.filter(function (t) {
        return t.type !== e;
      }) : []);
    }, n.prototype.setDeviceTokenDeletedAt = function (e) {
      e > 0 && (this._deviceTokenLastDeletedAt = e);
    }, n.prototype.saveDeviceToken = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return this._deviceTokenCacheEnabled ? [4, this._cacheContext.preference.set(ti, {
                tokens: this._deviceTokens,
                lastDeletedAt: this._deviceTokenLastDeletedAt
              })] : [3, 2];
            case 1:
              e.sent(), e.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, n.prototype.clear = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return this.currentUser = null, this.auth.clear(), this.close(), _i.delete(this), this._deviceTokens = [], this._deviceTokenLastDeletedAt = 0, [4, this.saveDeviceToken()];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, n;
  }(W),
  pi = function () {
    function e() {
      this.type = Hr.NONE, this.name = "none";
    }
    return e.prototype.run = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          return [2];
        });
      });
    }, e.prototype.onConnect = function (e, t) {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          return [2];
        });
      });
    }, e.prototype.onReconnect = function (e, t) {
      return t.resetReconnectCount, i(this, void 0, void 0, function () {
        return o(this, function (e) {
          return [2];
        });
      });
    }, e.prototype.onDisconnect = function (e, t) {
      return t.error, t.autoReconnect, i(this, void 0, void 0, function () {
        return o(this, function (e) {
          return [2];
        });
      });
    }, e.prototype.onDisconnectWebSocket = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          return [2];
        });
      });
    }, e.prototype.onLogout = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          return [2];
        });
      });
    }, e;
  }(),
  gi = function (e) {
    function n() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.type = Hr.LOGOUT, t.name = "logout", t;
    }
    return t(n, e), n.prototype.run = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n,
          r = this;
        return o(this, function (s) {
          switch (s.label) {
            case 0:
              return t = Date.now(), n = e.sdkState.userId, [4, e.logout()];
            case 1:
              return s.sent(), [4, e.changeState(new wi(), t)];
            case 2:
              return s.sent(), hi(function () {
                return i(r, void 0, void 0, function () {
                  return o(this, function (t) {
                    return e.connectionHandlers.forEach(function (e) {
                      e.onDisconnected && e.onDisconnected(n);
                    }), [2];
                  });
                });
              }), [2];
          }
        });
      });
    }, n;
  }(pi),
  vi = function (e) {
    function n() {
      var t = e.call(this) || this;
      return t.type = Hr.EXTERNAL_DISCONNECTED, t.name = "externaldisconnected", t;
    }
    return t(n, e), n.prototype.run = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, e.disconnect()];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, n.prototype.onConnect = function (e, t) {
      return i(this, void 0, void 0, function () {
        var n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return n = Date.now(), [4, e.disconnect()];
            case 1:
              return r.sent(), [4, e.changeState(new yi({
                authToken: t
              }), n)];
            case 2:
              return r.sent(), [2];
          }
        });
      });
    }, n.prototype.onReconnect = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new bi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onLogout = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new gi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n;
  }(pi),
  Ei = function (e) {
    function n(t) {
      var n = t.autoReconnect,
        r = e.call(this) || this;
      return r.type = Hr.INTERNAL_DISCONNECTED, r.name = "internaldisconnected", r._autoReconnect = !1, r._autoReconnect = n, r;
    }
    return t(n, e), n.prototype.run = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.disconnect()];
            case 1:
              return n.sent(), this._autoReconnect ? [4, e.changeState(new bi(), t)] : [3, 3];
            case 2:
              n.sent(), n.label = 3;
            case 3:
              return [2];
          }
        });
      });
    }, n.prototype.onConnect = function (e, t) {
      return i(this, void 0, void 0, function () {
        var n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return n = Date.now(), [4, e.disconnect()];
            case 1:
              return r.sent(), [4, e.changeState(new yi({
                authToken: t
              }), n)];
            case 2:
              return r.sent(), [2];
          }
        });
      });
    }, n.prototype.onReconnect = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new bi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onDisconnectWebSocket = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new vi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onLogout = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new gi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n;
  }(pi),
  bi = function (e) {
    function n() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.type = Hr.RECONNECTING, t.name = "reconnecting", t._callbacks = [], t;
    }
    return t(n, e), n.prototype._halt = function (e) {
      this._haltConnect && (this._haltConnect(e), this._haltConnect = void 0);
    }, n.prototype._flushCallbacks = function (e) {
      this._haltConnect = void 0, this._resetConnect = void 0, this._callbacks.forEach(function (t) {
        return t(e);
      });
    }, n.prototype.run = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n,
          r,
          s,
          a,
          c,
          l = this;
        return o(this, function (h) {
          switch (h.label) {
            case 0:
              t = Date.now(), n = new Xr(), this._callbacks.push(function (e) {
                return e ? n.reject(e) : n.resolve();
              }), hi(function () {
                return i(l, void 0, void 0, function () {
                  return o(this, function (t) {
                    return e.connectionHandlers.forEach(function (e) {
                      e.onReconnectStarted && e.onReconnectStarted();
                    }), [2];
                  });
                });
              }), h.label = 1;
            case 1:
              return h.trys.push([1, 4,, 9]), r = e.sdkState.websocket, s = r.reconnectMaxRetry, a = r.reconnectRetryStrategy, [4, li(function (t, n) {
                return i(l, void 0, void 0, function () {
                  var r;
                  return o(this, function (i) {
                    switch (i.label) {
                      case 0:
                        this._haltConnect = t, this._resetConnect = n, i.label = 1;
                      case 1:
                        return i.trys.push([1, 3,, 4]), [4, e.connect()];
                      case 2:
                        return i.sent(), [3, 4];
                      case 3:
                        if (r = i.sent(), e.clearLoginTimer(), r instanceof E && r.code === u.CONNECTION_CANCELED) return t(r), [2];
                        throw r;
                      case 4:
                        return [2];
                    }
                  });
                });
              }, s, a)];
            case 2:
              return h.sent(), [4, e.changeState(new mi(), t)];
            case 3:
              return h.sent(), hi(function () {
                return i(l, void 0, void 0, function () {
                  return o(this, function (t) {
                    return this._flushCallbacks(), e.connectionHandlers.forEach(function (e) {
                      e.onReconnectSucceeded && e.onReconnectSucceeded();
                    }), [2];
                  });
                });
              }), [3, 9];
            case 4:
              return c = h.sent(), v(c) ? [3, 7] : c instanceof E ? c.code === u.CONNECTION_CANCELED ? [3, 6] : [4, e.changeState(new Ei({
                autoReconnect: !1
              }), t)] : [3, 6];
            case 5:
              h.sent(), h.label = 6;
            case 6:
              return hi(function () {
                return i(l, void 0, void 0, function () {
                  return o(this, function (t) {
                    return this._flushCallbacks(c), e.connectionHandlers.forEach(function (e) {
                      e.onReconnectFailed && e.onReconnectFailed();
                    }), [2];
                  });
                });
              }), [3, 8];
            case 7:
              throw c;
            case 8:
              return [3, 9];
            case 9:
              return [2, n.promise];
          }
        });
      });
    }, n.prototype.onConnect = function (e, t) {
      return i(this, void 0, void 0, function () {
        var n;
        return o(this, function (r) {
          return n = new Xr(), this._halt(E.connectionCanceled), e.cancelConnectForRetry(), this._callbacks.push(function () {
            var r = Date.now();
            e.changeState(new yi({
              authToken: t
            }), r).then(function () {
              n.resolve();
            }).catch(function (e) {
              n.reject(e);
            });
          }), [2, n.promise];
        });
      });
    }, n.prototype.onReconnect = function (e, t) {
      var n = t.resetReconnectCount,
        r = void 0 !== n && n;
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          return e = new Xr(), this._resetConnect && r && this._resetConnect(), this._callbacks.push(function (t) {
            return t ? e.reject(t) : e.resolve();
          }), [2, e.promise];
        });
      });
    }, n.prototype.onDisconnect = function (e, t) {
      t.error;
      var n = t.autoReconnect,
        r = void 0 === n || n;
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), this._halt(E.connectionCanceled), [4, e.changeState(new Ei({
                autoReconnect: r
              }), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onDisconnectWebSocket = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), this._halt(E.connectionCanceled), [4, e.changeState(new vi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onLogout = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), this._halt(E.connectionCanceled), [4, e.changeState(new gi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n;
  }(pi),
  mi = function (e) {
    function n() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.type = Hr.CONNECTED, t.name = "connected", t;
    }
    return t(n, e), n.prototype.onReconnect = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.disconnect()];
            case 1:
              return n.sent(), [4, e.changeState(new bi(), t)];
            case 2:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onDisconnect = function (e, t) {
      var n = t.autoReconnect;
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new Ei({
                autoReconnect: n
              }), t)];
            case 1:
              return r.sent(), [2];
          }
        });
      });
    }, n.prototype.onDisconnectWebSocket = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new vi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n.prototype.onLogout = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), [4, e.changeState(new gi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n;
  }(pi),
  yi = function (e) {
    function n(t) {
      var n = t.authToken,
        r = e.call(this) || this;
      return r.type = Hr.CONNECTING, r.name = "connecting", r._authToken = "", r._callbacks = [], r._authToken = n, r;
    }
    return t(n, e), n.prototype._halt = function (e) {
      this._haltConnect && (this._haltConnect(e), this._haltConnect = void 0);
    }, n.prototype._flushCallbacks = function (e) {
      this._haltConnect = void 0, this._callbacks.forEach(function (t) {
        return t(e);
      });
    }, n.prototype.run = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n,
          r,
          s = this;
        return o(this, function (a) {
          switch (a.label) {
            case 0:
              t = Date.now(), n = new Xr(), this._callbacks.push(function (e) {
                return e ? n.reject(e) : n.resolve();
              }), a.label = 1;
            case 1:
              return a.trys.push([1, 4,, 10]), [4, li(function (t) {
                return i(s, void 0, void 0, function () {
                  var n;
                  return o(this, function (r) {
                    switch (r.label) {
                      case 0:
                        this._haltConnect = t, r.label = 1;
                      case 1:
                        return r.trys.push([1, 3,, 4]), [4, e.connect(this._authToken)];
                      case 2:
                        return r.sent(), [3, 4];
                      case 3:
                        if (n = r.sent(), e.clearLoginTimer(), n instanceof E && n.code === u.CONNECTION_CANCELED) return t(n), [2];
                        throw n;
                      case 4:
                        return [2];
                    }
                  });
                });
              }, e.sdkState.websocket.connectMaxRetry)];
            case 2:
              return a.sent(), [4, e.changeState(new mi(), t)];
            case 3:
              return a.sent(), hi(function () {
                return i(s, void 0, void 0, function () {
                  return o(this, function (t) {
                    return this._flushCallbacks(), e.connectionHandlers.forEach(function (t) {
                      t.onConnected && t.onConnected(e.sdkState.userId);
                    }), [2];
                  });
                });
              }), [3, 10];
            case 4:
              return r = a.sent(), v(r) ? [3, 8] : [4, e.disconnect()];
            case 5:
              return a.sent(), r instanceof E ? r.code === u.CONNECTION_CANCELED ? [3, 7] : [4, e.changeState(new wi(), t)] : [3, 7];
            case 6:
              a.sent(), a.label = 7;
            case 7:
              return hi(function () {
                return i(s, void 0, void 0, function () {
                  return o(this, function (e) {
                    return this._flushCallbacks(r), [2];
                  });
                });
              }), [3, 9];
            case 8:
              throw r;
            case 9:
              return [3, 10];
            case 10:
              return [2, n.promise];
          }
        });
      });
    }, n.prototype.onConnect = function (e) {
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          return e = new Xr(), this._callbacks.push(function (t) {
            return t ? e.reject(t) : e.resolve();
          }), [2, e.promise];
        });
      });
    }, n.prototype.onDisconnect = function (e, t) {
      var n = t.error,
        r = void 0 === n ? null : n,
        s = t.autoReconnect,
        a = void 0 !== s && s;
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), this._halt(null != r ? r : E.connectionCanceled), e.hasSession ? [4, e.changeState(new Ei({
                autoReconnect: a
              }), t)] : [3, 2];
            case 1:
              return n.sent(), [3, 4];
            case 2:
              return [4, e.changeState(new gi(), t)];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return [2];
          }
        });
      });
    }, n.prototype.onDisconnectWebSocket = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), this._halt(E.connectionCanceled), e.hasSession ? [4, e.changeState(new vi(), t)] : [3, 2];
            case 1:
              return n.sent(), [3, 4];
            case 2:
              return [4, e.changeState(new gi(), t)];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return [2];
          }
        });
      });
    }, n.prototype.onLogout = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = Date.now(), this._halt(E.connectionCanceled), [4, e.changeState(new gi(), t)];
            case 1:
              return n.sent(), [2];
          }
        });
      });
    }, n;
  }(pi),
  wi = function (e) {
    function n() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.type = Hr.INITIALIZED, t.name = "initialized", t;
    }
    return t(n, e), n.prototype.onConnect = function (e, t) {
      return i(this, void 0, void 0, function () {
        var n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return n = Date.now(), [4, e.changeState(new yi({
                authToken: t
              }), n)];
            case 1:
              return r.sent(), [2];
          }
        });
      });
    }, n;
  }(pi),
  Si = function (e) {
    function n() {
      return e.call(this, {
        code: "PING",
        payload: {
          id: Date.now(),
          active: 1
        },
        ackRequired: !1
      }) || this;
    }
    return t(n, e), n;
  }(Qr),
  ki = function () {
    function e(e) {
      var t = e.pingDelegate,
        n = e.sdkState,
        r = e.logger;
      this.pingDelegate = t, this.sdkState = n, this._logger = r;
    }
    return Object.defineProperty(e.prototype, "isWaiting", {
      get: function get() {
        return !!this._pingTimeoutTimer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.ping = function () {
      var e,
        t = this;
      if (!this.sdkState.websocket) throw E.connectionRequired;
      var n = new Si();
      try {
        var r = null !== (e = this.sdkState.websocket.pongTimeout) && void 0 !== e ? e : 5e3;
        this._pingTimeoutTimer = setTimeout(function () {
          t._logger.debug("pinger.ping() timeout"), t.pingDelegate.error();
        }, r), this.pingDelegate.send(n), this._logger.debug("pinger.ping()");
      } catch (e) {
        this._logger.debug("pinger.ping() error", e), this._pingTimeoutTimer && (clearTimeout(this._pingTimeoutTimer), this._pingTimeoutTimer = void 0), this.pingDelegate.error();
      }
      return n;
    }, e.prototype.pong = function () {
      this._logger.debug("pinger.pong()"), this._pingTimeoutTimer && (clearTimeout(this._pingTimeoutTimer), this._pingTimeoutTimer = void 0);
    }, e.prototype.refreshTimer = function () {
      var e,
        t = this;
      if (!this.sdkState.websocket) throw E.connectionRequired;
      this._logger.debug("pinger.refreshTimer()");
      var n = null !== (e = this.sdkState.websocket.pingInterval) && void 0 !== e ? e : 15e3;
      this.stop(), this._pingTimer = setInterval(function () {
        t.ping();
      }, n);
    }, e.prototype.start = function () {
      this._logger.debug("pinger.start()"), this.refreshTimer(), this.ping();
    }, e.prototype.stop = function () {
      this._logger.debug("pinger.stop()"), this._pingTimer && (clearInterval(this._pingTimer), this._pingTimer = void 0), this._pingTimeoutTimer && (clearTimeout(this._pingTimeoutTimer), this._pingTimeoutTimer = void 0);
    }, e;
  }(),
  Ti = function () {
    function e(e) {
      var t;
      this.lastUpdatedAt = null !== (t = e.last_updated_at) && void 0 !== t ? t : 0;
    }
    return e.payloadify = function (e) {
      return X(J({
        last_updated_at: e.lastUpdatedAt
      }));
    }, e;
  }(),
  Ci = 1048576,
  Oi = 5,
  Ai = function () {
    function e(e) {
      var t, n, r, i, o;
      void 0 === e && (e = {}), this.emojiHash = e.emoji_hash || "", this.uploadSizeLimit = e.file_upload_size_limit ? e.file_upload_size_limit * Ci : Number.MAX_SAFE_INTEGER, this.useReaction = !!e.use_reaction, this.applicationAttributes = null !== (t = e.application_attributes) && void 0 !== t ? t : [], this.premiumFeatureList = null !== (n = e.premium_feature_list) && void 0 !== n ? n : [], this.deviceTokenCache = this.applicationAttributes.includes("sdk_device_token_cache"), this.enabledChannelMemberShipHistory = this.applicationAttributes.includes("channel_membership_history"), this.multipleFilesMessageFileCountLimit = null !== (r = e.multiple_file_send_max_size) && void 0 !== r ? r : 5, this.allowSdkStatsUpload = null === (i = e.allow_sdk_log_ingestion) || void 0 === i || i, this.uikitConfigInfo = new Ti(null !== (o = e.uikit_config) && void 0 !== o ? o : {});
    }
    return e.payloadify = function (e) {
      return X(J({
        emoji_hash: e.emojiHash,
        file_upload_size_limit: e.uploadSizeLimit / Ci,
        application_attributes: e.applicationAttributes,
        premium_feature_list: e.premiumFeatureList,
        use_reaction: e.useReaction,
        allow_sdk_log_ingestion: e.allowSdkStatsUpload,
        uikit_config: e.uikitConfigInfo ? Ti.payloadify(e.uikitConfigInfo) : null
      }));
    }, e;
  }(),
  Ni = function () {
    function e(e) {
      this._iid = "", this._iid = e;
    }
    return e.payloadify = function (e) {
      return {};
    }, e;
  }(),
  Ri = function (e) {
    function n(t) {
      var n = t.userId,
        r = t.metadata,
        i = e.call(this) || this;
      return i.method = $.POST, i.path = "".concat(te, "/").concat(n, "/metadata"), i.params = {
        metadata: r
      }, i;
    }
    return t(n, e), n;
  }(ye),
  Ii = function (e) {
    function n(t, n) {
      var r = e.call(this, t, n) || this;
      return r.metaData = n, r;
    }
    return t(n, e), n;
  }(we),
  Di = function (e) {
    function n(t) {
      var n = t.userId,
        r = t.metadata,
        i = t.upsert,
        o = e.call(this) || this;
      return o.method = $.PUT, o.path = "".concat(te, "/").concat(n, "/metadata"), o.params = {
        metadata: r,
        upsert: i
      }, o;
    }
    return t(n, e), n;
  }(ye),
  Li = function (e) {
    function n(t, n) {
      var r = e.call(this, t, n) || this;
      return r.metadata = n, r;
    }
    return t(n, e), n;
  }(we),
  xi = function (e) {
    function n(t) {
      var n = t.userId,
        r = t.metadataKey,
        i = e.call(this) || this;
      return i.method = $.DELETE, i.path = "".concat(te, "/").concat(n, "/metadata/").concat(r), i;
    }
    return t(n, e), n;
  }(ye);
!function (e) {
  function n() {
    return null !== e && e.apply(this, arguments) || this;
  }
  t(n, e);
}(we);
var Mi = function (e) {
  function n(t) {
    var n = t.userId,
      r = e.call(this) || this;
    return r.method = $.DELETE, r.path = "".concat(te, "/").concat(n, "/metadata"), r;
  }
  return t(n, e), n;
}(ye);
!function (e) {
  function n() {
    return null !== e && e.apply(this, arguments) || this;
  }
  t(n, e);
}(we);
var Pi,
  Ui = function Ui(e, t) {
    var n = JSON.parse(JSON.stringify(e));
    return n._iid && delete n._iid, t && t(n), n;
  },
  zi = function zi(e, t) {
    var n = JSON.parse(JSON.stringify(e));
    return t && t(n), n;
  },
  Fi = function Fi(e) {
    return {
      do: function _do(t) {
        e || t();
      },
      throw: function _throw(t) {
        if (!e) throw t;
      }
    };
  };
!function (e) {
  e.ONLINE = "online", e.OFFLINE = "offline", e.NON_AVAILABLE = "nonavailable";
}(Pi || (Pi = {}));
var qi,
  Gi = function (e) {
    function r(t, n) {
      var r,
        i,
        o,
        s,
        u,
        l,
        h,
        d,
        _,
        f,
        p,
        g,
        v = this;
      return (v = e.call(this, t) || this).userId = null !== (i = null !== (r = n.guest_id) && void 0 !== r ? r : n.user_id) && void 0 !== i ? i : "", v.nickname = null !== (s = null !== (o = n.nickname) && void 0 !== o ? o : n.name) && void 0 !== s ? s : "", v.plainProfileUrl = null !== (l = null !== (u = n.profile_url) && void 0 !== u ? u : n.image) && void 0 !== l ? l : "", v.requireAuth = null !== (h = n.require_auth_for_profile_image) && void 0 !== h && h, v.metaData = null !== (d = n.metadata) && void 0 !== d ? d : {}, v.connectionStatus = Pi.NON_AVAILABLE, S(Pi, n.is_online) ? v.connectionStatus = n.is_online : w("boolean", n.is_online) && (v.connectionStatus = n.is_online ? Pi.ONLINE : Pi.OFFLINE), v.isActive = null === (_ = n.is_active) || void 0 === _ || _, v.lastSeenAt = null !== (f = n.last_seen_at) && void 0 !== f ? f : null, v.preferredLanguages = n.preferred_languages ? c([], a(n.preferred_languages), !1) : null, v.friendDiscoveryKey = null !== (p = n.friend_discovery_key) && void 0 !== p ? p : null, v.friendName = null !== (g = n.friend_name) && void 0 !== g ? g : null, v;
    }
    return t(r, e), r.payloadify = function (t) {
      return X(J(_n2(_n2({}, e.payloadify.call(this, t)), {
        user_id: t.userId,
        nickname: t.nickname,
        profile_url: t.plainProfileUrl,
        require_auth_for_profile_image: t.requireAuth,
        metadata: t.metaData,
        is_online: t.connectionStatus,
        is_active: t.isActive,
        last_seen_at: t.lastSeenAt,
        preferred_languages: t.preferredLanguages,
        friend_discovery_key: t.friendDiscoveryKey,
        friend_name: t.friendName
      })));
    }, Object.defineProperty(r.prototype, "profileUrl", {
      get: function get() {
        var e = no.of(this._iid).sessionManager;
        return this.requireAuth ? "".concat(this.plainProfileUrl, "?auth=").concat(e.ekey) : this.plainProfileUrl;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.serialize = function () {
      return Ui(this);
    }, r.prototype._isValidMetaData = function (e) {
      return !Array.isArray(e) && Object.keys(e).length > 0 && Object.keys(e).map(function (t) {
        return e[t];
      }).every(function (e) {
        return w("string", e);
      });
    }, r.prototype._applyMetaData = function (e, t) {
      var n = this;
      void 0 === t && (t = !1), Object.keys(e).forEach(function (r) {
        t ? delete n.metaData[r] : n.metaData[r] = e[r];
      });
    }, r.prototype.createMetaData = function (e) {
      return i(this, void 0, void 0, function () {
        var t, n, r, i, s, a;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return Fi(this._isValidMetaData(e)).throw(E.invalidParameters), t = no.of(this._iid), n = t.sdkState, r = t.requestQueue, i = new Ri({
                userId: n.userId,
                metadata: e
              }), [4, r.send(i)];
            case 1:
              return s = o.sent(), a = s.as(Ii).metaData, this._applyMetaData(a), [2, this.metaData];
          }
        });
      });
    }, r.prototype.updateMetaData = function (e, t) {
      return void 0 === t && (t = !1), i(this, void 0, void 0, function () {
        var n, r, i, s, a, c;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return Fi(this._isValidMetaData(e)).throw(E.invalidParameters), n = no.of(this._iid), r = n.sdkState, i = n.requestQueue, s = new Di({
                userId: r.userId,
                metadata: e,
                upsert: t
              }), [4, i.send(s)];
            case 1:
              return a = o.sent(), c = a.as(Li).metadata, this._applyMetaData(c), [2, this.metaData];
          }
        });
      });
    }, r.prototype.deleteMetaData = function (e) {
      return i(this, void 0, void 0, function () {
        var t, n, r, i, s;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return Fi(w("string", e)).throw(E.invalidParameters), t = no.of(this._iid), n = t.sdkState, r = t.requestQueue, i = new xi({
                userId: n.userId,
                metadataKey: e
              }), [4, r.send(i)];
            case 1:
              return o.sent(), this._applyMetaData(((s = {})[e] = !0, s), !0), [2, this.metaData];
          }
        });
      });
    }, r.prototype.deleteAllMetaData = function () {
      return i(this, void 0, void 0, function () {
        var e, t, n, r;
        return o(this, function (i) {
          switch (i.label) {
            case 0:
              return e = no.of(this._iid), t = e.sdkState, n = e.requestQueue, r = new Mi({
                userId: t.userId
              }), [4, n.send(r)];
            case 1:
              return i.sent(), this.metaData = {}, [2];
          }
        });
      });
    }, r;
  }(Ni),
  ji = function (e) {
    function n(t) {
      var n = t.userProfile,
        r = e.call(this) || this;
      return r.userProfile = n, r;
    }
    return t(n, e), n;
  }(Y),
  Ki = function () {
    function e(e, t) {
      var n, r, i, o, s, a, c, u, l, h, d, _, f, p;
      this._iid = e, this.appInfo = new Ai(t), this.user = new Gi(e, t), this.connectedAt = null !== (n = t.login_ts) && void 0 !== n ? n : 0, this.firstConnectedAt = 0, this.pingInterval = null !== (r = t.ping_interval) && void 0 !== r ? r : 15e3, this.pongTimeout = null !== (i = t.pong_timeout) && void 0 !== i ? i : 5e3, this.reconnectInterval = null !== (s = null === (o = t.reconnect) || void 0 === o ? void 0 : o.interval) && void 0 !== s ? s : 3e3, this.reconnectMaxInterval = null !== (c = null === (a = t.reconnect) || void 0 === a ? void 0 : a.max_interval) && void 0 !== c ? c : 6e4, this.reconnectRetryCount = null !== (l = null === (u = t.reconnect) || void 0 === u ? void 0 : u.retry_cnt) && void 0 !== l ? l : 5, this.reconnectIntervalMultiple = null !== (d = null === (h = t.reconnect) || void 0 === h ? void 0 : h.mul) && void 0 !== d ? d : 2, this.maxUnreadCountOnSuperGroup = null !== (_ = t.max_unread_cnt_on_super_group) && void 0 !== _ ? _ : 100, this.profileImageEncryption = !!t.profile_image_encryption, this.concurrentCallLimit = null !== (f = t.concurrent_call_limit) && void 0 !== f ? f : 5, this.backOffDelay = null !== (p = t.back_off_delay) && void 0 !== p ? p : 100;
    }
    return e.payloadify = function (e) {
      return X(J(_n2(_n2(_n2({}, Gi.payloadify(e.user)), Ai.payloadify(e.appInfo)), {
        login_ts: e.connectedAt,
        ping_interval: e.pingInterval,
        pong_timeout: e.pongTimeout,
        reconnect: {
          interval: e.reconnectInterval,
          max_interval: e.reconnectMaxInterval,
          retry_cnt: e.reconnectRetryCount,
          mul: e.reconnectIntervalMultiple
        },
        max_unread_cnt_on_super_group: e.maxUnreadCountOnSuperGroup,
        profile_image_encryption: e.profileImageEncryption,
        concurrent_call_limit: e.concurrentCallLimit,
        back_off_delay: e.backOffDelay
      })));
    }, e.prototype.apply = function () {
      var e = this.reconnectInterval,
        t = this.reconnectMaxInterval,
        n = this.reconnectIntervalMultiple,
        r = no.of(this._iid);
      r.sdkState.websocket && (r.sdkState.websocket.pingInterval = 1e3 * this.pingInterval, r.sdkState.websocket.pongTimeout = 1e3 * this.pongTimeout, r.sdkState.websocket.reconnectMaxRetry = this.reconnectRetryCount, r.sdkState.websocket.reconnectRetryStrategy = {
        calcTimeout: function calcTimeout(r) {
          return r > 0 ? 1e3 * Math.min(e * Math.pow(n, r - 1), t) : 10;
        }
      }), r.appInfo = this.appInfo, r.sessionManager.currentUser = this.user, r.connectedAt = this.connectedAt, this.firstConnectedAt || (r.firstConnectedAt = this.connectedAt), r.maxSuperGroupChannelUnreadCount = this.maxUnreadCountOnSuperGroup, r.concurrentCallLimit = this.concurrentCallLimit, r.backOffDelay = this.backOffDelay, r.dispatcher.dispatch(new ji({
        userProfile: this
      }));
    }, e;
  }(),
  Bi = function (e) {
    function r(t, n, r) {
      var i,
        o,
        s,
        a = this;
      return (a = e.call(this, t, n, r) || this).error = null, a.userProfile = new Ki(t, r), a.deviceTokenLastDeletedAt = null !== (i = r.device_token_last_deleted_at) && void 0 !== i ? i : 0, a.key = null !== (o = r.key) && void 0 !== o ? o : "", a.ekey = null !== (s = r.ekey) && void 0 !== s ? s : "", a.error = r.error ? new E(r) : null, a;
    }
    return t(r, e), r.asError = function (e) {
      return new r("", "LOGI", _n2({
        user_id: "",
        error: !0
      }, e));
    }, r.prototype.applyTo = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return this.error ? [3, 4] : (t = no.of(e)) ? [4, t.sessionManager.login(this)] : [3, 2];
            case 1:
              return n.sent(), this.userProfile.apply(), [3, 3];
            case 2:
              throw E.lostInstance;
            case 3:
              return [3, 5];
            case 4:
              throw this.error;
            case 5:
              return [2];
          }
        });
      });
    }, r;
  }(Ne),
  Vi = function (e) {
    function r(t) {
      var r = t.request,
        i = void 0 === r || r,
        o = t.features,
        s = void 0 === o ? {} : o,
        a = t.options,
        c = void 0 === a ? {} : a,
        u = e.call(this) || this;
      return u.request = i, u.features = _n2({
        localCache: !0
      }, s), u.options = _n2({
        ingestion: !0
      }, c), u;
    }
    return t(r, e), r;
  }(Y),
  Zi = function (e) {
    function n(t, n) {
      var r,
        i = n.sdkState,
        o = n.cacheContext,
        s = n.connectionHandlers,
        a = n.sessionManager,
        c = n.websocketClient,
        u = n.dispatcher,
        l = n.logger,
        h = n.entryState,
        d = void 0 === h ? new wi() : h,
        _ = this;
      return (_ = e.call(this) || this)._stateUpdatedAt = 0, _._connectingAt = 0, _._connectionRequestQueue = [], _._iid = t, _.sdkState = i, _.cacheContext = o, _.connectionHandlers = s, _._sessionManager = a, _._websocketClient = c, _._dispatcher = u, _._logger = l, _._currentState = d, (null === (r = _.sdkState.websocket) || void 0 === r ? void 0 : r.pingerDisabled) || (_._pinger = new ki({
        pingDelegate: {
          send: function send(e) {
            return _._websocketClient.send(e);
          },
          error: function error(e) {
            return _._websocketClient.error(e);
          }
        },
        sdkState: _.sdkState,
        logger: l
      })), _._websocketClient.on("open", function () {
        _._tryResolveConnectionRequest();
      }).on("message", function (e) {
        if ("LOGI" === e.code) _.clearLoginTimer(), _._dispatcher.dispatch(e.as(Bi));
      }).on("ping-refresh", function () {
        var e;
        return null === (e = _._pinger) || void 0 === e ? void 0 : e.refreshTimer();
      }).on("pong", function () {
        var e;
        return null === (e = _._pinger) || void 0 === e ? void 0 : e.pong();
      }).on("error", function () {
        var e;
        return null === (e = _._pinger) || void 0 === e ? void 0 : e.stop();
      }).on("close", function () {
        _._logiProcessingTimer = setTimeout(function () {
          _._logiProcessingTimer = void 0, _._unresolvedLogi || _._rejectConnectionRequest(E.networkError);
        }, 500);
      }), _._dispatcher.on(function (e) {
        e instanceof Bi && (_._unresolvedLogi = e, _._tryResolveConnectionRequest());
      }), _;
    }
    return t(n, e), Object.defineProperty(n.prototype, "currentState", {
      get: function get() {
        return this._currentState;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "hasSession", {
      get: function get() {
        return this._sessionManager.auth.hasSession;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.changeState = function (e, t) {
      return i(this, void 0, void 0, function () {
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t >= this._stateUpdatedAt ? (this._currentState = e, this._stateUpdatedAt = t, this._dispatcher.dispatch(new $r({
                stateType: e.type
              })), this._logger.debug("connection state changes to ".concat(e.name)), [4, this._currentState.run(this)]) : [3, 2];
            case 1:
              return n.sent(), [2, !0];
            case 2:
              return [2, !1];
          }
        });
      });
    }, n.prototype._tryResolveConnectionRequest = function () {
      var e;
      return i(this, void 0, void 0, function () {
        var t, n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return t = this._unresolvedLogi, this._websocketClient.isOpen && t ? (this._unresolvedLogi = void 0, t.error ? [3, 2] : [4, t.applyTo(this._iid)]) : [3, 3];
            case 1:
              return r.sent(), n = t.userProfile, this._enableStatLog({
                request: n.appInfo.applicationAttributes.includes("allow_sdk_request_log_publish"),
                features: {
                  localCache: n.appInfo.applicationAttributes.includes("allow_sdk_feature_local_cache_log_publish")
                },
                options: {
                  ingestion: n.appInfo.allowSdkStatsUpload
                }
              }), this._statLogConnection(), null === (e = this._pinger) || void 0 === e || e.start(), this._connectionRequestQueue.forEach(function (e) {
                return e.resolve();
              }), this._connectionRequestQueue = [], this.sdkState.appState = "foreground", [3, 3];
            case 2:
              this._sessionManager.auth.authToken = void 0, (t.error.isSessionKeyExpiredError || t.error.isSessionTokenExpiredError) && this._dispatcher.dispatch(new ke({
                reason: t.error.code
              })), this._rejectConnectionRequest(t.error), r.label = 3;
            case 3:
              return [2];
          }
        });
      });
    }, n.prototype._rejectConnectionRequest = function (e) {
      var t;
      if (null === (t = this._pinger) || void 0 === t || t.stop(), this.clearLoginTimer(), this._connectionRequestQueue.length > 0) {
        var n = this._connectionRequestQueue;
        this._connectionRequestQueue = [], n.forEach(function (t) {
          return t.reject(e);
        }), this._statLogConnection(e);
      }
    }, n.prototype._url = function (e) {
      var t, n, r;
      void 0 === e && (e = "");
      var i = this.sdkState,
        o = i.appId,
        s = i.appVersion,
        a = i.userId;
      i.extensions;
      var c = this.cacheContext.localCacheEnabled,
        u = this._sessionManager.auth,
        l = null === (t = this.sdkState.websocket) || void 0 === t ? void 0 : t.compression,
        d = null !== (n = this.sdkState.extensions) && void 0 !== n ? n : {},
        _ = !!d.sb_uikit,
        f = d.sb_syncmanager ? "s".concat(d.sb_syncmanager) : "",
        p = d.sb_uikit ? "u".concat(d.sb_uikit) : "",
        g = "JS/c".concat(h.SDK_VERSION, "/").concat(f, "/").concat(p);
      return "".concat(null === (r = this.sdkState.websocket) || void 0 === r ? void 0 : r.host, "/?p=JS&pv=").concat(encodeURIComponent(h.OS_VERSION), "&sv=").concat(encodeURIComponent(h.SDK_VERSION), "&ai=").concat(o).concat(s ? "&av=".concat(s) : "").concat(u.hasSession ? "&key=".concat(encodeURIComponent(u.sessionKey)) : "&user_id=".concat(encodeURIComponent(a), "&access_token=").concat(encodeURIComponent(e)), "&pmce=").concat(l ? 1 : 0, "&active=1&device_token_types=").concat(encodeURIComponent(["gcm", "huawei", "apns"].join(",")), "&SB-User-Agent=").concat(g, "&Request-Sent-Timestamp=").concat(Date.now().toString(), "&include_extra_data=").concat(encodeURIComponent(String(["premium_feature_list", "file_upload_size_limit", "application_attributes", "emoji_hash", "multiple_file_send_max_size"]))).concat(this._sessionManager.handler ? "&expiring_session=1" : "", "&use_local_cache=").concat(c ? 1 : 0, "&include_poll_details=1").concat(_ ? "&uikit_config=1" : "");
    }, n.prototype._enableStatLog = function (e) {
      var t = e.request,
        n = e.features,
        r = e.options,
        i = void 0 === r ? {} : r;
      this._dispatcher.dispatch(new Vi({
        request: t,
        features: n,
        options: i
      }));
    }, n.prototype._statLogConnection = function (e) {
      var t;
      this._dispatcher.dispatch(new Te(new Ce({
        type: me.WEBSOCKET_CONNECT,
        data: {
          host_url: null === (t = this.sdkState.websocket) || void 0 === t ? void 0 : t.host,
          success: !e,
          latency: Date.now() - this._connectingAt,
          error_code: null == e ? void 0 : e.code,
          error_description: null == e ? void 0 : e.message
        }
      })));
    }, n.prototype.connect = function (e) {
      var t;
      return void 0 === e && (e = ""), i(this, void 0, void 0, function () {
        var n,
          r,
          i = this;
        return o(this, function (o) {
          return this._logiProcessingTimer && (clearTimeout(this._logiProcessingTimer), this._logiProcessingTimer = void 0, this._rejectConnectionRequest(E.connectionCanceled)), n = this._url(e), r = new Xr(), this._connectionRequestQueue.push(r), 1 === this._connectionRequestQueue.length && (this._connectingAt = Date.now(), this._loginTimer = setTimeout(function () {
            i._loginTimer = void 0, i._rejectConnectionRequest(E.loginTimeout);
          }, null === (t = this.sdkState.websocket) || void 0 === t ? void 0 : t.responseTimeout), e && (this._sessionManager.auth.authToken = e), this._websocketClient.connect(n)), [2, r.promise];
        });
      });
    }, n.prototype.cancelConnectForRetry = function () {
      this._dispatcher.dispatch(Bi.asError(E.connectionRenew));
    }, n.prototype.disconnect = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this._websocketClient.disconnect()];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, n.prototype.logout = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return this.sdkState.userId = void 0, this._unresolvedLogi = void 0, [4, this._sessionManager.clear()];
            case 1:
              return e.sent(), [4, this.disconnect()];
            case 2:
              return e.sent(), [2];
          }
        });
      });
    }, n.prototype.clearLoginTimer = function () {
      this._loginTimer && (clearTimeout(this._loginTimer), this._loginTimer = void 0);
    }, n;
  }(W),
  Hi = function () {
    function e(e, t) {
      var n = t.sdkState,
        r = t.cacheContext,
        i = t.connectionHandlers,
        o = t.sessionManager,
        s = t.websocketClient,
        a = t.dispatcher,
        c = t.logger,
        u = t.disableWebSocketCloseEventHandling,
        l = void 0 !== u && u;
      this._disableWebSocketCloseEventHandling = !1, this._externalCalledWebSocketClose = !1, this._logger = c, this._disableWebSocketCloseEventHandling = l, this._context = new Zi(e, {
        sdkState: n,
        cacheContext: r,
        connectionHandlers: i,
        sessionManager: o,
        websocketClient: s,
        dispatcher: a,
        logger: c
      }), this._sdkState = n, this._sessionManager = o, this._websocketClient = s;
    }
    return e.prototype._registerEventDispatcher = function () {
      var e = this;
      this._disableWebSocketCloseEventHandling || (this._clearEventDispatcher(), this._sessionEventDispatcherContext = this._sessionManager.on("refresh-authtoken", function () {
        e.isConnected || (e._logger.debug("try reconnect by session token refresh"), e.reconnect());
      }).on("refresh", function () {
        e.isConnecting || e.isConnected || (e._logger.debug("try reconnect by session key refresh"), e.reconnect());
      }), this._websocketEventDispatcherContext = this._websocketClient.on("close", function () {
        "foreground" !== e._sdkState.appState || e._externalCalledWebSocketClose || e._sessionManager.isRefreshingAuthToken || (e._logger.debug("try reconnect by websocket connection closed"), e.reconnect());
      }));
    }, e.prototype._clearEventDispatcher = function () {
      this._sessionEventDispatcherContext && (this._sessionEventDispatcherContext.close(), this._sessionEventDispatcherContext = void 0), this._websocketEventDispatcherContext && (this._websocketEventDispatcherContext.close(), this._websocketEventDispatcherContext = void 0);
    }, Object.defineProperty(e.prototype, "isConnected", {
      get: function get() {
        return this._context.currentState.type === Hr.CONNECTED;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isConnecting", {
      get: function get() {
        var e = this._context.currentState;
        return e.type === Hr.CONNECTING || e.type === Hr.RECONNECTING;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connect = function (e) {
      return i(this, void 0, void 0, function () {
        var t;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return t = this._context.currentState, this._externalCalledWebSocketClose = !1, [4, t.onConnect(this._context, e)];
            case 1:
              return n.sent(), this._registerEventDispatcher(), [2];
          }
        });
      });
    }, e.prototype.reconnect = function () {
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return e = this._context.currentState, this._externalCalledWebSocketClose = !1, [4, e.onReconnect(this._context, {})];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.resetAndReconnect = function () {
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return e = this._context.currentState, this._externalCalledWebSocketClose = !1, [4, e.onReconnect(this._context, {
                resetReconnectCount: !0
              })];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.background = function () {
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return e = this._context.currentState, this._externalCalledWebSocketClose = !0, [4, e.onDisconnect(this._context, {
                autoReconnect: !1
              })];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.disconnect = function (e) {
      return i(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._context.currentState.onDisconnect(this._context, {
                error: e,
                autoReconnect: !0
              })];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.disconnectWebSocket = function () {
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return e = this._context.currentState, this._externalCalledWebSocketClose = !0, [4, e.onDisconnectWebSocket(this._context)];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.logout = function () {
      return i(this, void 0, void 0, function () {
        var e;
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return e = this._context.currentState, this._clearEventDispatcher(), [4, e.onLogout(this._context)];
            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e;
  }(),
  Wi = function (e) {
    function n(t) {
      var n,
        r,
        i,
        o,
        s = t.type,
        a = t.data,
        c = t.ts,
        u = void 0 === c ? Date.now() : c,
        l = e.call(this, {
          type: s,
          data: a,
          ts: u
        }) || this;
      return l.date = new Date(u), l.key = "".concat((n = l.date, r = n.getFullYear(), i = String(n.getMonth() + 1).padStart(2, "0"), o = String(n.getDate()).padStart(2, "0"), "".concat(r).concat(i).concat(o)), "_").concat(s), l;
    }
    return t(n, e), n;
  }(Ce),
  Qi = function (e) {
    function n(t) {
      var n = t.deviceId,
        r = t.statLogs,
        i = e.call(this) || this;
      return i.method = $.POST, i.path = "".concat(fe), i.params = {
        device_id: n,
        log_entries: r.map(function (e) {
          return Ce.payloadify(e);
        })
      }, i;
    }
    return t(n, e), n;
  }(ye),
  Yi = function Yi(e, t) {
    var n, r;
    if (null !== e && null !== t) {
      var i = Object.keys(e),
        o = Object.keys(t),
        u = c([], a(new Set(c(c([], a(i), !1), a(o), !1))), !1),
        l = {};
      try {
        for (var h = s(u), d = h.next(); !d.done; d = h.next()) {
          var _ = d.value,
            f = typeof e[_],
            p = typeof t[_];
          "undefined" === f ? l[_] = t[_] : "undefined" === p ? l[_] = e[_] : f !== p ? l[_] = t[_] : "object" === f && e[_] && t[_] ? l[_] = Yi(e[_], t[_]) : l[_] = t[_];
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          d && !d.done && (r = h.return) && r.call(h);
        } finally {
          if (n) throw n.error;
        }
      }
      return l;
    }
    return t;
  };
!function (e) {
  e[e.PENDING = 0] = "PENDING", e[e.COLLECT_ONLY = 1] = "COLLECT_ONLY", e[e.ENABLED = 2] = "ENABLED", e[e.DISABLED = 3] = "DISABLED";
}(qi || (qi = {}));
var Xi,
  Ji = function (e) {
    function n(t) {
      var n = t.cacheContext,
        r = t.requestQueue,
        i = t.dispatcher,
        o = t.baseLimit,
        s = void 0 === o ? 100 : o,
        a = t.maxLimit,
        c = void 0 === a ? 1e3 : a,
        u = t.minLimit,
        l = void 0 === u ? 10 : u,
        h = e.call(this) || this;
      return h.queue = [], h.enabledState = qi.PENDING, h.isFlushing = !1, h.generation = 1, h.lastFlushedAt = 0, h._collectRequestStat = !0, h._collectFeatureLocalCacheStat = !0, h.deviceId = Z(), h.cacheContext = n, h.requestQueue = r, h.dispatcher = i, h.baseLimit = s, h.limit = s, h.maxLimit = c, h.minLimit = l, h;
    }
    return t(n, e), Object.defineProperty(n.prototype, "isEnabled", {
      get: function get() {
        return this.enabledState === qi.ENABLED;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype._arrangeStat = function () {
      var e = [];
      this._collectRequestStat && e.push.apply(e, c([], a(this.queue.filter(function (e) {
        return e.type === me.API_RESULT || e.type === me.WEBSOCKET_CONNECT;
      })), !1)), this._collectFeatureLocalCacheStat && e.push.apply(e, c([], a(this.queue.filter(function (e) {
        return e.type === me.FEATURE_LOCALCACHE;
      })), !1)), this.queue = e;
    }, n.prototype._save = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return this.enabledState !== qi.ENABLED ? [3, 2] : [4, this.cacheContext.preference.set(this.key, {
                deviceId: this.deviceId,
                statLogs: this.queue.map(function (e) {
                  return Ce.payloadify(e);
                }),
                generation: this.generation++,
                lastFlushedAt: this.lastFlushedAt
              })];
            case 1:
              e.sent(), this.dispatch("save", c([], a(this.queue), !1)), e.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, n.prototype._flush = function () {
      return i(this, void 0, void 0, function () {
        var e, t, n, r, i;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              if (!this.isEnabled) return [3, 10];
              if (this.isFlushing) return [3, 10];
              this.isFlushing = !0, o.label = 1;
            case 1:
              return o.trys.push([1, 5, 9, 10]), this._arrangeStat(), e = this.queue.filter(function (e) {
                if (e instanceof Wi) {
                  var t = new Date(),
                    n = a([e.date.getFullYear(), t.getFullYear()], 2),
                    r = n[0],
                    i = n[1];
                  if (r < i) return !0;
                  if (r === i) {
                    var o = a([e.date.getMonth(), t.getMonth()], 2),
                      s = o[0],
                      c = o[1];
                    if (s < c) return !0;
                    if (s === c) {
                      var u = a([e.date.getDate(), t.getDate()], 2);
                      return u[0] < u[1];
                    }
                  }
                }
                return !1;
              }), t = this.queue.filter(function (e) {
                return !(e instanceof Wi);
              }), (n = c(c([], a(e), !1), a(t), !1).slice(0, Math.min(this.limit, this.maxLimit))).length > 0 ? (r = new Qi({
                deviceId: this.deviceId,
                statLogs: n
              }), [4, this.requestQueue.send(r)]) : [3, 4];
            case 2:
              return o.sent(), this.dispatch("flush", n), this.queue = c(c([], a(e), !1), a(t), !1).slice(n.length), [4, this._save()];
            case 3:
              o.sent(), o.label = 4;
            case 4:
              return this.limit = this.baseLimit, this.lastFlushedAt = Date.now(), [3, 10];
            case 5:
              return (i = o.sent()) instanceof E ? i.code !== u.STAT_LOG_NOT_ALLOWED ? [3, 7] : [4, this.clear()] : [3, 8];
            case 6:
              return o.sent(), this.enabledState = qi.DISABLED, [3, 8];
            case 7:
              i.code === u.STAT_UPLOAD_NOT_ALLOWED && (this.enabledState = qi.COLLECT_ONLY), o.label = 8;
            case 8:
              return this.limit = this.limit + 20, [3, 10];
            case 9:
              return this.isFlushing = !1, [7];
            case 10:
              return [2];
          }
        });
      });
    }, n.prototype.init = function (e) {
      return i(this, void 0, void 0, function () {
        var t,
          n,
          r = this;
        return o(this, function (i) {
          switch (i.label) {
            case 0:
              return this.key = e, [4, this.cacheContext.preference.get(this.key)];
            case 1:
              return (t = i.sent()) ? (this.deviceId = t.deviceId, this.queue = t.statLogs.map(function (e) {
                return new Ce({
                  type: e.stat_type,
                  ts: e.ts,
                  data: e.data
                });
              }), this.generation = t.generation, this.lastFlushedAt = t.lastFlushedAt, Date.now() - this.lastFlushedAt >= 108e5 && this.queue.length >= this.minLimit ? (n = Math.min(Math.floor(18e4 * Math.random()), 100), [4, ci(n)]) : [3, 4]) : [3, 4];
            case 2:
              return i.sent(), [4, this._flush()];
            case 3:
              i.sent(), i.label = 4;
            case 4:
              return this.commandEventContext || (this.commandEventContext = this.dispatcher.on(function (e) {
                if (e instanceof Te) {
                  var t = e.statLog;
                  r.put(t);
                } else if (e instanceof Vi) {
                  var n = e.request,
                    i = e.features,
                    o = e.options;
                  r._collectRequestStat = n, r._collectFeatureLocalCacheStat = null == i ? void 0 : i.localCache, r._arrangeStat(), r._collectRequestStat || r._collectFeatureLocalCacheStat ? r.enabledState = o.ingestion ? qi.ENABLED : qi.COLLECT_ONLY : r.enabledState = qi.DISABLED, r.isEnabled ? r.queue.length >= r.limit && r._flush() : r.clear();
                }
              })), [2];
          }
        });
      });
    }, n.prototype.put = function (e) {
      return i(this, void 0, void 0, function () {
        var t, n;
        return o(this, function (r) {
          switch (r.label) {
            case 0:
              return this.enabledState === qi.DISABLED ? [3, 3] : (e instanceof Wi ? this._collectFeatureLocalCacheStat && (t = a(this.queue.filter(function (t) {
                return t instanceof Wi && t.key === e.key;
              }), 1), (n = t[0]) ? n.data = Yi(n.data, e.data) : this.queue.push(e)) : this._collectRequestStat && this.queue.push(e), [4, this._save()]);
            case 1:
              return r.sent(), this.queue.length >= this.limit ? [4, this._flush()] : [3, 3];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [2];
          }
        });
      });
    }, n.prototype.clear = function () {
      return i(this, void 0, void 0, function () {
        return o(this, function (e) {
          switch (e.label) {
            case 0:
              return this.queue = [], this.generation = 1, [4, this._save()];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, n.prototype.close = function () {
      this.commandEventContext && (this.commandEventContext.close(), this.commandEventContext = void 0);
    }, n;
  }(W);
!function (e) {
  e[e.NONE = 0] = "NONE", e[e.VERBOSE = 1] = "VERBOSE", e[e.DEBUG = 2] = "DEBUG", e[e.INFO = 3] = "INFO", e[e.WARN = 4] = "WARN", e[e.ERROR = 5] = "ERROR";
}(Xi || (Xi = {}));
var $i,
  eo = function () {
    function e() {
      this.level = Xi.WARN;
    }
    return e.prototype.verbose = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      this.level <= Xi.VERBOSE && console.log.apply(console, c(["[verbose]"], a(e), !1));
    }, e.prototype.debug = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      this.level <= Xi.DEBUG && console.log.apply(console, c(["[debug]"], a(e), !1));
    }, e.prototype.info = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      this.level <= Xi.INFO && console.log.apply(console, c(["[info]"], a(e), !1));
    }, e.prototype.warn = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      this.level <= Xi.WARN && console.warn.apply(console, c(["[warn]"], a(e), !1));
    }, e.prototype.error = function () {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      this.level <= Xi.ERROR && console.error.apply(console, c(["[error]"], a(e), !1));
    }, e;
  }(),
  to = {},
  no = function () {
    function e(e, t) {
      var n, r, i, o, s, a, c, u, l, d;
      if (this.connectedAt = 0, this.firstConnectedAt = 0, this.connectionHandlers = new Map(), this.userEventHandlers = new Map(), !to[e]) {
        to[e] = this;
        var _ = null !== (n = t.options) && void 0 !== n ? n : new R(),
          f = this.sdkState = {
            appId: t.appId,
            appVersion: null !== (r = t.appVersion) && void 0 !== r ? r : "",
            appState: "foreground",
            userId: void 0,
            extensions: {},
            api: {
              host: null !== (i = t.apiHost) && void 0 !== i ? i : "https://api-".concat(t.appId, ".sendbird.com")
            },
            websocket: {
              host: null !== (o = t.websocketHost) && void 0 !== o ? o : "wss://ws-".concat(t.appId, ".sendbird.com"),
              pingerDisabled: !!t.noPingpong,
              pingInterval: void 0,
              pongTimeout: void 0,
              connectMaxRetry: 2,
              compression: !0,
              reconnectMaxRetry: -1,
              reconnectRetryStrategy: new ui(),
              responseTimeout: _.websocketResponseTimeout
            },
            sessionTokenRefreshTimeout: _.sessionTokenRefreshTimeout
          };
        this.appInfo = void 0, this.subscribedUnreadMessageCount = {
          all: 0,
          customTypes: {},
          ts: 0
        };
        var p = this.logger = new eo();
        this.logger.level = null !== (s = t.logLevel) && void 0 !== s ? s : Xi.WARN, this.connectedAt = 0, this.firstConnectedAt = 0, this.connectionHandlers = new Map(), this.userEventHandlers = new Map();
        var g = this.cacheContext = new L({
          encryption: t.encryption,
          store: t.store,
          localCacheEnabled: null !== (a = t.localCacheEnabled) && void 0 !== a && a,
          localCacheConfig: null !== (c = t.localCacheConfig) && void 0 !== c ? c : new B()
        });
        this.debugMode = null !== (u = t.debugMode) && void 0 !== u && u, this.maxSuperGroupChannelUnreadCount = h.DEFAULT_MAX_UNREAD_COUNT_OF_SUPER_GROUP_CHANNEL, this.useMemberInfoInMessage = _.useMemberInfoInMessage, this.typingIndicatorInvalidateTime = _.typingIndicatorInvalidateTime, this.typingIndicatorThrottle = _.typingIndicatorThrottle, this.concurrentCallLimit = void 0, this.backOffDelay = void 0;
        var v = this.dispatcher = new Q(),
          E = new V();
        this.requestQueue = new ei(e, {
          auth: E,
          sdkState: f,
          dispatcher: v,
          logger: p,
          useFetchCompat: t.useFetchCompat
        }), this.sessionManager = new fi({
          auth: E,
          cacheContext: g,
          sdkState: f,
          dispatcher: v,
          requestQueue: this.requestQueue,
          logger: p
        }), this.connectionManager = new Hi(e, {
          sdkState: f,
          cacheContext: this.cacheContext,
          connectionHandlers: this.connectionHandlers,
          dispatcher: v,
          sessionManager: this.sessionManager,
          websocketClient: this.requestQueue.commandRouter.websocketClient,
          disableWebSocketCloseEventHandling: null !== (l = t.disableWebSocketCloseEventHandling) && void 0 !== l && l,
          logger: p
        }), this.statLogCollector = new Ji({
          cacheContext: this.cacheContext,
          requestQueue: this.requestQueue,
          dispatcher: v
        }), this.appStateToggleEnabled = null === (d = t.appStateToggleEnabled) || void 0 === d || d;
      }
      return to[e];
    }
    return e.of = function (e) {
      if (to[e]) return to[e];
      throw E.lostInstance;
    }, e.clear = function (e) {
      to[e] && delete to[e];
    }, e.prototype.hasExtension = function (e) {
      return this.sdkState.extensions && this.sdkState.extensions[e];
    }, e;
  }(),
  ro = function () {
    function e() {}
    return e.prototype.init = function (e, t) {
      var n = t.sdkState,
        r = t.dispatcher,
        i = t.sessionManager,
        o = t.requestQueue,
        s = t.logger;
      t.onlineDetector;
      var a = t.cacheContext;
      this._iid = e, this._cacheContext = a, this._sdkState = n, this._dispatcher = r, this._sessionManager = i, this._requestQueue = o, this._logger = s;
    }, e;
  }();
!function (e) {
  e.OPEN = "open", e.CLOSED = "closed";
}($i || ($i = {}));
var io,
  oo = "removed",
  so = function so(e) {
    switch (e) {
      case "open":
        return $i.OPEN;
      case "closed":
        return $i.CLOSED;
      default:
        return null;
    }
  },
  ao = function ao(e) {
    return !e || !!e.text && w("string", e.text);
  },
  co = function co(e) {
    return T("string", e) && e.every(function (e) {
      return "" !== e.trim();
    });
  },
  uo = function (e) {
    function r(t, n) {
      var r,
        i,
        o,
        s,
        a,
        c,
        u,
        l = this;
      return (l = e.call(this, t) || this).pollId = 0, l.id = 0, l.text = null, l.voteCount = 0, l.createdBy = null, l.createdAt = 0, l.updatedAt = 0, l._lastVotedAt = 0, l.pollId = null !== (r = n.poll_id) && void 0 !== r ? r : 0, l.id = null !== (i = n.id) && void 0 !== i ? i : 0, l.text = null !== (o = n.text) && void 0 !== o ? o : null, l.voteCount = null !== (s = n.vote_count) && void 0 !== s ? s : 0, l.createdBy = null !== (a = n.created_by) && void 0 !== a ? a : null, l.createdAt = null !== (c = n.created_at) && void 0 !== c ? c : 0, l.updatedAt = null !== (u = n.updated_at) && void 0 !== u ? u : 0, l;
    }
    return t(r, e), r.payloadify = function (t) {
      return X(J(_n2(_n2({}, e.payloadify.call(this, t)), {
        vote_count: t.voteCount,
        poll_id: t.pollId,
        text: t.text,
        created_at: t.createdAt,
        id: t.id,
        created_by: t.createdBy,
        updated_at: t.updatedAt
      })));
    }, r;
  }(Ni),
  lo = function (e) {
    function r(t, n) {
      var r,
        i,
        o,
        s,
        a,
        c,
        u,
        l,
        h,
        d,
        _,
        f,
        p,
        g = this;
      return (g = e.call(this, t) || this).id = 0, g.title = null, g.createdAt = 0, g.updatedAt = 0, g.closeAt = -1, g.status = $i.CLOSED, g.messageId = 0, g.data = null, g.voterCount = -1, g.options = [], g.createdBy = null, g.allowUserSuggestion = !1, g.allowMultipleVotes = !1, g.votedPollOptionIds = [], g.id = null !== (r = n.id) && void 0 !== r ? r : 0, g.title = null !== (i = n.title) && void 0 !== i ? i : null, g.createdAt = null !== (o = n.created_at) && void 0 !== o ? o : 0, g.updatedAt = null !== (s = n.updated_at) && void 0 !== s ? s : 0, g.closeAt = null !== (a = n.close_at) && void 0 !== a ? a : -1, g.status = null !== (c = so(n.status)) && void 0 !== c ? c : $i.CLOSED, g.messageId = null !== (u = n.message_id) && void 0 !== u ? u : 0, g.data = null !== (l = n.data) && void 0 !== l ? l : null, g.voterCount = null !== (h = n.voter_count) && void 0 !== h ? h : -1, g.options = n.options ? n.options.map(function (e) {
        return new uo(g._iid, e);
      }) : [], g.createdBy = null !== (d = n.created_by) && void 0 !== d ? d : null, g.allowUserSuggestion = null !== (_ = n.allow_user_suggestion) && void 0 !== _ && _, g.allowMultipleVotes = null !== (f = n.allow_multiple_votes) && void 0 !== f && f, g.votedPollOptionIds = null !== (p = n.voted_option_ids) && void 0 !== p ? p : [], g;
    }
    return t(r, e), r.prototype._applyPollUpdatePayload = function (e) {
      var t,
        n,
        r,
        i,
        o,
        s,
        a,
        c,
        u = this;
      this.title = null !== (t = e.title) && void 0 !== t ? t : this.title, this.updatedAt = null !== (n = e.updated_at) && void 0 !== n ? n : this.updatedAt, this.closeAt = null !== (r = e.close_at) && void 0 !== r ? r : this.closeAt, this.status = null !== (i = so(e.status)) && void 0 !== i ? i : this.status, this.data = null !== (o = e.data) && void 0 !== o ? o : this.data, this.voterCount = null !== (s = e.voter_count) && void 0 !== s ? s : this.voterCount, e.options && (this.options = e.options.map(function (e) {
        return new uo(u._iid, e);
      }), this.votedPollOptionIds = e.options.filter(function (e) {
        return e.vote_count > 0;
      }).map(function (e) {
        return e.id;
      })), this.allowUserSuggestion = null !== (a = e.allow_user_suggestion) && void 0 !== a ? a : this.allowUserSuggestion, this.allowMultipleVotes = null !== (c = e.allow_multiple_votes) && void 0 !== c ? c : this.allowMultipleVotes;
    }, r.payloadify = function (t) {
      return X(J(_n2(_n2({}, e.payloadify.call(this, t)), {
        id: t.id,
        title: t.title,
        created_at: t.createdAt,
        updated_at: t.updatedAt,
        close_at: t.closeAt,
        status: t.status,
        message_id: t.messageId,
        data: t.data,
        voter_count: t.voterCount,
        options: t.options.map(function (e) {
          return uo.payloadify(e);
        }),
        created_by: t.createdBy,
        allow_user_suggestion: t.allowUserSuggestion,
        allow_multiple_votes: t.allowMultipleVotes,
        voted_option_ids: t.votedPollOptionIds
      })));
    }, r.prototype.applyPollUpdateEvent = function (e) {
      var t = e._payload.poll;
      return !(!t || this.id !== t.id || t.updated_at < this.updatedAt) && (this._applyPollUpdatePayload(t), !0);
    }, r.prototype.applyPollVoteEvent = function (e) {
      if (this.id !== e.pollId) return !1;
      var t = this.options,
        n = t.map(function (e) {
          return e.id;
        }),
        r = e._payload,
        i = Math.floor(r.ts / 1e3);
      return r.updated_vote_counts.forEach(function (e) {
        var r = n.indexOf(e.option_id);
        if (r > -1) {
          var o = t[r];
          i >= o._lastVotedAt && (o.voteCount = e.vote_count, o._lastVotedAt = i);
        }
      }), r.req_id && r.voted_option_ids && (this.votedPollOptionIds = r.voted_option_ids), !0;
    }, r.prototype.serialize = function () {
      return Ui(this);
    }, r;
  }(Ni);
!function (e) {
  e.UNKNOWN = "UNKNOWN", e.EVENT_MESSAGE_SENT_SUCCESS = "EVENT_MESSAGE_SENT_SUCCESS", e.EVENT_MESSAGE_SENT_FAILED = "EVENT_MESSAGE_SENT_FAILED", e.EVENT_MESSAGE_SENT_PENDING = "EVENT_MESSAGE_SENT_PENDING", e.EVENT_MESSAGE_RECEIVED = "EVENT_MESSAGE_RECEIVED", e.EVENT_MESSAGE_UPDATED = "EVENT_MESSAGE_UPDATED", e.EVENT_MESSAGE_DELETED = "EVENT_MESSAGE_DELETED", e.EVENT_MESSAGE_READ = "EVENT_MESSAGE_READ", e.EVENT_MESSAGE_DELIVERED = "EVENT_MESSAGE_DELIVERED", e.EVENT_MESSAGE_REACTION_UPDATED = "EVENT_MESSAGE_REACTION_UPDATED", e.EVENT_MESSAGE_THREADINFO_UPDATED = "EVENT_MESSAGE_THREADINFO_UPDATED", e.EVENT_MESSAGE_OFFSET_UPDATED = "EVENT_MESSAGE_OFFSET_UPDATED", e.REQUEST_MESSAGE = "REQUEST_MESSAGE", e.EVENT_POLL_UPDATED = "EVENT_POLL_UPDATED", e.EVENT_POLL_VOTED = "EVENT_POLL_VOTED", e.SYNC_POLL_CHANGELOGS = "SYNC_POLL_CHANGELOGS", e.REQUEST_RESEND_MESSAGE = "REQUEST_RESEND_MESSAGE", e.REQUEST_THREADED_MESSAGE = "REQUEST_THREADED_MESSAGE", e.REQUEST_MESSAGE_CHANGELOGS = "REQUEST_MESSAGE_CHANGELOGS", e.SYNC_MESSAGE_FILL = "SYNC_MESSAGE_FILL", e.SYNC_MESSAGE_BACKGROUND = "SYNC_MESSAGE_BACKGROUND", e.SYNC_MESSAGE_CHANGELOGS = "SYNC_MESSAGE_CHANGELOGS", e.LOCAL_MESSAGE_PENDING_CREATED = "LOCAL_MESSAGE_PENDING_CREATED", e.LOCAL_MESSAGE_FAILED = "LOCAL_MESSAGE_FAILED", e.LOCAL_MESSAGE_CANCELED = "LOCAL_MESSAGE_CANCELED", e.LOCAL_MESSAGE_RESEND_STARTED = "LOCAL_MESSAGE_RESEND_STARTED";
}(io || (io = {}));
var ho = function ho(e) {
    return e.startsWith("EVENT_") || e === io.SYNC_MESSAGE_FILL || e === io.SYNC_MESSAGE_CHANGELOGS || e === io.SYNC_POLL_CHANGELOGS;
  },
  _o = function (e) {
    function n(t) {
      var n = t.messages,
        r = t.source,
        i = t.isWebSocketEventComing,
        o = void 0 !== i && i,
        s = e.call(this) || this;
      return s.messages = n, s.source = r, s.isWebSocketEventComing = o, s;
    }
    return t(n, e), n;
  }(Y),
  fo = function (e) {
    function n(t) {
      var n = t.messageIds,
        r = t.source,
        i = t.isWebSocketEventComing,
        o = void 0 !== i && i,
        s = e.call(this) || this;
      return s.messageIds = n, s.source = r, s.isWebSocketEventComing = o, s;
    }
    return t(n, e), n;
  }(Y),
  po = function (e) {
    function n(t) {
      var n = t.reqId,
        r = t.source,
        i = e.call(this) || this;
      return i.reqId = n, i.source = r, i;
    }
    return t(n, e), n;
  }(Y),
  go = function (e) {
    function n(t) {
      var n = t.polls,
        r = t.source,
        i = e.call(this) || this;
      return i.polls = n, i.source = r, i;
    }
    return t(n, e), n;
  }(Y),
  vo = function (e) {
    function n(t) {
      var n = t.event,
        r = t.source,
        i = e.call(this) || this;
      return i.event = n, i.source = r, i;
    }
    return t(n, e), n;
  }(Y),
  Eo = function (e) {
    function n(t) {
      var n = t.event,
        r = t.source,
        i = e.call(this) || this;
      return i.event = n, i.source = r, i;
    }
    return t(n, e), n;
  }(Y),
  bo = function () {
    function e(e, t) {
      var n;
      this.limit = 20, this._isLoading = !1, this._hasNext = !0, this._token = "", this._iid = e, this.limit = null !== (n = t.limit) && void 0 !== n ? n : 20;
    }
    return Object.defineProperty(e.prototype, "hasNext", {
      get: function get() {
        return this._hasNext;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isLoading", {
      get: function get() {
        return this._isLoading;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._validate = function () {
      return w("number", this.limit) && this.limit > 0;
    }, e;
  }(),
  mo = function (e) {
    function n(t, n, r, i) {
      var o = e.call(this, t, i) || this;
      return o.channelUrl = n, o.channelType = r, o;
    }
    return t(n, e), n.prototype._validate = function () {
      return e.prototype._validate.call(this) && w("string", this.channelUrl) && S(x, this.channelType);
    }, n;
  }(bo);
export { ne as $, $ as A, bo as B, Vr as C, Yr as D, W as E, ji as F, Ki as G, ke as H, d as I, di as J, s as K, B as L, S as M, _ as N, p as O, f as P, x as Q, K as R, E as S, Xi as T, Gi as U, no as V, Ne as W, M as X, Ti as Y, Pi as Z, t as _, w as a, Ni as a0, y as a1, P as a2, Ui as a3, F as a4, j as a5, C as a6, U as a7, lo as a8, G as a9, ce as aA, Ee as aB, z as aC, v as aD, Eo as aE, N as aF, vo as aG, po as aH, ie as aI, de as aJ, oo as aK, ho as aL, Wi as aM, me as aN, li as aO, so as aP, se as aQ, oe as aR, Qr as aa, pe as ab, ve as ac, u as ad, ci as ae, Xr as af, q as ag, re as ah, io as ai, _o as aj, fo as ak, ae as al, mo as am, ro as an, uo as ao, $i as ap, Y as aq, O as ar, I as as, r as at, he as au, co as av, ao as aw, go as ax, Oi as ay, ge as az, i as b, o as c, te as d, X as e, ye as f, _n2 as g, we as h, A as i, le as j, ue as k, _e as l, T as m, Re as n, R as o, Z as p, Oe as q, c as r, a as s, Fi as t, J as u, l as v, zi as w, $r as x, Hr as y, hi as z };